const vehicleMakesModels = [
  {
    "make": "Alfa Romeo",
    "models": [
      {
        "name": "Giulia",
        "types": [
          {
            "name": "2.0 200 Q5 2017-",
            "engineCode": "55273835.0"
          },
          {
            "name": "2.0 280 Q5 2017-",
            "engineCode": "55273835.0"
          },
          {
            "name": "2.2D 181 2016-",
            "engineCode": "55266388.0"
          }
        ]
      },
      {
        "name": "Stelvio",
        "types": [
          {
            "name": "2.0 Q4 201 2017-",
            "engineCode": "55273835.0"
          },
          {
            "name": "2.0 Q4 281 2017-",
            "engineCode": "55273835.0"
          },
          {
            "name": "2.2D Q4 211 2017-",
            "engineCode": "55271838.0"
          }
        ]
      }
    ]
  },
  {
    "make": "Audi",
    "models": [
      {
        "name": "A3",
        "types": [
          {
            "name": "1.0 TFSI 116 2016-",
            "engineCode": "CHZD"
          },
          {
            "name": "1.2 TFSI 106 2013-",
            "engineCode": "CJZ"
          },
          {
            "name": "1.2 TFSI 111 2015-",
            "engineCode": "CYVB"
          },
          {
            "name": "1.4 TFSI 110 G-tron 2018-",
            "engineCode": "CPWA"
          },
          {
            "name": "1.4 TFSI 126 2013-",
            "engineCode": "CXS"
          },
          {
            "name": "1.4 TFSI 126 2014-",
            "engineCode": "CZC"
          },
          {
            "name": "1.4 TFSI 151 2014-",
            "engineCode": "CZE"
          },
          {
            "name": "1.4 TFSI 2012-",
            "engineCode": "CMB"
          },
          {
            "name": "1.4 TFSI 2013-",
            "engineCode": "CPT"
          }
        ]
      },
      {
        "name": "A4",
        "types": [
          {
            "name": "2.0 TFSI 170 G-TRON 2018-",
            "engineCode": "CVLA"
          },
          {
            "name": "2.0 TFSI 191 2016-",
            "engineCode": "CVKB"
          },
          {
            "name": "2.0 TFSI 191 2018-",
            "engineCode": "DEMA"
          },
          {
            "name": "2.0 TFSI 252 (Automat) 2016-",
            "engineCode": "CYRB"
          },
          {
            "name": "2.0 TFSI 252 Quattro (Automat) 2018-",
            "engineCode": "DDWA"
          },
          {
            "name": "35 TFSI 150 MHEV 2021-",
            "engineCode": "DMS"
          },
          {
            "name": "35 TFSI 151 2019-",
            "engineCode": "DLV"
          },
          {
            "name": "35 TFSI 170 g-tron 2021-",
            "engineCode": "DRX"
          },
          {
            "name": "40 TDI 191 2019-",
            "engineCode": "DETA"
          },
          {
            "name": "40 TDI 204 Quattro 2020-",
            "engineCode": "DTPA"
          },
          {
            "name": "40 TDI 205 2021-",
            "engineCode": "DTP"
          },
          {
            "name": "40 TFSI 191 2019-",
            "engineCode": "DLV"
          },
          {
            "name": "40 TFSI 204 MHEV 2021-",
            "engineCode": "DMS"
          },
          {
            "name": "40 TFSI 204 Q MHEV 2021-",
            "engineCode": "DMS"
          },
          {
            "name": "45 TFSI 245 MHEV 2019-",
            "engineCode": "DKN"
          },
          {
            "name": "ALLROAD 2.0 TFSI 225 Quattro [Automat] 2013-",
            "engineCode": "CNCD"
          },
          {
            "name": "ALLROAD 2.0 TFSI 252 Quattro (Automat) 2016-",
            "engineCode": "CYRB"
          },
          {
            "name": "ALLROAD 2.0 TFSI 252 Quattro (Automat) 2018-",
            "engineCode": "DDWA"
          },
          {
            "name": "ALLROAD 3.0 TDI 219 2017-",
            "engineCode": "CSWB"
          },
          {
            "name": "ALLROAD 3.0 TDI 273 2017-",
            "engineCode": "CRT"
          },
          {
            "name": "ALLROAD 40 TDI 204 Quattro 2021-",
            "engineCode": "DTPA"
          },
          {
            "name": "ALLROAD 45 TFSI 245 Q MHEV 2019-",
            "engineCode": "DKN"
          }
        ]
      },
      {
        "name": "A5",
        "types": [
          {
            "name": "2.0 TDI 151 2015-",
            "engineCode": "CSU"
          },
          {
            "name": "2.0 TDI 191 2015-",
            "engineCode": "CNH"
          },
          {
            "name": "2.0 TDI 191 2017-",
            "engineCode": "DETA"
          },
          {
            "name": "2.0 TDI Coupé 2012-",
            "engineCode": "CGL"
          },
          {
            "name": "2.0 TDI Sportback 2012-",
            "engineCode": "CGL"
          },
          {
            "name": "2.0 TFSI 170 G-tron 2018-",
            "engineCode": "CVLA"
          },
          {
            "name": "2.0 TFSI 190 Coupé 2017-",
            "engineCode": "CVKB"
          },
          {
            "name": "2.0 TFSI 191 2018-",
            "engineCode": "DEMA"
          },
          {
            "name": "2.0 TFSI 225 SB/Cab/Coupé (Automat) 2014-",
            "engineCode": "CNCD"
          },
          {
            "name": "2.0 TFSI 230 Quattro SB 2015-",
            "engineCode": "CNCE"
          },
          {
            "name": "2.0 TFSI 252 Quattro Coupé (Automat) 2018-",
            "engineCode": "DDWA"
          },
          {
            "name": "2.0 TFSI 252 Quattro SB (Automat) 2017-",
            "engineCode": "CYRB"
          },
          {
            "name": "2.0 TFSI 252 Quattro SB (Automat) 2018-",
            "engineCode": "DDWA"
          },
          {
            "name": "3.0 TDI 2012-",
            "engineCode": "CKV"
          },
          {
            "name": "3.0 TDI 218 (Without Webasto) 2016-",
            "engineCode": "CSW"
          },
          {
            "name": "3.0 TDI V7 2012-",
            "engineCode": "CDU"
          },
          {
            "name": "35 TDI 165 2019-",
            "engineCode": "DTPB"
          },
          {
            "name": "40 TDI 205 2021-",
            "engineCode": "DTPA"
          },
          {
            "name": "40 TFSI 170 g-tron 2021-",
            "engineCode": "DRX"
          },
          {
            "name": "40 TFSI 191 2019-",
            "engineCode": "DLV"
          },
          {
            "name": "40 TFSI 204 MHEV 2022-",
            "engineCode": "DMS"
          },
          {
            "name": "45 TFSI 245 Q MHEV 2019-",
            "engineCode": "DKN"
          },
          {
            "name": "45 TFSI 265 Q MHEV 2019-",
            "engineCode": "DMT"
          }
        ]
      },
      {
        "name": "A6",
        "types": [
          {
            "name": "2.0 TDI 151 2015-",
            "engineCode": "CSU"
          },
          {
            "name": "2.0 TDI 191 2017-",
            "engineCode": "DDD"
          },
          {
            "name": "2.0 TDI 2013-",
            "engineCode": "CNH"
          },
          {
            "name": "2.0 TFSI 252 Automat 2016-",
            "engineCode": "CYPA"
          },
          {
            "name": "3.0 TDI 219 2015-",
            "engineCode": "CRTE"
          },
          {
            "name": "3.0 TDI 273 2015-",
            "engineCode": "CRTD"
          },
          {
            "name": "3.0 TDI 287 2019-",
            "engineCode": "DDVB"
          },
          {
            "name": "3.0 TDI 320 Quattro 2015-",
            "engineCode": "CVUA"
          },
          {
            "name": "3.0 TDI 326 Quattro 2015-",
            "engineCode": "CVUB"
          },
          {
            "name": "3.0 TFSI 334 2015-",
            "engineCode": "CREC"
          },
          {
            "name": "40 TDI 204 Q 2019-",
            "engineCode": "DFBA"
          },
          {
            "name": "40 TDI 204 Q 2021-",
            "engineCode": "DTP"
          },
          {
            "name": "40 TDI 205 2019-",
            "engineCode": "DFB"
          },
          {
            "name": "40 TDI 205 2021-",
            "engineCode": "DTP"
          },
          {
            "name": "40 TFSI 204 Q MHEV 2021-",
            "engineCode": "DMS"
          },
          {
            "name": "45 TFSI 245 Q MHEV 2019-",
            "engineCode": "DKN"
          },
          {
            "name": "45 TFSI 246 2019-",
            "engineCode": "DKNA"
          },
          {
            "name": "50 TFSI e Quattro 2021-",
            "engineCode": "DRYA"
          },
          {
            "name": "55 TFSI e Quattro 2020-",
            "engineCode": "DLGA"
          },
          {
            "name": "55 TFSI e Quattro 2021-",
            "engineCode": "DRYA"
          },
          {
            "name": "ALLROAD 3.0 TDI 219 2015-",
            "engineCode": "CRT"
          },
          {
            "name": "ALLROAD 3.0 TDI 219 2016-",
            "engineCode": "CZV"
          },
          {
            "name": "ALLROAD 45 TDI 231 MHEV 2019-",
            "engineCode": "DDVE"
          }
        ]
      },
      {
        "name": "A7",
        "types": [
          {
            "name": "2.0 TFSI 252 Automat 2016-",
            "engineCode": "CYPA"
          },
          {
            "name": "3.0 TDI 2012-",
            "engineCode": "CGQ"
          },
          {
            "name": "3.0 TDI 219 2015-",
            "engineCode": "CRT"
          },
          {
            "name": "3.0 TDI 219 2016-",
            "engineCode": "CZV"
          },
          {
            "name": "3.0 TDI 273 2015-",
            "engineCode": "CRTD"
          },
          {
            "name": "3.0 TDI 286 Quattro 2019-",
            "engineCode": "DDVB"
          },
          {
            "name": "3.0 TDI 321 2015-",
            "engineCode": "CVUA"
          },
          {
            "name": "3.0 TDI 327 2015-",
            "engineCode": "CVUB"
          },
          {
            "name": "3.0 TFSI 334 2015-",
            "engineCode": "CREC"
          },
          {
            "name": "3.0 TFSI 340 Mild Hybrid 2018-",
            "engineCode": "DLZA"
          },
          {
            "name": "35 TDI 165 2019-",
            "engineCode": "DTPB"
          },
          {
            "name": "40 TDI 204 Q 2019-",
            "engineCode": "DTPA"
          }
        ]
      },
      {
        "name": "A8",
        "types": [
          {
            "name": "3.0 TDI 262 V6 Quattro 2016-",
            "engineCode": "CTBD"
          }
        ]
      },
      {
        "name": "Q5",
        "types": [
          {
            "name": "2.0 TDI 151 2014-",
            "engineCode": "CSU"
          },
          {
            "name": "2.0 TDI 191 2014-",
            "engineCode": "CNH"
          },
          {
            "name": "2.0 TDI 191 2017-",
            "engineCode": "DET"
          },
          {
            "name": "2.0 TDI 2012-",
            "engineCode": "CJC"
          },
          {
            "name": "2.0 TFSI 252 Q (Automat) 2018-",
            "engineCode": "DAXB"
          },
          {
            "name": "2.0 TFSI Hybrid 2012-",
            "engineCode": "CHJ"
          },
          {
            "name": "2.0 TFSI Quattro (Manuell) 2013-",
            "engineCode": "CNC"
          },
          {
            "name": "35 TDI 164 2019-",
            "engineCode": "DETB"
          },
          {
            "name": "40 TDI 191 2019-",
            "engineCode": "DETA"
          },
          {
            "name": "40 TDI 204 Q 2020-",
            "engineCode": "DFBA"
          },
          {
            "name": "40 TDI 204 Q 2021-",
            "engineCode": "DTPA"
          },
          {
            "name": "45 TFSI 245 (Automat) 2019-",
            "engineCode": "DNTA"
          },
          {
            "name": "55 TFSI e quattro 2020-",
            "engineCode": "DLGA"
          },
          {
            "name": "55 TFSI e quattro 2021-",
            "engineCode": "DRYA"
          }
        ]
      },
      {
        "name": "Q8",
        "types": [
          {
            "name": "45 TDI 231 Quattro 2020-",
            "engineCode": "DHXC"
          },
          {
            "name": "50 TDI Quattro 2020-",
            "engineCode": "DHXA"
          }
        ]
      },
      {
        "name": "RS",
        "types": [
          {
            "name": "Q3 2.5 TFSI 341 2015-",
            "engineCode": "CZGA"
          }
        ]
      },
      {
        "name": "RS3",
        "types": [
          {
            "name": "2.5 TFSI 341 2012-",
            "engineCode": "CEPA"
          },
          {
            "name": "2.5 TFSI 368 2016-",
            "engineCode": "CZGB"
          },
          {
            "name": "2.5 TFSI 400 Quattro 2021-",
            "engineCode": "DNWC"
          }
        ]
      },
      {
        "name": "RS4",
        "types": [
          {
            "name": "2.9 TFSI 450 Quattro 2018-",
            "engineCode": "DECA"
          }
        ]
      },
      {
        "name": "RS6",
        "types": [
          {
            "name": "4.0 TFSI 2013-",
            "engineCode": "CRD"
          },
          {
            "name": "4.0 TFSI 2015-",
            "engineCode": "CWUB"
          },
          {
            "name": "4.0 TFSI Performance 606 2015-",
            "engineCode": "CWUA"
          },
          {
            "name": "4.0 TFSI Performance 606 2016-",
            "engineCode": "CWUC"
          }
        ]
      },
      {
        "name": "S1",
        "types": [
          {
            "name": "2.0 TFSI 2014-",
            "engineCode": "CWZ"
          }
        ]
      },
      {
        "name": "S3",
        "types": [
          {
            "name": "2.0 TFSI 2013-",
            "engineCode": "CJX"
          },
          {
            "name": "2.0 TFSI 310 Quattro 2021-",
            "engineCode": "DNF"
          }
        ]
      },
      {
        "name": "S5",
        "types": [
          {
            "name": "3.0 TFSI 353 Quattro 2017-",
            "engineCode": "CWGD"
          }
        ]
      },
      {
        "name": "S7",
        "types": [
          {
            "name": "4.0 TFSi 2012-",
            "engineCode": "CEU"
          }
        ]
      },
      {
        "name": "SQ5",
        "types": [
          {
            "name": "3.0 TDI 2013-",
            "engineCode": "CGQ"
          }
        ]
      },
      {
        "name": "SQ7",
        "types": [
          {
            "name": "4.0 TDI V9 2017-",
            "engineCode": "CZAC"
          }
        ]
      }
    ]
  },
  {
    "make": "BMW",
    "models": [
      {
        "name": "114",
        "types": [
          {
            "name": "d [F20] [1T91] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d [F21] [1N51] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d [F21] [2S11] 2015-",
            "engineCode": "N47"
          },
          {
            "name": "i [F20] [1R11] 2012-",
            "engineCode": "N13"
          },
          {
            "name": "i [F21] [1P11] 2012-",
            "engineCode": "N13"
          }
        ]
      },
      {
        "name": "116",
        "types": [
          {
            "name": "d [F20] [1C71] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d [F21] [1N11] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d ed [F20] [1C91] 2012-",
            "engineCode": "N47"
          },
          {
            "name": "d ed [F21] [1N31] 2012-2013",
            "engineCode": "N47"
          },
          {
            "name": "d ed [F21] [1N31] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "i [F20] [1A11] 2012-",
            "engineCode": "N13"
          },
          {
            "name": "i [F20] [2R11] 2015-",
            "engineCode": "B38"
          },
          {
            "name": "i [F21] [1D11] 2012-",
            "engineCode": "N13"
          },
          {
            "name": "i [F21] [2P71] 2015-",
            "engineCode": "B38"
          }
        ]
      },
      {
        "name": "118",
        "types": [
          {
            "name": "d [F20] [1C11] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d [F21] [1E11] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d [F21] [1W51] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d [F40] [7M91] Manuell 2020-",
            "engineCode": "B47"
          },
          {
            "name": "d xDrive [F20] [1T51] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d xDrive [F20] [1U51] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d xDrive [F21] [1X51] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d xDrive [F21] [1Y51] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "i [F20] [1A31] 2012-",
            "engineCode": "N13"
          },
          {
            "name": "i [F20] [1R51] 2015-",
            "engineCode": "B38"
          },
          {
            "name": "i [F20] [2R31] 2015-",
            "engineCode": "N13"
          },
          {
            "name": "i [F21] [1D31] 2013-",
            "engineCode": "N13"
          },
          {
            "name": "i [F21] [1P51] 2015-",
            "engineCode": "B38"
          },
          {
            "name": "i [F21] [2P91] 2015-",
            "engineCode": "N13"
          }
        ]
      },
      {
        "name": "120",
        "types": [
          {
            "name": "d [F20] [1C31] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d [F20] [1S71] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d [F21] [1E31] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d [F21] [1W71] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d xDrive [F20] [1B51] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d xDrive [F20] [1T11] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d xDrive [F21] [1E51] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d xDrive [F21] [1X11] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d xDrive [F40] [7N51] Automat 2020-",
            "engineCode": "B47"
          },
          {
            "name": "i [F20] [1S11] 2016-",
            "engineCode": "B48"
          },
          {
            "name": "i [F20] [1U71] 2015-",
            "engineCode": "N13"
          },
          {
            "name": "i [F21] [1W11] 2016-",
            "engineCode": "B48"
          },
          {
            "name": "i [F21] [1Y11] 2015-",
            "engineCode": "N13"
          }
        ]
      },
      {
        "name": "125",
        "types": [
          {
            "name": "d [F20] [1C51] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d [F21] [1E71] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "i [F20] [1A51] 2012-",
            "engineCode": "N20"
          },
          {
            "name": "i [F20] [1S31] 2016-",
            "engineCode": "B48"
          },
          {
            "name": "i [F20] [1U91] 2015-",
            "engineCode": "N20"
          },
          {
            "name": "i [F21] [1D51] 2012-",
            "engineCode": "N20"
          },
          {
            "name": "i [F21] [1W31] 2016-",
            "engineCode": "B48"
          },
          {
            "name": "i [F21] [1Y31] 2015-",
            "engineCode": "N20"
          }
        ]
      },
      {
        "name": "128",
        "types": [
          {
            "name": "ti [F40] [7L51] 2021-",
            "engineCode": "B48E"
          }
        ]
      },
      {
        "name": "214",
        "types": [
          {
            "name": "d Active Tourer [F45] [2B11] Automat 2015-",
            "engineCode": "B37"
          },
          {
            "name": "d Active Tourer [F45] [2B11] Manuell 2015-",
            "engineCode": "B37"
          },
          {
            "name": "d Gran Tourer [F46] [2E11] Automat 2015-",
            "engineCode": "B37"
          },
          {
            "name": "d Gran Tourer [F46] [2E11] Manuell 2015-",
            "engineCode": "B37"
          }
        ]
      },
      {
        "name": "216",
        "types": [
          {
            "name": "d Active Tourer [F45] [2B31] Automat 2015-",
            "engineCode": "B37"
          },
          {
            "name": "d Active Tourer [F45] [2B31] Manuell 2015-",
            "engineCode": "B37"
          },
          {
            "name": "d Active Tourer [F45] [6T51] Manuell 2018-",
            "engineCode": "B37"
          },
          {
            "name": "d Gran Tourer [F46] [2E31] Automat 2015-",
            "engineCode": "B37"
          },
          {
            "name": "d Gran Tourer [F46] [2E31] Manuell 2015-",
            "engineCode": "B37"
          },
          {
            "name": "d Gran Tourer [F46] [6W51] Manuell 2018-",
            "engineCode": "B37"
          }
        ]
      },
      {
        "name": "218",
        "types": [
          {
            "name": "d Active Tourer [F45] [2C11] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d Active Tourer [F45] [6T91] Manuell 2018-",
            "engineCode": "B47"
          },
          {
            "name": "d Gran Tourer [F46] [2E51] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d Gran Tourer [F46] [6W91] Automat 2018-",
            "engineCode": "B47"
          },
          {
            "name": "d Gran Tourer [F46] [6W91] Manuell 2018-",
            "engineCode": "B47"
          },
          {
            "name": "d xDrive Active Tourer [F45] [2B91] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d xDrive Active Tourer [F45] [6U11] Automat 2018-",
            "engineCode": "B47"
          },
          {
            "name": "d xDrive Active Tourer [F45] [6U11] Manuell 2018-",
            "engineCode": "B47"
          },
          {
            "name": "d xDrive Gran Tourer [F46] [2E91] 2016-",
            "engineCode": "B47"
          },
          {
            "name": "d xDrive Gran Tourer [F46] [6X11] Automat 2018-",
            "engineCode": "B47"
          },
          {
            "name": "d xDrive Gran Tourer [F46] [6X11] Manuell 2018-",
            "engineCode": "B47"
          }
        ]
      },
      {
        "name": "220",
        "types": [
          {
            "name": "d [F22] [1H11] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d Active Tourer [F45] [2C31] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d Active Tourer [F45] [6U31] Automat 2018-",
            "engineCode": "B47"
          },
          {
            "name": "d Active Tourer [F45] [6U31] Manuell 2018-",
            "engineCode": "B47"
          },
          {
            "name": "d Active Tourer xDrive [F45] [6U51] 2018-",
            "engineCode": "B47"
          },
          {
            "name": "d Active Tourer xDrive [F45] [6U51] Manuell 2018-",
            "engineCode": "B47"
          },
          {
            "name": "d Gran Tourer [F46] [2E71] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d Gran Tourer [F46] [6X31] Automat 2018-",
            "engineCode": "B47"
          },
          {
            "name": "d Gran Tourer [F46] [6X31] Manuell 2018-",
            "engineCode": "B47"
          },
          {
            "name": "d xDrive [F44] [71AM] Automat 2020-",
            "engineCode": "B47"
          },
          {
            "name": "d xDrive Active Tourer [F45] [2C51] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d xDrive Gran Tourer [F46] [2D71] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d xDrive Gran Tourer [F46] [6X51] Automat 2018-",
            "engineCode": "B47"
          },
          {
            "name": "d xDrive Gran Tourer [F46] [6X51] Manuell 2018-",
            "engineCode": "B47"
          }
        ]
      },
      {
        "name": "225",
        "types": [
          {
            "name": "xe Active Tourer [F45] [2C71] 2016-",
            "engineCode": "XB2"
          },
          {
            "name": "xe Active Tourer [F45] [6Y31] 2018-",
            "engineCode": "XB2"
          }
        ]
      },
      {
        "name": "316",
        "types": [
          {
            "name": "d [F30] [3D91] 2012-2013",
            "engineCode": "N47D20"
          },
          {
            "name": "d [F30] [3D91] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d [F30] [3W31] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d [F30] [8F91] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d [F31] [3K91] 2012-2013",
            "engineCode": "N47D20"
          },
          {
            "name": "d [F31] [3K91] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d [F31] [8L51] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d [F31] [8L71] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "i [F30] [3A11] 2012-",
            "engineCode": "N13"
          },
          {
            "name": "i [F31] [3G11] 2012-",
            "engineCode": "N13"
          }
        ]
      },
      {
        "name": "318",
        "types": [
          {
            "name": "d [F30] [3D11] 2012-2013",
            "engineCode": "N47"
          },
          {
            "name": "d [F30] [3D11] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d [F30] [8C31] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d [F31] [3K11] 2012-2013",
            "engineCode": "N47"
          },
          {
            "name": "d [F31] [3K11] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d [F31] [8H71] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d GT [F34] [3Y11] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d GT [F34] [8Y51] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d GT[F34] [8T11] 2016-",
            "engineCode": "B47"
          },
          {
            "name": "d GT[F34] [8X11] 2018-",
            "engineCode": "B47"
          },
          {
            "name": "d xDrive [F30] [3J31] 2012-2013",
            "engineCode": "N47"
          },
          {
            "name": "d xDrive [F30] [3J31] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d xDrive [F30] [8C11] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d xDrive [F31] [8H51] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d xDrive [F31] [8J31] 2012-2013",
            "engineCode": "N47"
          },
          {
            "name": "d xDrive [F31] [8J31] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "i [F30] [8E31] 2015-",
            "engineCode": "B38"
          },
          {
            "name": "i [F31] [8K11] 2015-",
            "engineCode": "B38"
          },
          {
            "name": "i [G20] [20FF, 21FF, 22FF, 28FF] 2022-",
            "engineCode": "B48"
          },
          {
            "name": "i [G20] [70DY,71DY, 72DY, 78DY] 2020-",
            "engineCode": "B48"
          },
          {
            "name": "i [G21] [11FY, 12FY] 2022-",
            "engineCode": "B48"
          },
          {
            "name": "i [G21] [71DZ, 72DZ] 2020-",
            "engineCode": "B48"
          }
        ]
      },
      {
        "name": "320",
        "types": [
          {
            "name": "d [F30] [3D31] 2012-2013",
            "engineCode": "N47"
          },
          {
            "name": "d [F30] [3D31] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d [F30] [8C51] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d [F31] [3K31] 2012-2013",
            "engineCode": "N47"
          },
          {
            "name": "d [F31] [3K31] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d [F31] [8H91] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d ed [F30] [3E11] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d ed [F31] [3L11] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d EDE [F30] [8D11] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d EDE [F31] [8J91] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d GT [F34] [3Y31] 2013-",
            "engineCode": "N47"
          },
          {
            "name": "d GT [F34] [8T31] 2016-",
            "engineCode": "B47"
          },
          {
            "name": "d GT [F34] [8Y71] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d xDrive [3D51] [F30] 2012-2013",
            "engineCode": "N47"
          },
          {
            "name": "d xDrive [3K51] [F31] 2012-2013",
            "engineCode": "N47"
          },
          {
            "name": "d xDrive [F30] [3D51] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d xDrive [F31] [3K51] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d xDrive GT [F34] [3Y51] 2013-",
            "engineCode": "N47"
          },
          {
            "name": "e [G20] [5Y91] 2021-",
            "engineCode": "XB1"
          },
          {
            "name": "e [G21] [6N91] 2021-",
            "engineCode": "XB1"
          },
          {
            "name": "e xDrive [G21] [31ED] 2021-",
            "engineCode": "XB1"
          },
          {
            "name": "i [F30] [3B11] 2012-",
            "engineCode": "N20"
          },
          {
            "name": "i [F30] [8A11] 2016-",
            "engineCode": "B48"
          },
          {
            "name": "i [F31] [3G71] 2012-",
            "engineCode": "N20"
          },
          {
            "name": "i [F31] [8G31] 2016-",
            "engineCode": "B48"
          },
          {
            "name": "i [G20] [11FF, 12FF] 2024-",
            "engineCode": "B48"
          },
          {
            "name": "i [G20] [24FF, 50FF, 51FF, 52FF, 58FF] 2022-",
            "engineCode": "B48"
          },
          {
            "name": "i [G20] [5F30, 5F31, 5F32, 5F38] 2019-",
            "engineCode": "B48"
          },
          {
            "name": "i [G20] [5F71, 5F72] 2019-",
            "engineCode": "B48"
          },
          {
            "name": "i [G21] [21FY, 22FY] 2022-",
            "engineCode": "B48"
          },
          {
            "name": "i [G21] [6K31, 6K32] 2020-",
            "engineCode": "B48"
          },
          {
            "name": "i Ed [F30] [3J91] 2013-",
            "engineCode": "N13"
          },
          {
            "name": "i GT [F34] [3X11] 2013-",
            "engineCode": "N20"
          },
          {
            "name": "i GT [F34] [8X31] 2016-",
            "engineCode": "B48"
          },
          {
            "name": "i xDrive [F30] [8A51] 2016-",
            "engineCode": "B48"
          },
          {
            "name": "i xDrive [F31] [8G51] 2016-",
            "engineCode": "B48"
          },
          {
            "name": "i xDrive [G20] [5P30, 5P31, 5P32, 5P38] 2019-",
            "engineCode": "B48"
          },
          {
            "name": "i xDrive GT [F34] [3Z71] 2013-",
            "engineCode": "N20"
          },
          {
            "name": "i xDrive GT [F34] [8X51] 2016-",
            "engineCode": "B48"
          }
        ]
      },
      {
        "name": "325",
        "types": [
          {
            "name": "d [F30] [3D71] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d [F30] [8D31] 2016-",
            "engineCode": "B47"
          },
          {
            "name": "d [F30] [8F11] 2015-",
            "engineCode": "N47"
          },
          {
            "name": "d [F31] [3K71] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d [F31] [8J51] 2016-",
            "engineCode": "B47"
          },
          {
            "name": "d [F31] [8K51] 2015-",
            "engineCode": "N47"
          },
          {
            "name": "d GT [F34] [3Y71] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d GT [F34] [8Z11] 2016-",
            "engineCode": "B47"
          }
        ]
      },
      {
        "name": "328",
        "types": [
          {
            "name": "i [F30] [3A51] 2012-",
            "engineCode": "N20"
          },
          {
            "name": "i [F31] [3G51] 2012-",
            "engineCode": "N20"
          },
          {
            "name": "i GT [F34] [3X31] 2013-",
            "engineCode": "N20"
          },
          {
            "name": "i xDrive [F30] [3B51] 2012-",
            "engineCode": "N20"
          },
          {
            "name": "i xDrive [F31] [3H51] 2012-",
            "engineCode": "N20"
          },
          {
            "name": "i xDrive GT [F34] [3X51] 2013-",
            "engineCode": "N20"
          }
        ]
      },
      {
        "name": "330",
        "types": [
          {
            "name": "d [F30] [3E51] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d [F31] [3L51] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d [G20] [5V91] 2019-",
            "engineCode": "B57"
          },
          {
            "name": "d [G21] [6L91] 2020-",
            "engineCode": "B57"
          },
          {
            "name": "d GT [F34] [3Y91] 2014-",
            "engineCode": "N57"
          },
          {
            "name": "d GT [F34] [8T71] 2016-",
            "engineCode": "N57"
          },
          {
            "name": "d MHEV [G20] [5X91] 2021-",
            "engineCode": "B57"
          },
          {
            "name": "d MHEV [G21] [6M91] 2021-",
            "engineCode": "B57"
          },
          {
            "name": "d xDrive [F30] [3E31] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive [F31] [3L31] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive [G20] [5W11] 2020-",
            "engineCode": "B57"
          },
          {
            "name": "d xDrive [G21] [6M11] 2020-",
            "engineCode": "B57"
          },
          {
            "name": "d xDrive GT [F34] [3Z51] 2014-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive GT [F34] [8T91] 2016-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive MHEV [G20] [5Y11] 2021-",
            "engineCode": "B57"
          },
          {
            "name": "e [F30] [8E11] 2016-",
            "engineCode": "XB1"
          },
          {
            "name": "e [G20] [5P51] 2020-",
            "engineCode": "XB1"
          },
          {
            "name": "e [G20] [5P58] 2020-",
            "engineCode": "XB1"
          },
          {
            "name": "e iPerformance [G20] [5X71] 2019-",
            "engineCode": "XB1"
          },
          {
            "name": "e iPerformance [G21] [6N31] 2020-",
            "engineCode": "XB1"
          },
          {
            "name": "e xDrive [G20] [5P91] 2020-",
            "engineCode": "XB1"
          },
          {
            "name": "e xDrive [G20] [5P98] 2020-",
            "engineCode": "XB1"
          },
          {
            "name": "e xDrive [G21] [6N71] 2020-",
            "engineCode": "XB1"
          },
          {
            "name": "i [F30] [8A71] 2016-",
            "engineCode": "B48"
          },
          {
            "name": "i [F31] [8G71] 2016-",
            "engineCode": "B48"
          },
          {
            "name": "i [G20] [5R11] Webasto S536A 2019-",
            "engineCode": "B48"
          },
          {
            "name": "i [G21] [6K51] 2019-",
            "engineCode": "B48"
          },
          {
            "name": "i [G21] [6K51] Webasto S536A 2019-",
            "engineCode": "B48"
          },
          {
            "name": "i GT[F34] [8X71] 2016-",
            "engineCode": "B48"
          },
          {
            "name": "i xDrive [F30] [8G11] 2016-",
            "engineCode": "B48"
          },
          {
            "name": "i xDrive [F31] [8G91] 2016-",
            "engineCode": "B48"
          },
          {
            "name": "i xDrive [G20] [5R11] 2019-",
            "engineCode": "B48"
          },
          {
            "name": "i xDrive [G20] [5R71] 2019-",
            "engineCode": "B48"
          },
          {
            "name": "i xDrive [G21] [6K71] 2019-",
            "engineCode": "B48"
          },
          {
            "name": "i xDrive GT [F34] [8X91] 2016-",
            "engineCode": "B48"
          }
        ]
      },
      {
        "name": "335",
        "types": [
          {
            "name": "d xDrive [F30] [3J71] 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive GT [F34] [8U11] 2016-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive GT[F34] [3Z91] 2014-",
            "engineCode": "N57"
          },
          {
            "name": "i [F30] [3A91] 2012-",
            "engineCode": "N55"
          },
          {
            "name": "i [F31] [3G91] 2013-",
            "engineCode": "N55"
          },
          {
            "name": "i GT [F34] [3X71] 2013-",
            "engineCode": "N55"
          },
          {
            "name": "i xDrive [F30] [3B91] 2013-",
            "engineCode": "N55"
          },
          {
            "name": "i xDrive [F31] [3H91] 2013-",
            "engineCode": "N55"
          },
          {
            "name": "i xDrive GT [F34] [3X91] 2014-",
            "engineCode": "N55"
          }
        ]
      },
      {
        "name": "340",
        "types": [
          {
            "name": "i [F30] [8B31] 2016-",
            "engineCode": "B58"
          },
          {
            "name": "i [F31] [8H11] 2016-",
            "engineCode": "B58"
          },
          {
            "name": "i GT [F34] [8Y11] 2016-",
            "engineCode": "B58"
          },
          {
            "name": "i xDrive [F30] [8B71] 2016-",
            "engineCode": "B58"
          },
          {
            "name": "i xDrive [F31] [8H31] 2016-",
            "engineCode": "B58"
          },
          {
            "name": "i xDrive GT [F34] [8Y31] 2016-",
            "engineCode": "B58"
          }
        ]
      },
      {
        "name": "418",
        "types": [
          {
            "name": "d Coupè [F32] [4P51] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d Gran Coupè [F36] [4D51] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d Gran Coupè [F36] [4E71] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "i Gran Coupè [F36] [4D11] 2015-",
            "engineCode": "B38"
          },
          {
            "name": "i Gran Coupè [F36] [4H11] 2017-",
            "engineCode": "B38"
          }
        ]
      },
      {
        "name": "420",
        "types": [
          {
            "name": "d [F32] [3P11] 2013-",
            "engineCode": "N47"
          },
          {
            "name": "d Gran Coupè [F36] [4B51] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d Gran Coupè [F36] [4E91] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d xDrive [F32] [3P31] 2013-",
            "engineCode": "N47"
          },
          {
            "name": "d xDrive Coupè [F32] [4P91] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d xDrive Gran Coupè [F36] [4B71] 2014-",
            "engineCode": "N47"
          },
          {
            "name": "d xDrive Gran Coupè [F36] [4F11] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "d xDrive Gran Coupè [F36] [4K51] 2017-",
            "engineCode": "B47"
          },
          {
            "name": "i Coupè [F32] [3N11] 2014-",
            "engineCode": "N20"
          },
          {
            "name": "i Gran Coupè [F36] [4A11] 2014-",
            "engineCode": "N20"
          },
          {
            "name": "i xDrive Coupè [F32] [3S51] 2014-",
            "engineCode": "N20"
          },
          {
            "name": "i xDrive Gran Coupè[F36] [4A31] 2014-",
            "engineCode": "N20"
          }
        ]
      },
      {
        "name": "428",
        "types": [
          {
            "name": "i Coupè [F32] [3N31] 2013-",
            "engineCode": "N20"
          },
          {
            "name": "i Gran Coupè [F36] [4A51] 2014-",
            "engineCode": "N20"
          },
          {
            "name": "i xDrive Coupè [F32] [3N51] 2013-",
            "engineCode": "N20"
          }
        ]
      },
      {
        "name": "430",
        "types": [
          {
            "name": "d Coupè [F32] [4X91] 2017-",
            "engineCode": "N57"
          },
          {
            "name": "d Grand Coupé [F36] [4C11] 2014-",
            "engineCode": "N57"
          },
          {
            "name": "d Grand Coupé [F36] [4K91] 2017-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive Coupè [F32] [3S31] 2014-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive Coupè [F32] [4Y11] 2017-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive Grand Coupé [F36] [4C31] 2014-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive Grand Coupé [F36] [4L11] 2017-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive MHEV [G22] [41AS] 2021-",
            "engineCode": "B57"
          },
          {
            "name": "d xDrive MHEV [G23] [21AU] 2021-",
            "engineCode": "B57"
          }
        ]
      },
      {
        "name": "435",
        "types": [
          {
            "name": "d xDrive [F32] [3S91] 2014-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive [F32] [4Y31] 2017-",
            "engineCode": "N57"
          },
          {
            "name": "i Coupè [F32] [3R11] 2013-",
            "engineCode": "N55"
          },
          {
            "name": "i Drive Coupè [F32] [3R51] 2014-",
            "engineCode": "N55"
          },
          {
            "name": "i Grand Coupè [F36] [4B11] 2014-",
            "engineCode": "N55"
          },
          {
            "name": "i xDrive Grand Coupè [F36] [4B31] 2014-",
            "engineCode": "N55"
          }
        ]
      },
      {
        "name": "440",
        "types": [
          {
            "name": "d xDrive MHEV [G22] [51AS] 2021-",
            "engineCode": "B57"
          }
        ]
      },
      {
        "name": "518",
        "types": [
          {
            "name": "d [F10] [5C11] 2013-",
            "engineCode": "N47"
          },
          {
            "name": "d [F10] [5E31] [Webasto S536A] 2014-",
            "engineCode": "B47"
          },
          {
            "name": "d [F10] [5E31] 2014-",
            "engineCode": "B47"
          },
          {
            "name": "d [F11] [5J11] 2013-",
            "engineCode": "N47"
          },
          {
            "name": "d [F11] [5L11] [Webasto S536A] 2014-",
            "engineCode": "B47"
          },
          {
            "name": "d [F11] [5L11] 2014-",
            "engineCode": "B47"
          }
        ]
      },
      {
        "name": "520",
        "types": [
          {
            "name": "d [F10] [5C31] 2013-",
            "engineCode": "N47"
          },
          {
            "name": "d [F10] [5E51] [Webasto S536A] 2014-",
            "engineCode": "B47"
          },
          {
            "name": "d [F10] [5E51] 2014-",
            "engineCode": "B47"
          },
          {
            "name": "d [F10] [5J31] 2013-",
            "engineCode": "N47"
          },
          {
            "name": "d [F11] [5L31] [Webasto S536A] 2014-",
            "engineCode": "B47"
          },
          {
            "name": "d [F11] [5L31] 2014-",
            "engineCode": "B47"
          },
          {
            "name": "d MHEV [G30] [11DW] Webasto S536A 2020-",
            "engineCode": "XD5"
          },
          {
            "name": "d MHEV [G30] [11DW] Without Webasto 2020-",
            "engineCode": "XD5"
          },
          {
            "name": "d MHEV [G31] [11DX] Webasto S536A 2020-",
            "engineCode": "XD5"
          },
          {
            "name": "d MHEV [G31] [11DX] Without Webasto 2020-",
            "engineCode": "XD5"
          },
          {
            "name": "d xDrive [F10] [5B91] 2013-",
            "engineCode": "N47"
          },
          {
            "name": "d xDrive MHEV [G30] [31DW] Webasto S536A 2020-",
            "engineCode": "XD5"
          },
          {
            "name": "d xDrive MHEV [G30] [31DW] Without Webasto 2020-",
            "engineCode": "XD5"
          },
          {
            "name": "d xDrive MHEV [G31] [31DX] Webasto S536A 2020-",
            "engineCode": "XD5"
          },
          {
            "name": "d xDrive MHEV [G31] [31DX] Without Webasto 2020-",
            "engineCode": "XD5"
          },
          {
            "name": "d xDrive[F11] [5J51] 2013-",
            "engineCode": "N47"
          },
          {
            "name": "e [G30] [31BK] 2021-",
            "engineCode": "B48"
          },
          {
            "name": "e [G31] [71CG] 2021-",
            "engineCode": "B48"
          },
          {
            "name": "i [F10] [XG11] 2012-",
            "engineCode": "N20"
          },
          {
            "name": "i [F11] [XL11] 2012-",
            "engineCode": "N20"
          },
          {
            "name": "i [G30] [JK51] Webasto S536A 2018-",
            "engineCode": "B48"
          },
          {
            "name": "i [G30] [JR11] Webasto S536A 2019-",
            "engineCode": "B48"
          },
          {
            "name": "i [G30] 2017-",
            "engineCode": "B48"
          },
          {
            "name": "i [G30] 2019-",
            "engineCode": "B48"
          },
          {
            "name": "i [G31] [JT11] Webasto S536A 2019-",
            "engineCode": "B48"
          },
          {
            "name": "i [G31] [JT91] Webasto S536A 2018-",
            "engineCode": "B48"
          },
          {
            "name": "i [G31] 2017-",
            "engineCode": "B48"
          },
          {
            "name": "i [G31] 2018-",
            "engineCode": "B48"
          },
          {
            "name": "i MHEV [G30] 2020-",
            "engineCode": "B48"
          }
        ]
      },
      {
        "name": "525",
        "types": [
          {
            "name": "d [F10] [5C71] 2013-",
            "engineCode": "N47"
          },
          {
            "name": "d [F11] [5J71] 2013-",
            "engineCode": "N47"
          },
          {
            "name": "d xDrive [F10] [5C91] 2013-",
            "engineCode": "N47"
          },
          {
            "name": "d xDrive [F11] [5J91] 2013-",
            "engineCode": "N47"
          }
        ]
      },
      {
        "name": "528",
        "types": [
          {
            "name": "i [F10] [5A51] 2013-",
            "engineCode": "N20"
          },
          {
            "name": "i [F11] [5G51] 2013-",
            "engineCode": "N20"
          },
          {
            "name": "i GT [F07] [SZ61] 2013-",
            "engineCode": "N20"
          },
          {
            "name": "i xDrive [F10] [5A71] 2013-",
            "engineCode": "N20"
          },
          {
            "name": "i xDrive [F10] [XH31] 2012-",
            "engineCode": "N20"
          },
          {
            "name": "i xDrive [F11] [5G71] 2013-",
            "engineCode": "N20"
          },
          {
            "name": "i xDrive [F11] [XL51] 2012-",
            "engineCode": "N20"
          }
        ]
      },
      {
        "name": "530",
        "types": [
          {
            "name": "d [F10] [5D11] [Webasto SA536A] 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d [F10] [5D11] Without Webasto S536A 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d [F10] [XA51] [Webasto SA536A] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d [F10] [XA51] Without Webasto S536A 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d [F11] [5K11] [Webasto SA536A] 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d [F11] [5K11] Without Webasto S536A 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d [F11] [XB51] [Webasto SA536A] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d [F11] [XB51] Without Webasto S536A 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d [G30] [JC91] Webasto S536A 2017-",
            "engineCode": "B57"
          },
          {
            "name": "d [G31] [JN31] Webasto S536A 2017-",
            "engineCode": "B57"
          },
          {
            "name": "d GT [F07] [5N41] [Webasto SA536A] 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d GT [F07] [5N41] Without Webasto S536A 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d GT [F07] [XC61] [Webasto SA536A] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d GT [F07] [XC61] Without Webasto S536A 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d GT xDrive [F07] [5N61] [Webasto SA536A] 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d GT xDrive [F07] [5N61] 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d GT xDrive [F07] [XC21] [Webasto SA536A] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d GT xDrive [F07] [XC21] Without Webasto S536A 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d MHEV [G30] [11AH] Webasto S536A 2021-",
            "engineCode": "B57"
          },
          {
            "name": "d MHEV [G31] [11AJ] Webasto S536A 2021-",
            "engineCode": "B57"
          },
          {
            "name": "d xDrive [F10] [5D31] [Webasto SA536A] 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive [F10] [5D31] Without Webasto S536A 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive [F11] [5K31] [Webasto SA536A] 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive [F11] [5K31] Without Webasto S536A 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive [G30] [JD11] Webasto S536A 2017-",
            "engineCode": "B57"
          },
          {
            "name": "d xDrive [G31] [JN51] Webasto S536A 2017-",
            "engineCode": "B57"
          },
          {
            "name": "d xDrive MHEV [G30] [31AH] Webasto S536A 2021-",
            "engineCode": "B57"
          },
          {
            "name": "d xDrive MHEV [G31] [31AJ] Webasto S536A 2021-",
            "engineCode": "B57"
          },
          {
            "name": "e [G30] [11AG] 2020-",
            "engineCode": "B48"
          },
          {
            "name": "e [G30] [JA91] 2017-",
            "engineCode": "B48"
          },
          {
            "name": "e [G31] [11CG] 2021-",
            "engineCode": "B48"
          },
          {
            "name": "e xDrive [G30] [JP91] 2020-",
            "engineCode": "XB1"
          },
          {
            "name": "e xDrive [G30] 11CH] 2020-",
            "engineCode": "B48"
          },
          {
            "name": "e xDrive [G31] [31CG] 2021-",
            "engineCode": "B48"
          },
          {
            "name": "i [G30] [51BH] 2020-",
            "engineCode": "B48"
          },
          {
            "name": "i [G30] [JR31] 2018-",
            "engineCode": "B48"
          },
          {
            "name": "i [G30] [JR31] Webasto S536A 2018-",
            "engineCode": "B48"
          },
          {
            "name": "i [G31] [JL31] 2017-",
            "engineCode": "B48"
          },
          {
            "name": "i [G31] [JT31] 2018-",
            "engineCode": "B48"
          },
          {
            "name": "i [G31] [JT31] Webasto S536A 2018-",
            "engineCode": "B48"
          },
          {
            "name": "i MHEV [G30] [11BJ] 2020-",
            "engineCode": "B48"
          },
          {
            "name": "i MHEV [G31] [31BM] 2020-",
            "engineCode": "B48"
          },
          {
            "name": "i xDrive [G30] [JA71] 2017-",
            "engineCode": "B48"
          },
          {
            "name": "i xDrive [G30] [JR71] 2018-",
            "engineCode": "B48"
          },
          {
            "name": "i xDrive [G30] [JR71] Webasto S536A 2018-",
            "engineCode": "B48"
          },
          {
            "name": "i xDrive [G31] [JL51] 2017-",
            "engineCode": "B48"
          },
          {
            "name": "i xDrive [G31] [JT51] 2018-",
            "engineCode": "B48"
          },
          {
            "name": "i xDrive [G31] [JT51] Webasto S536A 2018-",
            "engineCode": "B48"
          },
          {
            "name": "i xDrive MHEV [G31] [51BM] 2020-",
            "engineCode": "B48"
          }
        ]
      },
      {
        "name": "535",
        "types": [
          {
            "name": "d [F10] [5D51] [Webasto SA536A] 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d [F10] [5D51] 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d [F10] [XA71] [Webasto SA536A] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d [F10] [XA71] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d [F11] [5K51] [Webasto SA536A] 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d [F11] [5K51] 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d [F11] [XB71] [Webasto SA536A] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d [F11] [XB71] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d GT [F07] [5N81] [Webasto SA536A] 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d GT [F07] [5N81] 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d GT [F07] [XC81] [Webasto SA536A] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d GT [F07] [XC81] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d GT xDrive [F07] [5N01] 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d GT xDrive [F07] [XC41] [Webasto SA536A] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d GT xDrive [F07] [XC41] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive [F10] [5D71] [Webasto SA536A] 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive [F10] [5D71] 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive [F10] [XA91] [Webasto SA536A] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive [F10] [XA91] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive [F11] [5K71] [Webasto SA536A] 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive [F11] [5K71] 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive [F11] [XB11] [Webasto SA536A] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive [F11] [XB11] 2012-",
            "engineCode": "N57"
          }
        ]
      },
      {
        "name": "540",
        "types": [
          {
            "name": "d xDrive [G30] [JD51] Webasto S536A 2017-",
            "engineCode": "B57"
          },
          {
            "name": "d xDrive [G31] [JN71] Webasto S536A 2017-",
            "engineCode": "B57"
          },
          {
            "name": "d xDrive MHEV [G31] [51AJ] Webasto S536A 2021-",
            "engineCode": "B57"
          },
          {
            "name": "i [G30] [JB31] 2017-",
            "engineCode": "B58"
          },
          {
            "name": "i xDrive [G30] [JB51] 2017-",
            "engineCode": "B58"
          },
          {
            "name": "i xDrive [G31] [JM11] 2017-",
            "engineCode": "B58"
          },
          {
            "name": "i xDrive MHEV [G31] [71BM] Webasto S536A 2022-",
            "engineCode": "B58"
          }
        ]
      },
      {
        "name": "630",
        "types": [
          {
            "name": "d GT [G32] [JW61] 2018-",
            "engineCode": "B58"
          },
          {
            "name": "d GT [G32] [JW61] Webasto SA536A 2018-",
            "engineCode": "B58"
          },
          {
            "name": "d xDrive GT [G32] [JW81] [Webasto SA536A] 2018-",
            "engineCode": "B58"
          },
          {
            "name": "i GT [G32] [JV21] 2017-",
            "engineCode": "B48"
          },
          {
            "name": "i GT [G32] [JX61] 2018-",
            "engineCode": "B48"
          },
          {
            "name": "i GT [G32] [JX61] Webasto S536A 2018-",
            "engineCode": "B48"
          },
          {
            "name": "i GT [G32] 21BP] 2020-",
            "engineCode": "B48"
          }
        ]
      },
      {
        "name": "640",
        "types": [
          {
            "name": "d [F12] [LZ71] [Webasto SA536A] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d [F12] [LZ71] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d [F13] [LX71] [Webasto SA536A] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d [F13] [LX71] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d Gran Coupè [F06] [6A61] [Webasto SA536A] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d Gran Coupè [F06] [6A61] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d Gran Coupè xDrive [F06] [6A81] 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive [F06] [6A81] 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive [F12] [YP31] [Webasto SA536A] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive [F12] [YP31] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive [F13] [YM31] [Webasto SA536A] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive [F13] [YM31] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive GT [G32] [JW01] [Webasto SA536A] 2018-",
            "engineCode": "B58"
          },
          {
            "name": "i GT [G32] [JV41] 2017-",
            "engineCode": "B58"
          },
          {
            "name": "i GT xDrive [G32] [JV61] 2017-",
            "engineCode": "B58"
          }
        ]
      },
      {
        "name": "730",
        "types": [
          {
            "name": "d [G11][7C21] Webasto S536A 2016-",
            "engineCode": "B57"
          },
          {
            "name": "d [G11][7S21] Webasto S536A 2019-",
            "engineCode": "B57"
          },
          {
            "name": "d xDrive [F01] [YC41] [Webasto SA536A] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive [F01] [YC41] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive [G11][7C41] [Webasto SA536A] 2016-",
            "engineCode": "B57"
          },
          {
            "name": "d xDrive [G11][7S41] Webasto S536A 2019-",
            "engineCode": "B57"
          },
          {
            "name": "dA [F01] [YC21] [Webasto SA536A] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "dA [F01] [YC21] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "i [G11] [7R01] 2019-",
            "engineCode": "B48"
          },
          {
            "name": "i [G11] [7R01] Webasto S536A 2019-",
            "engineCode": "B48"
          },
          {
            "name": "Ld [F02] [YG41] [Webasto SA536A] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "Ld [F02] [YG41] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "Ld [G12][7G41] Webasto S536A 2016-",
            "engineCode": "B57"
          },
          {
            "name": "Ld [G12][7V21] Webasto S536A 2019-",
            "engineCode": "B57"
          },
          {
            "name": "Ld xDrive [G12][7G61] Webasto S536A 2016-",
            "engineCode": "B57"
          },
          {
            "name": "Ld xDrive [G12][7V41] Webasto S536A 2019-",
            "engineCode": "B57"
          }
        ]
      },
      {
        "name": "740",
        "types": [
          {
            "name": "d xDrive [G11][7C61] Webasto S536A 2016-",
            "engineCode": "B57"
          },
          {
            "name": "d xDrive [G11][7S61] Webasto S536A 2019-",
            "engineCode": "B57"
          },
          {
            "name": "dA [F01] [YC81] [Webasto SA536A] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "dA [F01] [YC81] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "dA xDrive [F01] [YB01] [Webasto SA536A] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "dA xDrive [F01] [YB01] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "e iPerformance [G11][7D01] 2016-",
            "engineCode": "XB1"
          },
          {
            "name": "i [G11] [7A21] 2016-",
            "engineCode": "B58"
          },
          {
            "name": "Ld xDrive [G12][7G81] Webasto S536A 2016-",
            "engineCode": "B57"
          },
          {
            "name": "Ld xDrive [G12][7V61] Webasto S536A 2019-",
            "engineCode": "B57"
          },
          {
            "name": "Le iPerformance [G12][7J01] 2016-",
            "engineCode": "XB1"
          },
          {
            "name": "Le iPerformance xDrive [G12][7J21] 2016-",
            "engineCode": "XB1"
          },
          {
            "name": "Li xDrive [G12] [7B41] 2016-",
            "engineCode": "B58"
          }
        ]
      },
      {
        "name": "750",
        "types": [
          {
            "name": "dA xDrive (F01) [YB81] 2013-",
            "engineCode": "N57"
          },
          {
            "name": "Ld xDrive [G11][7C81] Webasto S536A 2016-",
            "engineCode": "B57"
          },
          {
            "name": "Ld xDrive [G11][7S81] Webasto S536A 2019-",
            "engineCode": "B57"
          },
          {
            "name": "Ld xDrive [G12][7H01] Webasto S536A 2016-",
            "engineCode": "B57"
          },
          {
            "name": "Ld xDrive [G12][7V81] Webasto S536A 2019-",
            "engineCode": "B57"
          },
          {
            "name": "LdA xDrive (F02) [YF61] 2013-",
            "engineCode": "N57"
          }
        ]
      },
      {
        "name": "840",
        "types": [
          {
            "name": "d xDrive Cab [G14][FY21] Webasto S536A 2018-",
            "engineCode": "B57"
          },
          {
            "name": "d xDrive Coupè [G15][BC21] Webasto S536A 2018-",
            "engineCode": "B57"
          },
          {
            "name": "d xDrive Gran Coupé [G16] [GW41] 2019-",
            "engineCode": "B57"
          }
        ]
      },
      {
        "name": "M135",
        "types": [
          {
            "name": "i [F20] [1B71] 2013-",
            "engineCode": "N55"
          },
          {
            "name": "i [F20] [1V11] 2015-",
            "engineCode": "N55"
          },
          {
            "name": "i [F21] [1N71] 2013-",
            "engineCode": "N55"
          },
          {
            "name": "i [F21] [1Y71] 2015-",
            "engineCode": "N55"
          },
          {
            "name": "i xDrive [F20] [1B91] 2013-",
            "engineCode": "N55"
          },
          {
            "name": "i xDrive [F20] [1V31] 2015-",
            "engineCode": "N55"
          },
          {
            "name": "i xDrive [F21] [1N91] 2013-",
            "engineCode": "N55"
          },
          {
            "name": "i xDrive [F21] [1Y91] 2015-",
            "engineCode": "N55"
          },
          {
            "name": "i xDrive [F40] [7L11] 2020-",
            "engineCode": "B48"
          }
        ]
      },
      {
        "name": "M140",
        "types": [
          {
            "name": "i [F20] [1R91] 2016-",
            "engineCode": "B58"
          },
          {
            "name": "i [F21] [1P91] 2016-",
            "engineCode": "B58"
          },
          {
            "name": "i xDrive [F20] [1S91] 2016-",
            "engineCode": "B58"
          },
          {
            "name": "i xDrive [F21] [1W91] 2016-",
            "engineCode": "B58"
          }
        ]
      },
      {
        "name": "M235",
        "types": [
          {
            "name": "i [F22] [1J71] 2014-",
            "engineCode": "N55"
          },
          {
            "name": "i [F23] [1M11] 2015-",
            "engineCode": "N55"
          },
          {
            "name": "i xDrive [F22] [1J91] 2014-",
            "engineCode": "N55"
          },
          {
            "name": "i xDrive [F44] [11AL] 2020-",
            "engineCode": "B48"
          },
          {
            "name": "i xDrive Cabrio [F23] [1M51] 2015-",
            "engineCode": "N55"
          }
        ]
      },
      {
        "name": "M340",
        "types": [
          {
            "name": "d xDrive MHEV [G20] [51DY] 2021-",
            "engineCode": "B57"
          },
          {
            "name": "d xDrive MHEV [G21] [51DZ] 2021-",
            "engineCode": "B57"
          }
        ]
      },
      {
        "name": "M550",
        "types": [
          {
            "name": "d xDrive [F10] [5D91] 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive [F10] [FV71] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive [F11] [5K91] 2013-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive [F11] [MY91] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "d xDrive [G30] [JD71] Webasto S536A 2018-",
            "engineCode": "B57"
          },
          {
            "name": "d xDrive [G31] [JN91] Webasto S536A 2018-",
            "engineCode": "B57"
          }
        ]
      },
      {
        "name": "M850",
        "types": [
          {
            "name": "i xDrive Cab [G14] [FY41] 2019-",
            "engineCode": "N63"
          },
          {
            "name": "i xDrive Coupé [G16] [BC41] 2019-",
            "engineCode": "N63"
          },
          {
            "name": "i xDrive Gran Coupé [G16] [GV81] 2020-",
            "engineCode": "N63"
          }
        ]
      },
      {
        "name": "X1",
        "types": [
          {
            "name": "20i sDrive [F48] [71AA] 2019-",
            "engineCode": "B48"
          },
          {
            "name": "20i sDrive [F48] [HS71] 2015-",
            "engineCode": "B48"
          },
          {
            "name": "20i sDrive [F48] [JG31] 2018-",
            "engineCode": "B48"
          },
          {
            "name": "20i sDrive [U11] [41EE] 2022-",
            "engineCode": "B48"
          },
          {
            "name": "20i xDrive [F48] [11AB] 2020-",
            "engineCode": "B48"
          },
          {
            "name": "20i xDrive [F48] [HS91] 2015-",
            "engineCode": "B48"
          },
          {
            "name": "20i xDrive [F48] [JG51] 2018-",
            "engineCode": "B48"
          },
          {
            "name": "20i xDrive [U11] [51EE] 2022-",
            "engineCode": "B48"
          },
          {
            "name": "23i xDrive [U11] [61EE] 2022-",
            "engineCode": "B48"
          },
          {
            "name": "25i xDrive [F48] [51AB] 2020-",
            "engineCode": "B48"
          },
          {
            "name": "25i xDrive [F48] [HT11] 2015-",
            "engineCode": "B48"
          },
          {
            "name": "25i xDrive [F48] [JG91] 2018-",
            "engineCode": "B48"
          },
          {
            "name": "M35i xDrive [U11] [11EF] 2023-",
            "engineCode": "B48"
          },
          {
            "name": "sDrive 16d [F48] [HT51] 2015-",
            "engineCode": "B37"
          },
          {
            "name": "sDrive 16d [F48] [JH11] Manuell 2018-",
            "engineCode": "B37"
          },
          {
            "name": "sDrive 18d [E84] [VN71] 2012-",
            "engineCode": "N47"
          },
          {
            "name": "sDrive 18d [F48] [71AC] Automat 2019-",
            "engineCode": "B47"
          },
          {
            "name": "sDrive 18d [F48] [71AC] Manuell 2019-",
            "engineCode": "B47"
          },
          {
            "name": "sDrive 18d [F48] [HT71] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "sDrive 18d [F48] [JH51] Automat 2018-",
            "engineCode": "B47"
          },
          {
            "name": "sDrive 18d [F48] [JH51] Manuell 2018-",
            "engineCode": "B47"
          },
          {
            "name": "sDrive 20d [E84] [VN91] 2012-",
            "engineCode": "N47"
          },
          {
            "name": "sDrive 20d [F48] [71AD] Automat 2019-",
            "engineCode": "B47"
          },
          {
            "name": "sDrive 20d [F48] [HU11] 2016-",
            "engineCode": "B47"
          },
          {
            "name": "sDrive 20d [F48] [JH91] Automat 2018-",
            "engineCode": "B47"
          },
          {
            "name": "sDrive 20d ED [E84] [VZ91] 2012-",
            "engineCode": "N47"
          },
          {
            "name": "sDrive 20i [E84] [VL91] 2012-",
            "engineCode": "N20"
          },
          {
            "name": "xDrive 18d [E84] [VP71] 2012-",
            "engineCode": "N47"
          },
          {
            "name": "xDrive 18d [F48] [31AD] Automat 2019-",
            "engineCode": "B47"
          },
          {
            "name": "xDrive 18d [F48] [31AD] Manuell 2019-",
            "engineCode": "B47"
          },
          {
            "name": "xDrive 18d [F48] [HT91] 2016-",
            "engineCode": "B47"
          },
          {
            "name": "xDrive 18d [F48] [JH71] Automat 2018-",
            "engineCode": "B47"
          },
          {
            "name": "xDrive 18d [F48] [JH71] Manuell 2018-",
            "engineCode": "B47"
          },
          {
            "name": "xDrive 20d [E84] [VP91] 2012-",
            "engineCode": "N47"
          },
          {
            "name": "xDrive 20d [F48] [31AE] Automat 2019-",
            "engineCode": "B47"
          },
          {
            "name": "xDrive 20d [F48] [HU31] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "xDrive 20d [F48] [JJ11] Automat 2018-",
            "engineCode": "B47"
          },
          {
            "name": "xDrive 20i [E84] [VM91] 2012-",
            "engineCode": "N20"
          },
          {
            "name": "xDrive 25d [E84] [VM71] 2012-",
            "engineCode": "N47"
          },
          {
            "name": "xDrive 28i [E84] [VM11] 2012-",
            "engineCode": "N20"
          }
        ]
      },
      {
        "name": "X2",
        "types": [
          {
            "name": "20i sDrive [F39] [YH31] 2018-",
            "engineCode": "B48"
          },
          {
            "name": "20i xDrive [F39] [YH51] 2018-",
            "engineCode": "B48"
          },
          {
            "name": "M35i [F39] [YN11] 2019-",
            "engineCode": "B48"
          },
          {
            "name": "M35i [U10] [81GM] 2024-",
            "engineCode": "B48"
          },
          {
            "name": "sDrive 18d [F39] [YK51] Automat 2018-",
            "engineCode": "B47"
          },
          {
            "name": "sDrive 18d [F39] [YK51] Manuell 2018-",
            "engineCode": "B47"
          },
          {
            "name": "sDrive 20d [F39] [YK91] Automat 2019-",
            "engineCode": "B47"
          },
          {
            "name": "xDrive 18d [F39] [YK71] Automat 2018-",
            "engineCode": "B47"
          },
          {
            "name": "xDrive 18d [F39] [YK71] Manuell 2018-",
            "engineCode": "B47"
          },
          {
            "name": "xDrive 20d [F39] [YL11] Automat 2018-",
            "engineCode": "B47"
          }
        ]
      },
      {
        "name": "X3",
        "types": [
          {
            "name": "18d sDrive [F25] [WZ31] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "20 xDrive [G45] [31GP] 2024-",
            "engineCode": "B48"
          },
          {
            "name": "20i sDrive [F25][WY91] 2014-",
            "engineCode": "N20"
          },
          {
            "name": "20i sDrive [G01] [11,DP, 12DP] 2020-",
            "engineCode": "B48"
          },
          {
            "name": "20i sDrive [G01] [TR11] 2018-",
            "engineCode": "B48"
          },
          {
            "name": "20i sDrive [G01] [TS71] 2019-",
            "engineCode": "B48"
          },
          {
            "name": "20i xDrive [F25][WX31] 2012-",
            "engineCode": "N20"
          },
          {
            "name": "20i xDrive [G01] [21DP] 2020-",
            "engineCode": "B48"
          },
          {
            "name": "20i xDrive [G01] [TR51] 2018-",
            "engineCode": "B48"
          },
          {
            "name": "20i xDrive [G01] [TR55] 2018-",
            "engineCode": "B48"
          },
          {
            "name": "20i xDrive [G01] [TY11] 2019-",
            "engineCode": "B48"
          },
          {
            "name": "20i xDrive [G01] [TY15] 2019-",
            "engineCode": "B48"
          },
          {
            "name": "20i xDrive MHEV [G01] [25DP] 2021-",
            "engineCode": "B48"
          },
          {
            "name": "28i xDrive [F25][WX91] 2012-",
            "engineCode": "N20"
          },
          {
            "name": "30e xDrive [G01] [61DP] 2021-",
            "engineCode": "XB1G"
          },
          {
            "name": "30e xDrive [G01] [TS11] 2020-",
            "engineCode": "XB1G"
          },
          {
            "name": "30i xDrive [G01] [51DP] 2020-",
            "engineCode": "B48"
          },
          {
            "name": "30i xDrive [G01] [TR91] 2018-",
            "engineCode": "B48"
          },
          {
            "name": "30i xDrive [G01] [TR95] 2018-",
            "engineCode": "B48"
          },
          {
            "name": "30i xDrive [G01] [TY51] 2019-",
            "engineCode": "B48"
          },
          {
            "name": "30i xDrive [G01] [TY55] 2019-",
            "engineCode": "B48"
          },
          {
            "name": "30i xDrive MHEV [G01] [55DP] 2021-",
            "engineCode": "B48"
          },
          {
            "name": "35d xDrive (F25)[WY71] [Webasto S536A] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "35d xDrive (F25)[WY71] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "M40i xDrive [G01] [TS31] 2018-",
            "engineCode": "B58"
          }
        ]
      },
      {
        "name": "X4",
        "types": [
          {
            "name": "20d xDrive [F26] [XX11] 2015-",
            "engineCode": "B47"
          },
          {
            "name": "20i xDrive [F26][XW11] 2014-",
            "engineCode": "N20"
          },
          {
            "name": "20i xDrive [G02] [UJ11] 2018-",
            "engineCode": "B48"
          },
          {
            "name": "20i xDrive [G02] [UJ71] 2019-",
            "engineCode": "B48"
          },
          {
            "name": "20i xDrive MHEV [G02] [11DT] 2021-",
            "engineCode": "B48"
          },
          {
            "name": "28i xDrive [F26][XW31] 2014-",
            "engineCode": "N20"
          },
          {
            "name": "30d xDrive (F26)[XX31] [Webasto S536A] 2014-",
            "engineCode": "N57"
          },
          {
            "name": "30d xDrive (F26)[XX31] 2014-",
            "engineCode": "N57"
          },
          {
            "name": "30i xDrive [G02] [2V11] 2019-",
            "engineCode": "B48"
          },
          {
            "name": "30i xDrive [G02] [UJ31] 2018-",
            "engineCode": "B48"
          },
          {
            "name": "30i xDrive MHEV [G02] [31DT] 2021-",
            "engineCode": "B48"
          },
          {
            "name": "35d xDrive (F26)[XX51] [Webasto S536A] 2014-",
            "engineCode": "N57"
          },
          {
            "name": "35d xDrive (F26)[XX51] 2014-",
            "engineCode": "N57"
          }
        ]
      },
      {
        "name": "X5",
        "types": [
          {
            "name": "30d xDrive (G05)[CV61] With Webasto S536A 2019-",
            "engineCode": "B57"
          },
          {
            "name": "M50d [E70] [ZW81] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "M50d [F15] [KS81] 2013-",
            "engineCode": "N57"
          },
          {
            "name": "xDrive 30d [F15] [KS41] 2013-",
            "engineCode": "N57"
          },
          {
            "name": "xDrive 40d [F15] [KS61] 2013-",
            "engineCode": "N57"
          }
        ]
      },
      {
        "name": "X6",
        "types": [
          {
            "name": "30d xDrive (G06)[GT21] With Webasto S536A 2019-",
            "engineCode": "B57"
          },
          {
            "name": "M50d [E71] [FH81] 2012-",
            "engineCode": "N57"
          },
          {
            "name": "M50d [F16] [KV61] 2014-",
            "engineCode": "N57"
          },
          {
            "name": "xDrive 30d [F16] [KV21] 2014-",
            "engineCode": "N57"
          },
          {
            "name": "xDrive 40d [F16] [KV41] 2015-",
            "engineCode": "N57"
          }
        ]
      },
      {
        "name": "X7",
        "types": [
          {
            "name": "30d xDrive (G07)[CW81] With Webasto S536A 2019-",
            "engineCode": "B57"
          }
        ]
      }
    ]
  },
  {
    "make": "Citroen",
    "models": [
      {
        "name": "Berlingo",
        "types": [
          {
            "name": "II [B9] 1.2 PureTech 111 2017-",
            "engineCode": "HNZ"
          },
          {
            "name": "II [B9] 1.6 Blue HDI 101 2015-",
            "engineCode": "DV6FD"
          },
          {
            "name": "III [K9] 1.5 BlueHDi 101 2018-",
            "engineCode": "DV5RD"
          },
          {
            "name": "III [K9] 1.5 BlueHDi 130 4x5 2020-",
            "engineCode": "YHZ"
          },
          {
            "name": "III [K9] 1.5 BlueHDi 131 2018-",
            "engineCode": "DV5RC"
          },
          {
            "name": "III [K9] 1.5 BlueHDi 76 2019-",
            "engineCode": "YHW"
          },
          {
            "name": "III [K9] BlueHDi 101 2018-",
            "engineCode": "DV5RD"
          },
          {
            "name": "III [K9] PureTech 111 2019-",
            "engineCode": "EB2ADT"
          },
          {
            "name": "III [K9] PureTech 131 2019-",
            "engineCode": "HNS"
          }
        ]
      },
      {
        "name": "C1",
        "types": [
          {
            "name": "II 1.1 2014-",
            "engineCode": "CFB"
          },
          {
            "name": "II 1.2 Vti 83 2014-",
            "engineCode": "EB3"
          },
          {
            "name": "II FEEL PT73 2020-",
            "engineCode": "CFB"
          }
        ]
      },
      {
        "name": "C3",
        "types": [
          {
            "name": "Aircross 1.2 Pure Tech 111 2017-",
            "engineCode": "HNZ"
          },
          {
            "name": "Aircross 1.2 Pure Tech 131 2017-",
            "engineCode": "HNY"
          },
          {
            "name": "Aircross 1.2 PureTech 111 2019-",
            "engineCode": "ED2DT"
          },
          {
            "name": "Aircross 1.2 PureTech 83 2017- 2018",
            "engineCode": "EB2"
          },
          {
            "name": "Aircross 1.2 PureTech 83 2018-",
            "engineCode": "EB2F"
          },
          {
            "name": "Aircross PureTech 111 2019-",
            "engineCode": "HNP"
          },
          {
            "name": "Aircross PureTech 131 2019-",
            "engineCode": "HNS"
          },
          {
            "name": "II 1.0 PureTech 69 2012-",
            "engineCode": "EB0"
          },
          {
            "name": "II 1.2 Pure Tech 111 2014-",
            "engineCode": "HNZ"
          },
          {
            "name": "II 1.2 VTI 83 2012-",
            "engineCode": "EB2"
          },
          {
            "name": "II 1.4 e-HDI 2012-",
            "engineCode": "8HP"
          },
          {
            "name": "II 1.6 Blue HDI 101 2015-",
            "engineCode": "DV6FD"
          },
          {
            "name": "III 1.2 PureTech 111 2017-",
            "engineCode": "HNZ"
          },
          {
            "name": "III 1.2 PureTech 111 2019-",
            "engineCode": "HNV"
          },
          {
            "name": "III 1.2 PureTech 83 2017- 2018",
            "engineCode": "EB2"
          },
          {
            "name": "III 1.2 PureTech 83 2018-",
            "engineCode": "EB2F"
          },
          {
            "name": "III 1.6 Blue HDI 101 2017-",
            "engineCode": "DV6FD"
          },
          {
            "name": "III PureTech 111 2020-",
            "engineCode": "HNP"
          },
          {
            "name": "Picasso 1.2 Pure Tech 111 2017-",
            "engineCode": "HNZ"
          },
          {
            "name": "Picasso 1.2 PureTech 111 2015-2017",
            "engineCode": "HNZ"
          },
          {
            "name": "Picasso 1.6 Blue HDI 101 2015-",
            "engineCode": "DV6FD"
          }
        ]
      },
      {
        "name": "C4",
        "types": [
          {
            "name": "1.2 e-THP 2014-2017",
            "engineCode": "HNY"
          },
          {
            "name": "1.2 e-THP 2017-",
            "engineCode": "HNY"
          },
          {
            "name": "Aircross 1.6 HDI 2012-",
            "engineCode": "9HL"
          },
          {
            "name": "Aircross 1.6i 2012-",
            "engineCode": "MMC"
          },
          {
            "name": "Aircross 1.8 HDI 2012-",
            "engineCode": "MMC"
          },
          {
            "name": "Cactus 1.2 PureTech 111 2019-",
            "engineCode": "HNZ"
          },
          {
            "name": "Cactus 1.2 VTI 83 2014-",
            "engineCode": "HMZ"
          },
          {
            "name": "Cactus 1.6 Blue HDI 101 2015-",
            "engineCode": "BHY"
          },
          {
            "name": "Cactus 1.6 e-HDI 2014-",
            "engineCode": "DV6"
          },
          {
            "name": "Cactus Blue HDI 121 2019-",
            "engineCode": "YHX"
          },
          {
            "name": "Cactus PureTech 111 2019-",
            "engineCode": "HNP"
          },
          {
            "name": "Cactus PureTech 131 2019-",
            "engineCode": "HNS"
          },
          {
            "name": "Grand Picasso 1.6 e-THP 166 2014-",
            "engineCode": "5GZ"
          },
          {
            "name": "Grand Picasso 2.0 Hdi 2014-",
            "engineCode": "AHX"
          },
          {
            "name": "Grand SpaceTourer BlueHDi 131 2018-",
            "engineCode": "DV5RC"
          },
          {
            "name": "Grand SpaceTourer BlueHDi 161 2019-",
            "engineCode": "EHY"
          },
          {
            "name": "Grand SpaceTourer PureTech 131 2019-",
            "engineCode": "HNS"
          },
          {
            "name": "Grand SpaceTourer PureTech 131 2020-",
            "engineCode": "HNS"
          },
          {
            "name": "Grand SpaceTourer PureTech 180 Automat 2019-",
            "engineCode": "EP6FATXD"
          },
          {
            "name": "III 1.2 PureTech 131 2021-",
            "engineCode": "HNS"
          },
          {
            "name": "III 1.2 PureTech 156 2021-",
            "engineCode": "HNN"
          },
          {
            "name": "Picasso 1.2 e-THP 2015-2017",
            "engineCode": "HNY"
          },
          {
            "name": "Picasso 1.2 e-THP PureTech 131 2017-",
            "engineCode": "HNY"
          },
          {
            "name": "Picasso 1.6 HDI (9HC) 2013-",
            "engineCode": "9HC"
          },
          {
            "name": "Picasso 1.6 HDI (9HR) 2013-",
            "engineCode": "9HR"
          },
          {
            "name": "Picasso 2.0 Hdi 2014-",
            "engineCode": "AHX"
          },
          {
            "name": "Picasso PureTech 131 2014-",
            "engineCode": "HNY"
          },
          {
            "name": "SpaceTourer BlueHDi 131 2018-",
            "engineCode": "DV5RC"
          },
          {
            "name": "SpaceTourer BlueHDi 161 2019-",
            "engineCode": "EHY"
          },
          {
            "name": "SpaceTourer PureTech 180 Automat 2019-",
            "engineCode": "EP6FATXD"
          }
        ]
      },
      {
        "name": "C5",
        "types": [
          {
            "name": "Aircross BlueHDi 131 2019-",
            "engineCode": "DV5RC"
          },
          {
            "name": "Aircross BlueHDi 181 2019-",
            "engineCode": "EHZ"
          },
          {
            "name": "Aircross Hybrid 137 2024-",
            "engineCode": "HPY"
          },
          {
            "name": "Aircross PHEV 226 2020-",
            "engineCode": "EP6FADTXD"
          },
          {
            "name": "Aircross PureTech 131 2019-",
            "engineCode": "HNS"
          },
          {
            "name": "Aircross PureTech 180 Automat 2019-",
            "engineCode": "EP6F"
          },
          {
            "name": "III 2.0 HDI 151 2015-",
            "engineCode": "AHX"
          },
          {
            "name": "III 2.0 HDI 181 2015-",
            "engineCode": "AHW"
          },
          {
            "name": "X Hybrid 137 2024-",
            "engineCode": "HPY"
          },
          {
            "name": "X PHEV 226 2023-",
            "engineCode": "EP6FAD"
          }
        ]
      },
      {
        "name": "DS",
        "types": [
          {
            "name": "3 1.2 VTi 82 Manuell 2013-",
            "engineCode": "HMZ"
          }
        ]
      },
      {
        "name": "DS3",
        "types": [
          {
            "name": "1.2 Pure Tech 111 2014-2016",
            "engineCode": "HNZ"
          },
          {
            "name": "1.2 THP 131 2015-2016",
            "engineCode": "HNY"
          },
          {
            "name": "1.4 HDI 2012-",
            "engineCode": "9HR"
          },
          {
            "name": "1.6T Racing 2012-",
            "engineCode": "5FD"
          }
        ]
      },
      {
        "name": "DS4",
        "types": [
          {
            "name": "1.2 e-THP 131 2015-2016",
            "engineCode": "HNY"
          },
          {
            "name": "1.6 e-HDI 2012-",
            "engineCode": "9HL"
          }
        ]
      },
      {
        "name": "DS5",
        "types": [
          {
            "name": "1.6 e-Hdi 2012-",
            "engineCode": "9HL"
          },
          {
            "name": "2.0 BlueHDI 151 2014-",
            "engineCode": "DW10FD"
          },
          {
            "name": "2.0 BlueHDI 181 2013-",
            "engineCode": "DW10FC"
          },
          {
            "name": "2.0 HDI 2012-",
            "engineCode": "RHH"
          },
          {
            "name": "BlueHDI 121 2015-",
            "engineCode": "DV6"
          }
        ]
      },
      {
        "name": "Jumper",
        "types": [
          {
            "name": "III 2.0 BlueHDI 111 2016-",
            "engineCode": "DW10FUE"
          },
          {
            "name": "III 2.0 BlueHDI 131 2016-",
            "engineCode": "DW10FUD"
          },
          {
            "name": "III 2.0 BlueHDI 164 2016-",
            "engineCode": "DW10FUC"
          },
          {
            "name": "III 2.2 BlueHDI 121 2020-",
            "engineCode": "DW12"
          },
          {
            "name": "III 2.2 BlueHDI 141 2020-",
            "engineCode": "DW12"
          },
          {
            "name": "III 2.2 BlueHDI 166 2020-",
            "engineCode": "DW12"
          }
        ]
      },
      {
        "name": "Jumpy",
        "types": [
          {
            "name": "III 1.5 BlueHDi 101 2019-",
            "engineCode": "DV5RUCD"
          },
          {
            "name": "III 1.5 BlueHDi 121 2019-",
            "engineCode": "DV5RUC"
          },
          {
            "name": "III BlueHDi 116 2016-",
            "engineCode": "DW6FCU"
          },
          {
            "name": "III BlueHDi 121 2016-",
            "engineCode": "DW10FE"
          },
          {
            "name": "III BlueHDi 146 2022-",
            "engineCode": "DW10FD"
          },
          {
            "name": "III BlueHDi 151 2016-",
            "engineCode": "DW10FD"
          },
          {
            "name": "III BlueHDi 181 2016-",
            "engineCode": "DW10FC"
          },
          {
            "name": "III BlueHDi 96 2016-",
            "engineCode": "BHV"
          }
        ]
      },
      {
        "name": "Spacetourer",
        "types": [
          {
            "name": "2.0 BlueHDi 151 2016-",
            "engineCode": "DW10FD"
          },
          {
            "name": "2.0 BlueHDi 181 2016-",
            "engineCode": "DW10FC"
          },
          {
            "name": "BlueHDi 151 2019-",
            "engineCode": "DW10FD"
          },
          {
            "name": "BlueHDi 181 2019-",
            "engineCode": "DW10FC"
          }
        ]
      }
    ]
  },
  {
    "make": "Cupra",
    "models": [
      {
        "name": "Ateca",
        "types": [
          {
            "name": "1.5 TSI 151 2024-",
            "engineCode": "DXDB"
          }
        ]
      },
      {
        "name": "Formentor",
        "types": [
          {
            "name": "1.4 e-Hybrid 204 PHEV 2021-",
            "engineCode": "DGE"
          },
          {
            "name": "1.4 ZV e-Hybrid 245 PHEV 2021-",
            "engineCode": "DGE"
          },
          {
            "name": "1.5 eTSI 151 2024-",
            "engineCode": "DXDB"
          },
          {
            "name": "1.5 TSI 151 2021-",
            "engineCode": "DPC"
          },
          {
            "name": "2.0 TSI 190 4Drive 2021-",
            "engineCode": "DNN"
          },
          {
            "name": "2.0 TSI 300 4Drive 2021-",
            "engineCode": "DNF"
          }
        ]
      },
      {
        "name": "Leon",
        "types": [
          {
            "name": "1.4 e-Hybrid 245 PHEV 2021-",
            "engineCode": "DGE"
          },
          {
            "name": "2.0 TSI 246 2021-",
            "engineCode": "DNPA"
          }
        ]
      },
      {
        "name": "Terramar",
        "types": [
          {
            "name": "1.5 eTSI 151 2025-",
            "engineCode": "DXDB"
          },
          {
            "name": "2.0 TSI 265 VZ 4Drive 2024-",
            "engineCode": "DNPB"
          }
        ]
      }
    ]
  },
  {
    "make": "DS Automobiles",
    "models": [
      {
        "name": "DS",
        "types": [
          {
            "name": "3 1.6 THP 166 2016-",
            "engineCode": "EP6FDT"
          },
          {
            "name": "3 Crossback 1.2 PureTech 101 2019-",
            "engineCode": "EB2ADT"
          },
          {
            "name": "3 Crossback 1.2 PureTech 131 2019-",
            "engineCode": "EB2ADT"
          },
          {
            "name": "3 Crossback 1.2 PureTech 156 2019-",
            "engineCode": "EB2ADT"
          },
          {
            "name": "3 PureTech 111 2017-",
            "engineCode": "HNZ"
          },
          {
            "name": "3 PureTech 131 2015-2017",
            "engineCode": "HNY"
          },
          {
            "name": "3 PureTech 131 2017-",
            "engineCode": "HNY"
          },
          {
            "name": "3 PureTech 82 Manuell 2016-",
            "engineCode": "HMZ"
          },
          {
            "name": "4 BlueHDi 181 2016-",
            "engineCode": "AHW"
          },
          {
            "name": "4 Crossback BlueHDi 121 2016-",
            "engineCode": "DV6FC"
          },
          {
            "name": "4 PureTech 131 2015-2017",
            "engineCode": "HNY"
          },
          {
            "name": "4 PureTech 131 2017-",
            "engineCode": "HNY"
          },
          {
            "name": "5 BlueHDi 151 2015-",
            "engineCode": "DW10FD"
          },
          {
            "name": "5 BlueHDi 181 2016-",
            "engineCode": "AHW"
          },
          {
            "name": "7 Crossback 1.6 PureTech 181 2019-",
            "engineCode": "EP6FA"
          },
          {
            "name": "7 Crossback E-Tense 301 2019-",
            "engineCode": "EP6FA"
          }
        ]
      }
    ]
  },
  {
    "make": "Dacia",
    "models": [
      {
        "name": "Dokker",
        "types": [
          {
            "name": "1.2 TCe 2013-",
            "engineCode": "H5F"
          },
          {
            "name": "1.6 Sce 101 2015-",
            "engineCode": "H4M"
          },
          {
            "name": "Van 1.2 TCe 2013-",
            "engineCode": "H5F"
          },
          {
            "name": "Van 1.3 TCe 131 2019-",
            "engineCode": "H5H"
          },
          {
            "name": "Van 1.5 Blue dCi 96 2020-",
            "engineCode": "K9K"
          }
        ]
      },
      {
        "name": "Duster",
        "types": [
          {
            "name": "I 1.2 Tce 125 4x5 2015-",
            "engineCode": "H5F"
          },
          {
            "name": "I 1.2 Tce 2013-",
            "engineCode": "H5F"
          },
          {
            "name": "I 1.6 16v 115 4x3 2015-",
            "engineCode": "H4M"
          },
          {
            "name": "I 1.6 16v 115 4x5 2015-",
            "engineCode": "H4M"
          },
          {
            "name": "II 1.0 TCe 100 4x3 2020-",
            "engineCode": "H4D"
          },
          {
            "name": "II 1.0 TCe 90 4x3 2021-",
            "engineCode": "H4D"
          },
          {
            "name": "II 1.2 TCe 125 4x3 2017-",
            "engineCode": "H5F"
          },
          {
            "name": "II 1.3 TCe 130 4x3 2019-",
            "engineCode": "H5H"
          },
          {
            "name": "II 1.3 TCe 130 4x5 2019-",
            "engineCode": "H5H"
          },
          {
            "name": "II 1.3 TCe 150 4x3 2019-",
            "engineCode": "H5H"
          },
          {
            "name": "II 1.3 TCe 150 4x5 2019-",
            "engineCode": "H5H"
          },
          {
            "name": "II 1.5 Blue dCi 115 4x5 2019-",
            "engineCode": "K9"
          },
          {
            "name": "II 1.5 dCi 110 4x2, 4x5 2016-2018",
            "engineCode": "K9K"
          },
          {
            "name": "II 1.5 dCi 110 4x3 2018-",
            "engineCode": "K9K"
          },
          {
            "name": "II 1.6 SCe 115 4x2, 4x5 2017-",
            "engineCode": "H4M"
          },
          {
            "name": "III 1.2 TCe 130 4x5 2024-",
            "engineCode": "H5F"
          },
          {
            "name": "III 1.2 TCe 131 2024-",
            "engineCode": "H5F"
          },
          {
            "name": "III 1.6 Hybrid 141 2024-",
            "engineCode": "H4M"
          }
        ]
      },
      {
        "name": "Jogger",
        "types": [
          {
            "name": "1.0 TCe 111 2022-",
            "engineCode": "H5D"
          },
          {
            "name": "1.6 140 Hybrid 2023-",
            "engineCode": "H4M"
          }
        ]
      },
      {
        "name": "Lodgy",
        "types": [
          {
            "name": "1.2 TCe 2012-",
            "engineCode": "H5F"
          },
          {
            "name": "1.3 TCe 131 2019-",
            "engineCode": "H5H"
          },
          {
            "name": "1.5 dCi 2015-2017",
            "engineCode": "K9K"
          },
          {
            "name": "1.5 dCi 2017-",
            "engineCode": "K9K"
          },
          {
            "name": "Stepway 1.6 Sce 101 2019-",
            "engineCode": "H4M"
          }
        ]
      },
      {
        "name": "Logan",
        "types": [
          {
            "name": "MCV II 0.9 TCe 2013-",
            "engineCode": "H4B"
          },
          {
            "name": "MCV II 1.5 dCi 2015-",
            "engineCode": "K9K"
          }
        ]
      },
      {
        "name": "Sandero",
        "types": [
          {
            "name": "II 0.9 TCe 2012-",
            "engineCode": "H4B"
          },
          {
            "name": "II 1.5 dCi 2015-",
            "engineCode": "K9K"
          },
          {
            "name": "III 1.0 TCe 90 (Manuell) 2021-",
            "engineCode": "H4D"
          },
          {
            "name": "Stepway 1.0 TCe 91 2021-",
            "engineCode": "H4D"
          }
        ]
      }
    ]
  },
  {
    "make": "Fiat",
    "models": [
      {
        "name": "500L",
        "types": [
          {
            "name": "Trekking 1.4 Tjet 2014-",
            "engineCode": "940B7000"
          },
          {
            "name": "Trekking 1.6 MultiJet 105hk 2013-",
            "engineCode": "199B5000"
          }
        ]
      },
      {
        "name": "500X",
        "types": [
          {
            "name": "1.0 GSE 121 2019-",
            "engineCode": "55282151.0"
          },
          {
            "name": "1.4 MultiAir Crossover 2015-",
            "engineCode": "55263624.0"
          },
          {
            "name": "1.6 E-Torq 110 Crossover 2015-",
            "engineCode": "55263842.0"
          },
          {
            "name": "2.0 MultiJet II 140 Crossover 2015-",
            "engineCode": "55263088.0"
          }
        ]
      },
      {
        "name": "Ducato",
        "types": [
          {
            "name": "2.2 MultiJet 121 2022-",
            "engineCode": "46349131.0"
          },
          {
            "name": "2.2 MultiJet 141 2021-",
            "engineCode": "46349131.0"
          },
          {
            "name": "2.3 JTD 131 2012-2015",
            "engineCode": "F1AE3481D"
          },
          {
            "name": "2.3 MultiJet 121 2020-",
            "engineCode": "F1AGL"
          },
          {
            "name": "2.3 MultiJet 130 Euro7 2016-",
            "engineCode": "F1AGL411D"
          },
          {
            "name": "2.3 MultiJet 141 2020-",
            "engineCode": "F1AGL"
          },
          {
            "name": "2.3 MultiJet 150 Euro7 2016-",
            "engineCode": "F1AGL411A/C"
          },
          {
            "name": "2.3 MultiJet 180 Euro7 2016-",
            "engineCode": "F1AGL411B"
          }
        ]
      },
      {
        "name": "Scudo",
        "types": [
          {
            "name": "2.0 Multijet (128hk) 2012-",
            "engineCode": "RHO2"
          },
          {
            "name": "2.0 Multijet 146 2022-",
            "engineCode": "DW10F"
          },
          {
            "name": "2.0 Multijet 181 2022-",
            "engineCode": "DW10F"
          }
        ]
      }
    ]
  },
  {
    "make": "Ford",
    "models": [
      {
        "name": "B-Max",
        "types": [
          {
            "name": "1.0 Ecoboost 2012-",
            "engineCode": "10FDOX"
          },
          {
            "name": "1.4 Duratec 2012-",
            "engineCode": "Sigma"
          },
          {
            "name": "1.5 TDCi 2013-",
            "engineCode": "15DSOX"
          },
          {
            "name": "1.6 TDCi 2012-",
            "engineCode": "16DSOX"
          },
          {
            "name": "1.6 Ti-VCT 2013-",
            "engineCode": "Duratec"
          }
        ]
      },
      {
        "name": "C-Max",
        "types": [
          {
            "name": "1.0 EcoBoost 2012-",
            "engineCode": "C10FDOX"
          },
          {
            "name": "1.5 TDCi 121 2019-",
            "engineCode": "Duratorq"
          },
          {
            "name": "1.5 TDCi 2015-",
            "engineCode": "XWDB"
          },
          {
            "name": "1.5T EcoBoost 2015-",
            "engineCode": "M8DB"
          },
          {
            "name": "2.0 TDCi 151 2015-",
            "engineCode": "T7DB"
          }
        ]
      },
      {
        "name": "EcoSport",
        "types": [
          {
            "name": "1.5 EcoBlue 125 AWD 2019-",
            "engineCode": "Duratorq"
          },
          {
            "name": "1.5 TDCi 2016-",
            "engineCode": "Duratorq"
          },
          {
            "name": "1.5 Ti-VCT 2014-",
            "engineCode": "Duratec"
          }
        ]
      },
      {
        "name": "Edge",
        "types": [
          {
            "name": "2.0 TDCi 181 2017-",
            "engineCode": "Duratorq"
          },
          {
            "name": "2.0 TDCi 211 2017-",
            "engineCode": "Duratorq"
          }
        ]
      },
      {
        "name": "Fiesta",
        "types": [
          {
            "name": "1.0 EcoBoost 125 mHEV 2020-",
            "engineCode": "Ecoboost"
          },
          {
            "name": "1.0 EcoBoost 126 2020-",
            "engineCode": "Ecoboost"
          },
          {
            "name": "1.0T EcoBoost 2018-",
            "engineCode": "C10FDOX"
          },
          {
            "name": "1.1 2012-",
            "engineCode": "P4JA/P4JB"
          },
          {
            "name": "1.1 86 2018-",
            "engineCode": "C11FDOX"
          },
          {
            "name": "1.5 TDCi 2012-",
            "engineCode": "DV5"
          },
          {
            "name": "1.5 TDCi 86 2019-",
            "engineCode": "Duratorq"
          },
          {
            "name": "ST 1.7 2013-",
            "engineCode": "JTJA"
          }
        ]
      },
      {
        "name": "Focus",
        "types": [
          {
            "name": "III 1.0 EcoBoost 2012-",
            "engineCode": "0FDOX"
          },
          {
            "name": "III 1.5 TDCi 2015-",
            "engineCode": "15DSOX"
          },
          {
            "name": "III 2.0 TDCi 151 2015-",
            "engineCode": "T7DB"
          },
          {
            "name": "III RS 2.3 EcoBoost 351 2016-",
            "engineCode": "YVDA"
          },
          {
            "name": "III ST 2.0 TDCi 186 2015-",
            "engineCode": "T8DA"
          },
          {
            "name": "IV 1.0 EcoBoost 101 2020-",
            "engineCode": "Ecoboost"
          },
          {
            "name": "IV 1.0 EcoBoost 125 mHEV 2020-2025",
            "engineCode": "B7DA"
          },
          {
            "name": "IV 1.0 EcoBoost 125 mHEV Flex 2022-2025",
            "engineCode": "R0DA"
          },
          {
            "name": "IV 1.0 EcoBoost 126 2019-",
            "engineCode": "Ecoboost"
          },
          {
            "name": "IV 1.0 EcoBoost 155 mHEV 2020-2025",
            "engineCode": "M0DC"
          },
          {
            "name": "IV 1.5 EcoBlue 121 2020-",
            "engineCode": "Duratorq"
          },
          {
            "name": "IV 1.5 EcoBlue 96 2020-",
            "engineCode": "Duratorq"
          }
        ]
      },
      {
        "name": "Galaxy",
        "types": [
          {
            "name": "2.0 TDCi 121 2015-",
            "engineCode": "Duratorq"
          },
          {
            "name": "2.0 TDCi 151 2015-",
            "engineCode": "Duratorq"
          },
          {
            "name": "2.0 TDCi 181 2015-",
            "engineCode": "Duratorq"
          }
        ]
      },
      {
        "name": "Grand",
        "types": [
          {
            "name": "Tourneo Connect 1.5 EcoBlue 117 2025-",
            "engineCode": "DXDE"
          }
        ]
      },
      {
        "name": "Kuga",
        "types": [
          {
            "name": "1.5 EcoBlue 120 FWD 2020-",
            "engineCode": "Duratorq"
          },
          {
            "name": "1.5 EcoBoost 151 2020-",
            "engineCode": "Ecoboost"
          },
          {
            "name": "1.5 TDCi 121 2017-",
            "engineCode": "15DSOX"
          },
          {
            "name": "2.0 TDCi 151 2015-",
            "engineCode": "Duratorq"
          },
          {
            "name": "2.0 TDCi 181 2015-",
            "engineCode": "Duratorq"
          },
          {
            "name": "2.5 Hybrid 190 FWD 2021-",
            "engineCode": "GDC"
          },
          {
            "name": "2.5 Plug-In Hybrid 225 FWD 2020-",
            "engineCode": "GDA"
          }
        ]
      },
      {
        "name": "Mondeo",
        "types": [
          {
            "name": "V 2.0 EcoBoost 2015-",
            "engineCode": "Ecoboost"
          },
          {
            "name": "V 2.0 Hybrid 2015-",
            "engineCode": "UACA"
          },
          {
            "name": "V 2.0 Hybrid iVCT 188 2019-",
            "engineCode": "UACC"
          },
          {
            "name": "V 2.0 TDCi 151 2015-",
            "engineCode": "Duratorq"
          },
          {
            "name": "V 2.0 TDCi 181 2015-",
            "engineCode": "Duratorq"
          },
          {
            "name": "V 2.0 TDCi 211 2015-",
            "engineCode": "Duratorq"
          }
        ]
      },
      {
        "name": "Puma",
        "types": [
          {
            "name": "1.0 EcoBoost mHEV 126 2020-",
            "engineCode": "Ecoboost"
          }
        ]
      },
      {
        "name": "Ranger",
        "types": [
          {
            "name": "2.0 EcoBlue 171 2019-2022",
            "engineCode": "YN2X"
          },
          {
            "name": "2.0 EcoBlue 214 2019-2022",
            "engineCode": "YN2X"
          },
          {
            "name": "2.2 TDCi 2012-",
            "engineCode": "Duratorq"
          },
          {
            "name": "2.2 TDCi 2015-",
            "engineCode": "Duratorq"
          },
          {
            "name": "3.2 TDCi 2012-",
            "engineCode": "Duratorq"
          },
          {
            "name": "3.2 TDCi 2017-",
            "engineCode": "Duratorq"
          },
          {
            "name": "IV 2.0 EcoBlue 206 2023-",
            "engineCode": "YN2X"
          },
          {
            "name": "IV 2.3T EcoBoost PHEV 281 2023-",
            "engineCode": "N32S"
          },
          {
            "name": "Raptor III 2.0 EcoBlue 2019-2022",
            "engineCode": "YN2X"
          }
        ]
      },
      {
        "name": "S-Max",
        "types": [
          {
            "name": "2.0 TDCI 150/181 2015-",
            "engineCode": "Duratorq"
          }
        ]
      },
      {
        "name": "Talento",
        "types": [
          {
            "name": "1.6 EcoJet / MultiJet 2016-",
            "engineCode": "R9M"
          }
        ]
      },
      {
        "name": "Tourneo",
        "types": [
          {
            "name": "Connect 1.5 TDCi 75/100/121 2015-",
            "engineCode": "15DSOX"
          },
          {
            "name": "Connect 1.6 Ecoboost Automat 2014-",
            "engineCode": "JQGA"
          },
          {
            "name": "Connect 1.6 TDCi 2014-",
            "engineCode": "Duratorq"
          },
          {
            "name": "Connect III 1.5 EcoBlue 117 2025-",
            "engineCode": "DXDE"
          },
          {
            "name": "Connect III 2.0 EcoBlue 122 4WD 2022-",
            "engineCode": "DTRC"
          },
          {
            "name": "Connect III 2.0 EcoBlue 123 2022-",
            "engineCode": "DTRC"
          },
          {
            "name": "Courier 1.5 TDCi 2014-2018",
            "engineCode": "15DSOX"
          },
          {
            "name": "Courier 1.5 TDCi 2019-",
            "engineCode": "15DSOX"
          },
          {
            "name": "Courier 1.6 TDCi 2014-",
            "engineCode": "Duratorq"
          },
          {
            "name": "Custom 2.0 TDCi EcoBlue 130 mHEV 2020-",
            "engineCode": "PANTHER"
          },
          {
            "name": "Custom 2.0 TDCi EcoBlue 131 2020-",
            "engineCode": "PANTHER"
          },
          {
            "name": "Custom 2.0 TDCi EcoBlue 171 2020-",
            "engineCode": "PANTHER"
          },
          {
            "name": "Custom 2.0 TDCi EcoBlue 186 2020-",
            "engineCode": "PANTHER"
          },
          {
            "name": "Custom II 2.0 EcoBlue 150 FWD (BKFB) 2024-",
            "engineCode": "BKFB"
          },
          {
            "name": "Custom II 2.0 EcoBlue 150 FWD (ENFB) 2024-",
            "engineCode": "ENFB"
          },
          {
            "name": "Custom II 2.0 EcoBlue 170 AWD (BKAA - tourneo) 2024-",
            "engineCode": "BKAA"
          },
          {
            "name": "Custom II 2.0 EcoBlue 170 FWD (BKFA - tourneo) 2024-",
            "engineCode": "BKFA"
          },
          {
            "name": "Custom II 2.0 EcoBlue 170 FWD (ENBK - tourneo) 2024-",
            "engineCode": "ENBK"
          }
        ]
      },
      {
        "name": "Transit",
        "types": [
          {
            "name": "2.0 EcoBlue 165 RWD 2023-",
            "engineCode": "BLHA"
          },
          {
            "name": "2.0 TDCi 130 EcoBlue 4WD 2017-",
            "engineCode": "PANTHER"
          },
          {
            "name": "2.0 TDCi 170 EcoBlue 4WD 2017-",
            "engineCode": "PANTHER"
          },
          {
            "name": "2.0 TDCi EcoBlue 130 FWD 2020-",
            "engineCode": "PANTHER"
          },
          {
            "name": "2.0 TDCi EcoBlue 130 MHEV FWD 2020-",
            "engineCode": "PANTHER"
          },
          {
            "name": "2.0 TDCi EcoBlue 170 FWD 2020-",
            "engineCode": "PANTHER"
          },
          {
            "name": "2.0 TDCi EcoBlue 185 FWD 2020-",
            "engineCode": "PANTHER"
          },
          {
            "name": "2.0 TDCi EcoBlue 2016-",
            "engineCode": "PANTHER"
          },
          {
            "name": "2.2 TDCi (AWD) 2012-",
            "engineCode": "Duratorq"
          },
          {
            "name": "2.2 TDCi (FWD) 2012-",
            "engineCode": "Duratorq"
          },
          {
            "name": "2.2 TDCi (RWD) 2012-",
            "engineCode": "Duratorq"
          },
          {
            "name": "Connect 1.0 EcoBoost 100 E86 2022-",
            "engineCode": "B3GB"
          },
          {
            "name": "Connect 1.0 EcoBoost 101 2019-",
            "engineCode": "B3GA"
          },
          {
            "name": "Connect 1.5 EcoBoost 117 2025-",
            "engineCode": "DXDE"
          },
          {
            "name": "Connect 1.5 TDCi 100/121 2019-",
            "engineCode": "Duratorq"
          },
          {
            "name": "Connect 1.5 TDCi 75/100/121 2015-2018",
            "engineCode": "Duratorq"
          },
          {
            "name": "Connect 1.6 EcoBoost Automat 2014-",
            "engineCode": "JQGA"
          },
          {
            "name": "Connect 1.6 TDCi 2014-",
            "engineCode": "Duratorq"
          },
          {
            "name": "Courier 1.5 TDCi 2014-",
            "engineCode": "15DSOX"
          },
          {
            "name": "Courier 1.6 TDCi 2014-",
            "engineCode": "Duratorq"
          },
          {
            "name": "Courier II 1.0 EcoBoost 101 2024-",
            "engineCode": "B3DA"
          },
          {
            "name": "Courier II 1.0 EcoBoost 126 2024-",
            "engineCode": "B7JB"
          },
          {
            "name": "Custom 2.0 TDCi EcoBlue 130 mHEV 2020-",
            "engineCode": "PANTHER"
          },
          {
            "name": "Custom 2.0 TDCi EcoBlue 131 2020-",
            "engineCode": "PANTHER"
          },
          {
            "name": "Custom 2.0 TDCi EcoBlue 171 2020-",
            "engineCode": "PANTHER"
          },
          {
            "name": "Custom 2.0 TDCi EcoBlue 186 2020-",
            "engineCode": "PANTHER"
          },
          {
            "name": "Custom 2.0 TDCi EcoBlue 2016-",
            "engineCode": "PANTHER"
          },
          {
            "name": "Custom 2.2 TDCi 2013-",
            "engineCode": "Duratorq"
          },
          {
            "name": "Custom II 2.0 EcoBlue 150 FWD (ENBK - transit) 2024-",
            "engineCode": "ENBK"
          },
          {
            "name": "Custom II 2.0 EcoBlue 170 AWD (BKAA - transit) 2024-",
            "engineCode": "BKAA"
          },
          {
            "name": "Custom II 2.0 EcoBlue 170 AWD (ENBK - transit) 2024-",
            "engineCode": "ENBK"
          },
          {
            "name": "Custom II 2.0 EcoBlue 170 FWD (BKFA - transit) 2024-",
            "engineCode": "BKFA"
          }
        ]
      }
    ]
  },
  {
    "make": "Honda",
    "models": [
      {
        "name": "CR-V",
        "types": [
          {
            "name": "IV 1.6 i-DTEC 2013-",
            "engineCode": "N16A2"
          },
          {
            "name": "IV 1.6 i-DTEC 4WD 2015-",
            "engineCode": "N16A4"
          },
          {
            "name": "IV 2.0i-VTEC 2012-",
            "engineCode": "R20A9"
          },
          {
            "name": "IV 2.2 i-DTEC 2012-",
            "engineCode": "N22B4"
          },
          {
            "name": "V 1.5 VTEC Turbo CVT [Aut] 2019-",
            "engineCode": "L15BY"
          },
          {
            "name": "V 1.5 VTEC Turbo Manuell 2019-",
            "engineCode": "L15BY"
          },
          {
            "name": "V 2.0 i MMD-Hybrid 2WD 2019-",
            "engineCode": "LFB1"
          },
          {
            "name": "V 2.0 i MMD-Hybrid 4WD 2019-",
            "engineCode": "LFB1"
          },
          {
            "name": "VI 2.0 e:HEV 184 2WD 2023-",
            "engineCode": "LFC"
          },
          {
            "name": "VI 2.0 e:HEV 184 AWD 2023-",
            "engineCode": "LFC"
          },
          {
            "name": "VI 2.0 e:HEV 207 2WD 2023-",
            "engineCode": "LFC"
          },
          {
            "name": "VI 2.0 e:HEV 207 AWD 2023-",
            "engineCode": "LFC"
          },
          {
            "name": "VI 2.0 e:PHEV 185 2023-",
            "engineCode": "LFC"
          }
        ]
      },
      {
        "name": "Civic",
        "types": [
          {
            "name": "1.0 VTEC Turbo 2017-",
            "engineCode": "10A2"
          },
          {
            "name": "1.4 i-VTEC 2012-",
            "engineCode": "L13Z4"
          },
          {
            "name": "1.5 VTEC Turbo CVT [Aut] 2017-",
            "engineCode": "L15BA"
          },
          {
            "name": "1.5 VTEC Turbo Manuell 2017-",
            "engineCode": "L15B7"
          },
          {
            "name": "1.6 i-DTEC 2013-",
            "engineCode": "N16A1"
          },
          {
            "name": "1.8 i-VTEC 2012-",
            "engineCode": "R18Z4"
          },
          {
            "name": "2.2 i-DTEC 2012-",
            "engineCode": "N22B4"
          }
        ]
      },
      {
        "name": "HR-V",
        "types": [
          {
            "name": "II 1.5 i-VTEC 131 2015-",
            "engineCode": "L15B4"
          },
          {
            "name": "II 1.5 VTEC Turbo [Aut] 2019-",
            "engineCode": "L15BY"
          },
          {
            "name": "II 1.5 VTEC Turbo [Man] 2019-",
            "engineCode": "L15BY"
          },
          {
            "name": "II 1.6 i-DTEC 2016-",
            "engineCode": "N16A3"
          },
          {
            "name": "II e:HEV 1.5 i-MMD 2022-",
            "engineCode": "LEC3"
          }
        ]
      },
      {
        "name": "Jazz",
        "types": [
          {
            "name": "III 1.3 Hybrid 2012-",
            "engineCode": "LDA3"
          },
          {
            "name": "IV 1.3 i-VTEC 2016-",
            "engineCode": "L13B2"
          },
          {
            "name": "IV 1.5 i-VTEC 131 2018-",
            "engineCode": "L15B3"
          },
          {
            "name": "IV e:HEV 1.5 i-MMD 2021-",
            "engineCode": "LEB8"
          }
        ]
      },
      {
        "name": "ZR-V",
        "types": [
          {
            "name": "2.0 e:HEV 141 2WD 2023-",
            "engineCode": "LFC"
          },
          {
            "name": "2.0 e:HEV 141 AWD 2023-",
            "engineCode": "LFC"
          },
          {
            "name": "2.0 e:HEV 185 2023-",
            "engineCode": "LFC"
          }
        ]
      }
    ]
  },
  {
    "make": "Hyundai",
    "models": [
      {
        "name": "Bayon",
        "types": [
          {
            "name": "1.0 T-GDi 2021-",
            "engineCode": "G3LE"
          },
          {
            "name": "1.0 T-GDi mHEV 48V 2021-",
            "engineCode": "G3LF"
          },
          {
            "name": "1.25 MPi 85 2021-",
            "engineCode": "G4LF"
          }
        ]
      },
      {
        "name": "Grand",
        "types": [
          {
            "name": "Santa Fe 2.2 CRDi 2017-",
            "engineCode": "D4HB"
          }
        ]
      },
      {
        "name": "Ioniq",
        "types": [
          {
            "name": "Hybrid 2016-",
            "engineCode": "G4LE"
          }
        ]
      },
      {
        "name": "Santa",
        "types": [
          {
            "name": "Fe III 2.2 CRDi 2016-2020",
            "engineCode": "D4HB"
          },
          {
            "name": "Fe IV 1.6 T-GDi 180 Hybrid 2021-2023",
            "engineCode": "G4FP"
          },
          {
            "name": "Fe IV 1.6 T-GDi 230 Hybrid 2021-2023",
            "engineCode": "G4FT"
          },
          {
            "name": "Fe IV 2.2 CRDi 2021-2023",
            "engineCode": "D4HE"
          }
        ]
      },
      {
        "name": "Tucson",
        "types": [
          {
            "name": "1.6 CRDi 2019-",
            "engineCode": "D4FE"
          },
          {
            "name": "1.6 GDi 2015-",
            "engineCode": "G4FD"
          },
          {
            "name": "1.6 T-GDi (Automat) 2015-",
            "engineCode": "G4FJ"
          },
          {
            "name": "1.6 T-GDi (Manuell) 2015-",
            "engineCode": "G4FJ"
          },
          {
            "name": "1.6 T-GDi 150 mHEV 2021-",
            "engineCode": "G4FU"
          },
          {
            "name": "1.6 T-GDi 180 4WD mHEV 2021-",
            "engineCode": "G4FU"
          },
          {
            "name": "1.6 T-GDi 230 4WD Hybrid 2021-",
            "engineCode": "G4FT"
          },
          {
            "name": "1.6 T-GDi 230 Hybrid 2021-",
            "engineCode": "G4FT"
          },
          {
            "name": "1.6 T-GDi 265 PHEV 4WD (G4FP) 2021-",
            "engineCode": "G4FP"
          },
          {
            "name": "1.6 T-GDi 265 PHEV 4WD (G4FT) 2021-",
            "engineCode": "G4FT"
          },
          {
            "name": "1.7 CRDi 2016-",
            "engineCode": "D4FD"
          },
          {
            "name": "2.0 CRDi 2015-",
            "engineCode": "D4HA"
          },
          {
            "name": "2.0 CRDi Mildhybrid 2019-",
            "engineCode": "D4HA"
          }
        ]
      },
      {
        "name": "i10",
        "types": [
          {
            "name": "1.0 MPi 2020-",
            "engineCode": "G3LD"
          },
          {
            "name": "1.1 2019-",
            "engineCode": "G3LA"
          }
        ]
      },
      {
        "name": "i20",
        "types": [
          {
            "name": "1.0 T-GDi 2016-",
            "engineCode": "G3LC"
          },
          {
            "name": "1.0 T-GDi 2021-",
            "engineCode": "G3LE"
          },
          {
            "name": "1.0 T-GDi mHEV 2021-",
            "engineCode": "G3LF"
          },
          {
            "name": "1.1 CRDi 2012-",
            "engineCode": "D3FA"
          },
          {
            "name": "1.1 CRDi 2015-",
            "engineCode": "D3FA"
          },
          {
            "name": "1.2 MPi 85 2021-",
            "engineCode": "G4LF"
          },
          {
            "name": "1.3 2015-",
            "engineCode": "G4LA"
          },
          {
            "name": "1.4 MPI 2012-",
            "engineCode": "G4FA"
          },
          {
            "name": "1.5 2015-",
            "engineCode": "G4LC"
          }
        ]
      },
      {
        "name": "i30",
        "types": [
          {
            "name": "1.0 T-GDi 120 mHEV 2021-",
            "engineCode": "G3LF"
          },
          {
            "name": "1.0 T-GDi 2017-",
            "engineCode": "G3LC"
          },
          {
            "name": "1.4 CRDi 2012-",
            "engineCode": "D4FC"
          },
          {
            "name": "1.4 MPI 2012-",
            "engineCode": "G4FA"
          },
          {
            "name": "1.4 T-GDi 2017-",
            "engineCode": "G4LD"
          },
          {
            "name": "1.5 2015-",
            "engineCode": "G4LC"
          },
          {
            "name": "1.5 DPi 111 2021-",
            "engineCode": "G4LG"
          },
          {
            "name": "1.5 T-GDi 159 mHEV 2021-",
            "engineCode": "G4LK"
          },
          {
            "name": "1.6 CRDI 2014-",
            "engineCode": "D4FB"
          },
          {
            "name": "1.6 GDi 2012-",
            "engineCode": "G4FD"
          },
          {
            "name": "1.6 GDi 2015-",
            "engineCode": "G4FD"
          },
          {
            "name": "1.6 T 2015-",
            "engineCode": "G4FS"
          }
        ]
      },
      {
        "name": "i30N",
        "types": [
          {
            "name": "2.0 Performance 276 2018-",
            "engineCode": "G4KH"
          },
          {
            "name": "2.0T-GDi 251 2018-",
            "engineCode": "G4KH"
          }
        ]
      },
      {
        "name": "i40",
        "types": [
          {
            "name": "1.7 CRDi 2015-",
            "engineCode": "D4FD"
          }
        ]
      },
      {
        "name": "ix20",
        "types": [
          {
            "name": "1.4 CRDi 2015-",
            "engineCode": "D4FC"
          },
          {
            "name": "1.6 CRDi 2015-",
            "engineCode": "D4FB"
          },
          {
            "name": "1.7 2015-",
            "engineCode": "G4FC"
          }
        ]
      },
      {
        "name": "ix35",
        "types": [
          {
            "name": "1.7 CRDi 2013-",
            "engineCode": "D4FD"
          }
        ]
      }
    ]
  },
  {
    "make": "Jeep",
    "models": [
      {
        "name": "Cherokee",
        "types": [
          {
            "name": "2.0 CRD 2014-",
            "engineCode": "EBT"
          },
          {
            "name": "2.2 CRD 2016-",
            "engineCode": "LAU"
          }
        ]
      },
      {
        "name": "Compass",
        "types": [
          {
            "name": "1.3 GSE PHEV T4 4xe 2020-",
            "engineCode": "46337540"
          },
          {
            "name": "1.4 Multiair 2017-",
            "engineCode": "55263623.0"
          },
          {
            "name": "2.0 CRD 140 4x5 2018-",
            "engineCode": "55263087.0"
          },
          {
            "name": "2.0 CRD 170 4x5 2018-",
            "engineCode": "55263088.0"
          }
        ]
      },
      {
        "name": "Grand",
        "types": [
          {
            "name": "Cherokee IV 3.6 FlexFuel 4x5 2017-",
            "engineCode": "entastar"
          }
        ]
      },
      {
        "name": "Renegade",
        "types": [
          {
            "name": "1.0 GSE (T-GDI) 121 2019-",
            "engineCode": "55282151.0"
          },
          {
            "name": "1.3 GSE 180hk AWD 2019-",
            "engineCode": "55282328"
          },
          {
            "name": "1.3 GSE PHEV 240 T4 4xe 2020-",
            "engineCode": "46337540"
          },
          {
            "name": "1.4 140hk 2015-",
            "engineCode": "EAM"
          },
          {
            "name": "1.6 120hk 2015-",
            "engineCode": "EJK"
          },
          {
            "name": "1.6 E-Torq 110 hk 2015-",
            "engineCode": "55263842.0"
          },
          {
            "name": "2.0 140hk 2015-",
            "engineCode": "EBT"
          },
          {
            "name": "2.0 170hk 2015-",
            "engineCode": "940.A4.000"
          }
        ]
      },
      {
        "name": "Wrangler",
        "types": [
          {
            "name": "IV (JL) 2.0T 273 2018-",
            "engineCode": "EC1"
          }
        ]
      }
    ]
  },
  {
    "make": "Kia",
    "models": [
      {
        "name": "Carens",
        "types": [
          {
            "name": "1.6 GDi 2013-",
            "engineCode": "G4FD"
          },
          {
            "name": "1.7 CRDi 2013-",
            "engineCode": "D4FD"
          }
        ]
      },
      {
        "name": "Cee´d",
        "types": [
          {
            "name": "1.0 T-GDi 2016-",
            "engineCode": "G3LC"
          },
          {
            "name": "1.0 T-GDi 2019-",
            "engineCode": "G3LC"
          },
          {
            "name": "1.4 T-GDi 2019-",
            "engineCode": "G4LD"
          },
          {
            "name": "1.5 2016-",
            "engineCode": "G4LC"
          },
          {
            "name": "1.6 CRDi 2014-",
            "engineCode": "D4FB"
          },
          {
            "name": "1.6 CRDi 2019-",
            "engineCode": "D4FE"
          },
          {
            "name": "1.6 DCT Plug-In Hybrid 2020-",
            "engineCode": "G4LE"
          },
          {
            "name": "1.6 GDi 2012-",
            "engineCode": "G4FD"
          },
          {
            "name": "1.6 GT 2014-",
            "engineCode": "G4FJ"
          }
        ]
      },
      {
        "name": "Niro",
        "types": [
          {
            "name": "1.6 GDi Hybrid 142 2023-",
            "engineCode": "G4LL"
          },
          {
            "name": "1.6 GDi Plug-In Hybrid 184 2023-",
            "engineCode": "G4LL"
          },
          {
            "name": "Hybrid 1.7 2016-",
            "engineCode": "G4LE"
          }
        ]
      },
      {
        "name": "Optima",
        "types": [
          {
            "name": "1.7 CRDi 2012-",
            "engineCode": "D4FD"
          },
          {
            "name": "2.0 Hybrid 2013-",
            "engineCode": "G4NE"
          },
          {
            "name": "2.0 Plug-In Hybrid 2017-",
            "engineCode": "G4NG"
          },
          {
            "name": "2.1 2012-",
            "engineCode": "G4ND"
          },
          {
            "name": "GT 2.0 T-GDi 246 2017-",
            "engineCode": "G4KH"
          },
          {
            "name": "SW 1.6 T-GDi DCT8 2018-",
            "engineCode": "G4FJ"
          },
          {
            "name": "SW 2.0 Plug-In Hybrid 2018-",
            "engineCode": "G4NG"
          }
        ]
      },
      {
        "name": "Picanto",
        "types": [
          {
            "name": "1.0 MPi 2021-",
            "engineCode": "G3LD"
          },
          {
            "name": "1.1 2017-",
            "engineCode": "G3LA"
          },
          {
            "name": "1.2 MPi 2021-",
            "engineCode": "G4LF"
          },
          {
            "name": "1.3 2017-",
            "engineCode": "G4LA"
          },
          {
            "name": "III 1.0 T-Gdi 101 2017-",
            "engineCode": "G3LC"
          }
        ]
      },
      {
        "name": "ProCeed",
        "types": [
          {
            "name": "1.4 T-GDi 2019-",
            "engineCode": "G4LD"
          },
          {
            "name": "1.6 T-GDi DCT 2019-",
            "engineCode": "G4FJ"
          }
        ]
      },
      {
        "name": "Rio",
        "types": [
          {
            "name": "1.0 T-GDi 120 mHEV DCT 2021-",
            "engineCode": "G3LF"
          },
          {
            "name": "1.0 T-GDi 2017-",
            "engineCode": "G3LC"
          },
          {
            "name": "1.2 MPi 85 2020-",
            "engineCode": "G4LF"
          },
          {
            "name": "1.26 2017-",
            "engineCode": "G4LA"
          },
          {
            "name": "1.5 2016-",
            "engineCode": "G4FA"
          },
          {
            "name": "1.5 2017-",
            "engineCode": "G4LC"
          }
        ]
      },
      {
        "name": "Sorento",
        "types": [
          {
            "name": "1.6 T-GDi 265 AWD Plug-in Hybrid 2021-",
            "engineCode": "G4FT"
          },
          {
            "name": "2.2 CRDi 2015-",
            "engineCode": "D4HB"
          },
          {
            "name": "2.2 CRDi 2021-",
            "engineCode": "D4HE"
          }
        ]
      },
      {
        "name": "Soul",
        "types": [
          {
            "name": "1.6 CRDi 2013-",
            "engineCode": "D4FB"
          },
          {
            "name": "1.6 GDI 2014-",
            "engineCode": "G4FD"
          },
          {
            "name": "1.6 T-GDI 205 2017-",
            "engineCode": "G4FJ"
          }
        ]
      },
      {
        "name": "Sportage",
        "types": [
          {
            "name": "1.6 CRDi 2019-",
            "engineCode": "D4FE"
          },
          {
            "name": "1.6 GDI 2016-",
            "engineCode": "G4FD"
          },
          {
            "name": "1.6 T-GDi (Automat) 2016-",
            "engineCode": "G4FJ"
          },
          {
            "name": "1.6 T-GDi 180 AWD MHEV (G4FP) 2022-",
            "engineCode": "G4FP"
          },
          {
            "name": "1.6 T-GDi 180 AWD MHEV (G4FU) 2022-",
            "engineCode": "G4FU"
          },
          {
            "name": "1.6 T-GDi 230 Hybrid 2022-",
            "engineCode": "G4FT"
          },
          {
            "name": "1.6 T-GDi 265 AWD Plug-in Hybrid 2022-",
            "engineCode": "G4FT"
          },
          {
            "name": "1.7 CRDi 2014-",
            "engineCode": "D4FD"
          },
          {
            "name": "2.0 CRDi 2016-",
            "engineCode": "D4HA"
          },
          {
            "name": "2.0 CRDi ECODynamics+ 2019-",
            "engineCode": "D4HA"
          },
          {
            "name": "2.0 GDI 2014-",
            "engineCode": "G4NC"
          }
        ]
      },
      {
        "name": "Stinger",
        "types": [
          {
            "name": "2.0 T-GDi 2018-",
            "engineCode": "G4KL"
          },
          {
            "name": "2.2 CRDi 2018-",
            "engineCode": "D4HC"
          },
          {
            "name": "3.3 T-GDi 2018-",
            "engineCode": "G6DP"
          }
        ]
      },
      {
        "name": "Stonic",
        "types": [
          {
            "name": "1.0 T-GDi 120 mHEV 2021-",
            "engineCode": "G3LF"
          },
          {
            "name": "1.0 T-GDi 2018-",
            "engineCode": "G3LC"
          },
          {
            "name": "1.3 2018-",
            "engineCode": "G4LA"
          },
          {
            "name": "1.5 2018-",
            "engineCode": "G4LC"
          }
        ]
      },
      {
        "name": "Venga",
        "types": [
          {
            "name": "1.4 CRDi 2015-",
            "engineCode": "D4FC"
          },
          {
            "name": "1.5 2016-",
            "engineCode": "G4FA"
          },
          {
            "name": "1.7 2016-",
            "engineCode": "G4FC"
          }
        ]
      },
      {
        "name": "XCeed",
        "types": [
          {
            "name": "1.0 T-GDi 2019-",
            "engineCode": "G3LC"
          },
          {
            "name": "1.4 T-GDi 2019-",
            "engineCode": "G4LD"
          },
          {
            "name": "1.5 T-GDi 2021-",
            "engineCode": "G4LH"
          },
          {
            "name": "1.6 DCT Plug-In Hybrid 2020-",
            "engineCode": "G4LE"
          },
          {
            "name": "1.6 T-GDi 2019-",
            "engineCode": "G4FJ"
          }
        ]
      }
    ]
  },
  {
    "make": "Land Rover",
    "models": [
      {
        "name": "Range",
        "types": [
          {
            "name": "Rover 3.0 TD 2013-",
            "engineCode": "306DT"
          }
        ]
      }
    ]
  },
  {
    "make": "Lexus",
    "models": [
      {
        "name": "ES",
        "types": [
          {
            "name": "300h 2.5 Hybrid 219 2019-",
            "engineCode": "A25A-FXS"
          }
        ]
      },
      {
        "name": "GS",
        "types": [
          {
            "name": "250 2.5 V7 2012-",
            "engineCode": "4GR-FSE"
          }
        ]
      },
      {
        "name": "IS",
        "types": [
          {
            "name": "300h 2013-",
            "engineCode": "2AR-FSE"
          }
        ]
      },
      {
        "name": "LM",
        "types": [
          {
            "name": "350h 2.5 Hybrid AWD 251 2023-",
            "engineCode": "A25A-FXS"
          }
        ]
      },
      {
        "name": "NX",
        "types": [
          {
            "name": "300h 2014-",
            "engineCode": "2AR-FXE"
          },
          {
            "name": "II 350h 2.5 Hybrid 243 2022-",
            "engineCode": "A25A-FXS"
          },
          {
            "name": "II 450h+ 2.5 PHEV 307 2022-",
            "engineCode": "A25A-FXS"
          }
        ]
      },
      {
        "name": "RX",
        "types": [
          {
            "name": "350h 2.5 Hybrid AWD 246 2023-",
            "engineCode": "A25A-FXS"
          },
          {
            "name": "450h+ 2.5 PHEV 307 2023-",
            "engineCode": "A25A-FXS"
          }
        ]
      },
      {
        "name": "UX",
        "types": [
          {
            "name": "250h 2.0 2WD/AWD 2019-",
            "engineCode": "M20A-FXS"
          }
        ]
      }
    ]
  },
  {
    "make": "MG",
    "models": [
      {
        "name": "EHS",
        "types": [
          {
            "name": "1.5 TGI PHEV 2021-",
            "engineCode": "5E4E"
          }
        ]
      },
      {
        "name": "HS",
        "types": [
          {
            "name": "PHEV 2024-",
            "engineCode": "5E4E"
          }
        ]
      }
    ]
  },
  {
    "make": "Mazda",
    "models": [
      {
        "name": "3",
        "types": [
          {
            "name": "1.5 Hybrid 116 2022-",
            "engineCode": "M15A"
          },
          {
            "name": "1.5 Skyactiv-G 115 2015-",
            "engineCode": "P5"
          },
          {
            "name": "1.5 Skyactiv-G 75 2015-",
            "engineCode": "P5"
          },
          {
            "name": "1.5 Skyactiv-G 90 2015-",
            "engineCode": "P5"
          }
        ]
      },
      {
        "name": "4",
        "types": [
          {
            "name": "1.5 Skyactiv-D 105 Manuell 2016-",
            "engineCode": "S5"
          },
          {
            "name": "1.5 Skyactiv-G 100 2014-",
            "engineCode": "P5"
          },
          {
            "name": "1.5 Skyactiv-G 100 2017-",
            "engineCode": "P5"
          },
          {
            "name": "1.5 Skyactiv-G 120 2014-",
            "engineCode": "P5"
          },
          {
            "name": "1.5 Skyactiv-G 120 2017-",
            "engineCode": "P5"
          },
          {
            "name": "2.0 Skyactiv-G 120 2014-",
            "engineCode": "PE"
          },
          {
            "name": "2.0 Skyactiv-G 120 2017-",
            "engineCode": "PE"
          },
          {
            "name": "2.0 Skyactiv-G 122 2019-",
            "engineCode": "PE"
          },
          {
            "name": "2.0 Skyactiv-G 122 M-Hybrid 2019-",
            "engineCode": "PEXN"
          },
          {
            "name": "2.0 Skyactiv-G 150 2014-",
            "engineCode": "PE"
          },
          {
            "name": "2.0 Skyactiv-G 165 2014-",
            "engineCode": "PE"
          },
          {
            "name": "2.0 Skyactiv-X 180 M-Hybrid 2020-",
            "engineCode": "HF"
          },
          {
            "name": "2.2 D Automat 2013-",
            "engineCode": "SH"
          },
          {
            "name": "2.2 DE 150 Manuell 2013-",
            "engineCode": "SH"
          },
          {
            "name": "2.5 e-Skyactiv G 140 2WD 2024-",
            "engineCode": "PY"
          }
        ]
      },
      {
        "name": "7.0",
        "types": [
          {
            "name": "2 2013-",
            "engineCode": "PE"
          },
          {
            "name": "2.2 D Automat 2013-",
            "engineCode": "SH"
          },
          {
            "name": "2.2 DE 150 AWD Manuell 2015-",
            "engineCode": "SH"
          },
          {
            "name": "2.2 DE 150 Manuell 2013-",
            "engineCode": "SH"
          },
          {
            "name": "2.2 DE 175 AWD Aut 2015-",
            "engineCode": "SH"
          },
          {
            "name": "2.2 DE 175 AWD Manuell 2015-",
            "engineCode": "SH"
          },
          {
            "name": "2.2 DE 175 Manuell 2013-",
            "engineCode": "SH"
          },
          {
            "name": "2.5 2013-2018",
            "engineCode": "PY"
          }
        ]
      },
      {
        "name": "CX-3",
        "types": [
          {
            "name": "1.5 Skyactiv-D 105 AWD 2015-",
            "engineCode": "S5"
          },
          {
            "name": "2.0 Skyactiv-G 2WD 2015-",
            "engineCode": "PE"
          }
        ]
      },
      {
        "name": "CX-30",
        "types": [
          {
            "name": "2.0 Skyactiv-G 122 2WD Mildhybrid 2019-",
            "engineCode": "PE"
          },
          {
            "name": "2.0 Skyactiv-G 150 2WD Mildhybrid 2020-",
            "engineCode": "PE"
          },
          {
            "name": "2.0 Skyactiv-X 180 4x4 MHEV 2020-",
            "engineCode": "HF"
          },
          {
            "name": "2.0 Skyactiv-X 180 MHEV 2020-",
            "engineCode": "HF"
          },
          {
            "name": "2.5 e-Skyactiv G 140 2WD 2024-",
            "engineCode": "PY"
          }
        ]
      },
      {
        "name": "CX-5",
        "types": [
          {
            "name": "2.0 165 2WD 2017-",
            "engineCode": "PE"
          },
          {
            "name": "2.0 2WD 2012-",
            "engineCode": "PE"
          },
          {
            "name": "2.0 4WD 2012-",
            "engineCode": "PE"
          },
          {
            "name": "2.2 D 150 4WD (Automat) 2017-",
            "engineCode": "SH"
          },
          {
            "name": "2.2 D 150 4WD (Manuell) 2014-",
            "engineCode": "SH"
          },
          {
            "name": "2.2 D 150 FWD (Automat) 2017-",
            "engineCode": "SH"
          },
          {
            "name": "2.2 D 175 4WD 2014-",
            "engineCode": "SH"
          },
          {
            "name": "2.2 D 175 FWD (Automat) 2017-",
            "engineCode": "SH"
          },
          {
            "name": "2.2 D 184 AWD Adblue 2019-",
            "engineCode": "SHY"
          },
          {
            "name": "2.2 D 2WD (Automat) 2012-",
            "engineCode": "SH"
          },
          {
            "name": "2.2 D 2WD (Manuell) 2012-",
            "engineCode": "SH"
          },
          {
            "name": "2.2 D 4WD (Automat) 2012-",
            "engineCode": "SH"
          },
          {
            "name": "2.2 D 4WD (Manuell) 2012-",
            "engineCode": "SH"
          },
          {
            "name": "2.2 DE 150 2WD (Manuell) 2014-",
            "engineCode": "SH"
          },
          {
            "name": "2.5 194 4WD (Automat) 2017-",
            "engineCode": "PY"
          },
          {
            "name": "2.5 Skyactiv G 4WD (Automat) 2015-",
            "engineCode": "PY"
          }
        ]
      },
      {
        "name": "CX-60",
        "types": [
          {
            "name": "2.5 e-Skyactiv PHEV 2022-",
            "engineCode": "PYZR"
          },
          {
            "name": "3.3 e-Skyactiv D 2023-",
            "engineCode": "T3Y4"
          }
        ]
      }
    ]
  },
  {
    "make": "Mercedes Benz",
    "models": [
      {
        "name": "A",
        "types": [
          {
            "name": "160 CDI [W176] 2013-",
            "engineCode": "OM607"
          },
          {
            "name": "180 [W176] 2012-",
            "engineCode": "M270.910"
          },
          {
            "name": "180 [W177] 2018-",
            "engineCode": "M282.914"
          },
          {
            "name": "180 CDI [W176] (OM607) 2012-",
            "engineCode": "OM607"
          },
          {
            "name": "180 CDI [W176] (OM651) 2012-",
            "engineCode": "OM651"
          },
          {
            "name": "180 d [W177] 2018-",
            "engineCode": "OM608.915"
          },
          {
            "name": "200 [W176] 2012-",
            "engineCode": "M270.910"
          },
          {
            "name": "200 [W177] 2018-",
            "engineCode": "M282.914"
          },
          {
            "name": "200 CDI [W176] 2012-2016",
            "engineCode": "OM651"
          },
          {
            "name": "200 CDI 4MATIC [W176] 2014-2016",
            "engineCode": "OM651"
          },
          {
            "name": "200 d [W176] 2017-",
            "engineCode": "OM651"
          },
          {
            "name": "200 d [W177] 2019-",
            "engineCode": "OM654.920"
          },
          {
            "name": "220 [W177] 2018-",
            "engineCode": "M260.920"
          },
          {
            "name": "220 4MATIC [W176] 2014-",
            "engineCode": "M270.920"
          },
          {
            "name": "220 CDI [W176] 2012-2016",
            "engineCode": "OM651"
          },
          {
            "name": "220 CDI 4MATIC [W176] 2012-2016",
            "engineCode": "OM651"
          },
          {
            "name": "220 d [W176] 2017-",
            "engineCode": "OM651"
          },
          {
            "name": "220 d [W177] 2019-",
            "engineCode": "OM654.920"
          },
          {
            "name": "250 [W176] 2012-",
            "engineCode": "M270.920"
          },
          {
            "name": "250 [W177] 2018-",
            "engineCode": "M260.920"
          },
          {
            "name": "250 4MATIC [W176] 2012-",
            "engineCode": "M270.920"
          },
          {
            "name": "250 e Hybrid [W177] 2020-",
            "engineCode": "M282.914"
          },
          {
            "name": "45 AMG 4MATIC [W176] 2013-",
            "engineCode": "M133.980"
          }
        ]
      },
      {
        "name": "B",
        "types": [
          {
            "name": "160 CDI [W246] 2013-",
            "engineCode": "OM607"
          },
          {
            "name": "180 [W246] (Automat/7G-DCT) 2016-",
            "engineCode": "M270.910"
          },
          {
            "name": "180 [W247] 2019-",
            "engineCode": "M282.914"
          },
          {
            "name": "180 CDI [W246] 2013-",
            "engineCode": "OM607"
          },
          {
            "name": "180 d [W247] 2019-",
            "engineCode": "OM608.915"
          },
          {
            "name": "200 [W247] 2019-",
            "engineCode": "M282.914"
          },
          {
            "name": "200 CDI BlueEFFICIENCY [W246] 2011-2016",
            "engineCode": "OM651"
          },
          {
            "name": "200 d [W246] 2017-",
            "engineCode": "OM651"
          },
          {
            "name": "200 d [W247] 2019-",
            "engineCode": "OM654.920"
          },
          {
            "name": "220 [W246] 2013-",
            "engineCode": "M270.920"
          },
          {
            "name": "220 CDI [W246] 2012-2016",
            "engineCode": "OM651"
          },
          {
            "name": "220 CDI 4MATIC [W246] 2014-2016",
            "engineCode": "OM651"
          },
          {
            "name": "220 d [W246] 2017-",
            "engineCode": "OM651"
          },
          {
            "name": "220 d [W247] 2019-",
            "engineCode": "OM654.920"
          },
          {
            "name": "250 [W246] 2012-",
            "engineCode": "M270.920"
          },
          {
            "name": "250 e Hybrid [W247] 2020-",
            "engineCode": "M282.914"
          }
        ]
      },
      {
        "name": "C",
        "types": [
          {
            "name": "180 [C/S/W204] (Automat) 2012-",
            "engineCode": "M274.910"
          },
          {
            "name": "180 [W/S205] (Automat/7G-TRONIC) 2015-",
            "engineCode": "M274"
          },
          {
            "name": "180 [W/S205] (Automat/9G-TRONIC) 2017-",
            "engineCode": "M274"
          },
          {
            "name": "180 [W206] 2021-",
            "engineCode": "M254"
          },
          {
            "name": "180 BlueTEC [W/S205] 2015-",
            "engineCode": "OM626"
          },
          {
            "name": "200 [W/S205] (Automat/7G-TRONIC) 2015-",
            "engineCode": "M274"
          },
          {
            "name": "200 [W/S205] (Automat/9G-TRONIC) 2017-",
            "engineCode": "M274"
          },
          {
            "name": "200 [W206] 2021-",
            "engineCode": "M254"
          },
          {
            "name": "200 2WD [W/S205] 2019-",
            "engineCode": "M264.915"
          },
          {
            "name": "200 4MATIC [W/S205] (Automat/9G-TRONIC) 2015-",
            "engineCode": "M274"
          },
          {
            "name": "200 4MATIC [W206] 2021-",
            "engineCode": "M254"
          },
          {
            "name": "200 BlueTEC [W/S205] 2015-",
            "engineCode": "OM626"
          },
          {
            "name": "200 d [W/S205] 2015-",
            "engineCode": "OM651"
          },
          {
            "name": "200 d [W/S205] 2019-",
            "engineCode": "OM654"
          },
          {
            "name": "220 BlueTEC [W/S205] 2014-",
            "engineCode": "OM651"
          },
          {
            "name": "220 d [W/S205] 2015-",
            "engineCode": "OM651"
          },
          {
            "name": "220 d [W/S205] 2019-",
            "engineCode": "OM654"
          },
          {
            "name": "220 d [W/S206] 2021-",
            "engineCode": "OM654"
          },
          {
            "name": "220 d 4MATIC [W/S205] 2015-",
            "engineCode": "OM651"
          },
          {
            "name": "250 [W/S205] (Automat/7G-TRONIC) 2015-",
            "engineCode": "M274"
          },
          {
            "name": "250 BlueTEC [W/S205] 2014-",
            "engineCode": "OM651"
          },
          {
            "name": "250 d [W/S205] 2015-",
            "engineCode": "OM651"
          },
          {
            "name": "300 d [W/S205] 2019-",
            "engineCode": "OM654"
          },
          {
            "name": "300 de Hybrid [W/S205] 2020-",
            "engineCode": "OM654"
          },
          {
            "name": "300 e Hybrid [W/S205] 2020-",
            "engineCode": "M274"
          },
          {
            "name": "350 e Hybrid [W/S205] 2015-",
            "engineCode": "M274.920"
          }
        ]
      },
      {
        "name": "CLA",
        "types": [
          {
            "name": "180 [C117] 2013-",
            "engineCode": "M270.910"
          },
          {
            "name": "180 [C118] 2019-",
            "engineCode": "M282.914"
          },
          {
            "name": "180 d [C118] 2019-",
            "engineCode": "OM608.915"
          },
          {
            "name": "180 Shooting Brake [X117] 2015-",
            "engineCode": "M270.910"
          },
          {
            "name": "200 [C117] 2013-",
            "engineCode": "M270.910"
          },
          {
            "name": "200 [C118] 2019-",
            "engineCode": "M282.914"
          },
          {
            "name": "200 CDI [C117] 2014-2016",
            "engineCode": "OM651"
          },
          {
            "name": "200 CDI 4MATIC [C117] 2014-2016",
            "engineCode": "OM651"
          },
          {
            "name": "200 d [C117] 2017-",
            "engineCode": "OM651"
          },
          {
            "name": "200 d [C118] 2019-",
            "engineCode": "OM654.920"
          },
          {
            "name": "200 Shooting Brake [X117] 2015-",
            "engineCode": "M270.910"
          },
          {
            "name": "220 [C118] 2019-",
            "engineCode": "M260.920"
          },
          {
            "name": "220 CDI [C117] 2013-2016",
            "engineCode": "OM651"
          },
          {
            "name": "220 CDI 4MATIC [C117] 2013-2016",
            "engineCode": "OM651"
          },
          {
            "name": "220 d [C117] 2017-",
            "engineCode": "OM651"
          },
          {
            "name": "220 d [C118] 2019-",
            "engineCode": "OM654.920"
          },
          {
            "name": "250 [C117] 2013-",
            "engineCode": "M270.920"
          },
          {
            "name": "250 [C118] 2019-",
            "engineCode": "M260.920"
          },
          {
            "name": "250 4MATIC [C117] 2013-",
            "engineCode": "M270.920"
          },
          {
            "name": "250 4MATIC Shooting Brake [X117] 2015-",
            "engineCode": "M270.920"
          },
          {
            "name": "250 e Hybrid [C118] 2020-",
            "engineCode": "M282.914"
          },
          {
            "name": "250 Shooting Brake [X117] 2015-",
            "engineCode": "M270.920"
          },
          {
            "name": "45 AMG 4MATIC [C117] 2014-",
            "engineCode": "M133.980"
          },
          {
            "name": "45 AMG 4MATIC Shooting Brake [X117] 2014-",
            "engineCode": "M133.980"
          }
        ]
      },
      {
        "name": "CLS",
        "types": [
          {
            "name": "220 BlueTEC [C218] 2014-",
            "engineCode": "OM651.924"
          },
          {
            "name": "220 BlueTEC Shooting Brake [X218] 2014-",
            "engineCode": "OM651.924"
          },
          {
            "name": "250 BlueTEC 4MATIC [C218] 2014-",
            "engineCode": "OM651.924"
          },
          {
            "name": "250 BlueTEC 4MATIC Shooting Brak [X218] 2014-",
            "engineCode": "OM651.924"
          },
          {
            "name": "350 CDI 4MATIC Shooting Brake [X218] 2012-",
            "engineCode": "OM642.85X"
          },
          {
            "name": "350 EQ Boost [C257] 2020-",
            "engineCode": "M264.920"
          }
        ]
      },
      {
        "name": "Citan",
        "types": [
          {
            "name": "108 CDI [W415] 2012-",
            "engineCode": "OM607"
          },
          {
            "name": "108 CDI [W415] 2020-",
            "engineCode": "OM608"
          },
          {
            "name": "108 CDI 75 [W420] 2022-",
            "engineCode": "OM608"
          },
          {
            "name": "109 CDI [W415] 2012-",
            "engineCode": "OM607"
          },
          {
            "name": "109 CDI [W415] 2020-",
            "engineCode": "OM608"
          },
          {
            "name": "110 CDI 95 [W420] 2022-",
            "engineCode": "OM608"
          },
          {
            "name": "111 CDI [W415] 2013-",
            "engineCode": "OM607"
          },
          {
            "name": "111 CDI [W415] 2020-",
            "engineCode": "OM608"
          },
          {
            "name": "112 CDI 116 [W420] 2022-",
            "engineCode": "OM608"
          }
        ]
      },
      {
        "name": "E",
        "types": [
          {
            "name": "200 [A/C207] (Automat) 2013-",
            "engineCode": "274.92"
          },
          {
            "name": "200 [W/S212] (Automat) 2013-",
            "engineCode": "274.92"
          },
          {
            "name": "200 [W/S213] (Automat) 2016-",
            "engineCode": "M274"
          },
          {
            "name": "200 4MATIC [W/S213] (Automat) 2016-",
            "engineCode": "M274"
          },
          {
            "name": "200 BlueTEC [W/S212] 2014-",
            "engineCode": "OM651"
          },
          {
            "name": "200 d [W/S213] 2016-",
            "engineCode": "OM654"
          },
          {
            "name": "220 BlueTEC [W/S212] 2014-",
            "engineCode": "OM651"
          },
          {
            "name": "220 BlueTEC 4MATIC [W/S212] 2014-",
            "engineCode": "OM651"
          },
          {
            "name": "220 d [W/S213] 2016-",
            "engineCode": "OM654"
          },
          {
            "name": "250 [A/C207] (Automat) 2013-",
            "engineCode": "274.92"
          },
          {
            "name": "250 [W/S212] (Automat) 2013-",
            "engineCode": "274.92"
          },
          {
            "name": "250 BlueTEC [W/S212] 2014-",
            "engineCode": "OM651"
          },
          {
            "name": "250 BlueTEC 4MATIC [W/S212] 2014-",
            "engineCode": "OM651"
          },
          {
            "name": "300 d [W/S213] 2018-",
            "engineCode": "OM654.920"
          },
          {
            "name": "300 de Hybrid [W/S213] 2020-",
            "engineCode": "OM654.920"
          },
          {
            "name": "300 de Hybrid [W/S214] 2023-",
            "engineCode": "OM654.820"
          },
          {
            "name": "350 d [W/S213] 2016-",
            "engineCode": "OM642.855"
          },
          {
            "name": "400 4MATIC [W/S213, A/C238] 2017-",
            "engineCode": "M276.853"
          },
          {
            "name": "400 d [W/S213] w Aux heater, w/o Front air susp 2019-",
            "engineCode": "OM656.929"
          },
          {
            "name": "450 d [W214] 2023-",
            "engineCode": "OM656"
          },
          {
            "name": "500 BlueEFFICIENCY [W/S212] 2012-",
            "engineCode": "278.922"
          }
        ]
      },
      {
        "name": "G",
        "types": [
          {
            "name": "350 d 4-MATIC [W463] 2019-",
            "engineCode": "OM656.929"
          },
          {
            "name": "400 d 4-MATIC [W463] 2019-",
            "engineCode": "OM656.929"
          }
        ]
      },
      {
        "name": "GLA",
        "types": [
          {
            "name": "180 [X156] 2015-",
            "engineCode": "M270"
          },
          {
            "name": "180 d [X156] 2016-2017",
            "engineCode": "OM607"
          },
          {
            "name": "200 [H247] 2020-",
            "engineCode": "M282.914"
          },
          {
            "name": "200 [X156] 2014-",
            "engineCode": "M270"
          },
          {
            "name": "200 CDI [X156] 2014-2016",
            "engineCode": "OM651"
          },
          {
            "name": "200 CDI 4MATIC [X156] 2014-2016",
            "engineCode": "OM651"
          },
          {
            "name": "200 d [H247] 2020-",
            "engineCode": "OM654.920"
          },
          {
            "name": "200 d [X156] 2017-",
            "engineCode": "OM651"
          },
          {
            "name": "200 d 4MATIC [H247] 2020-",
            "engineCode": "OM654.920"
          },
          {
            "name": "220 4MATIC [X156] 2017-",
            "engineCode": "M270"
          },
          {
            "name": "220 CDI [X156] 2014-2016",
            "engineCode": "OM651"
          },
          {
            "name": "220 CDI 4MATIC [X156] 2014-2016",
            "engineCode": "OM651"
          },
          {
            "name": "220 d [H247] 2020-",
            "engineCode": "OM654.920"
          },
          {
            "name": "220 d 4MATIC [H247] 2020-",
            "engineCode": "OM654.920"
          },
          {
            "name": "220 d 4MATIC [X156] 2017-",
            "engineCode": "OM651"
          },
          {
            "name": "250 [H247] 2020-",
            "engineCode": "M260.920"
          },
          {
            "name": "250 [X156] 2014-",
            "engineCode": "M270"
          },
          {
            "name": "250 4MATIC [X156] 2014-",
            "engineCode": "M270"
          },
          {
            "name": "250 e Hybrid [H247] 2020-",
            "engineCode": "M282.914"
          },
          {
            "name": "45 AMG 4MATIC [X156] 2014-",
            "engineCode": "M133.980"
          }
        ]
      },
      {
        "name": "GLB",
        "types": [
          {
            "name": "180 d [X247] 2020-",
            "engineCode": "OM654.920"
          },
          {
            "name": "200 [X247] 2020-",
            "engineCode": "M282.914"
          },
          {
            "name": "200 d [X247] 2020-",
            "engineCode": "OM654.920"
          },
          {
            "name": "220 d [X247] 2020-",
            "engineCode": "OM654.920"
          },
          {
            "name": "250 [X247] 2020-",
            "engineCode": "M260.920"
          }
        ]
      },
      {
        "name": "GLC",
        "types": [
          {
            "name": "200 d 4MATIC [X/C253] 2019-",
            "engineCode": "OM654.920"
          },
          {
            "name": "220 d 4MATIC [X/C253] 2015-",
            "engineCode": "OM651"
          },
          {
            "name": "220 d 4MATIC [X/C253] 2019-",
            "engineCode": "OM654.920"
          },
          {
            "name": "250 4MATIC [X/C253] 2015-",
            "engineCode": "M274"
          },
          {
            "name": "250 d 4MATIC [X/C253] 2015-",
            "engineCode": "OM651"
          },
          {
            "name": "300 d 4MATIC [X/C253] 2019-",
            "engineCode": "OM654.920"
          },
          {
            "name": "300 de Hybrid 4MATIC [X/C253] 2020-",
            "engineCode": "OM654.920"
          },
          {
            "name": "300 e Hybrid 4MATIC [X/C253] 2020-",
            "engineCode": "M274"
          },
          {
            "name": "350 e Hybrid 4MATIC [X/C253] 2016-",
            "engineCode": "M274"
          },
          {
            "name": "400 d [X/C253] w Aux heater, w/o Front air susp 2019-",
            "engineCode": "OM656.929"
          }
        ]
      },
      {
        "name": "GLE",
        "types": [
          {
            "name": "250 d 4MATIC [W166] 2015-2018",
            "engineCode": "OM651.960"
          },
          {
            "name": "350 d 4MATIC [W166] Ex. Webasto 2015-",
            "engineCode": "OM642.826"
          },
          {
            "name": "350 d 4MATIC Coupé [C292] Ex. Webasto 2015-",
            "engineCode": "OM642.826"
          },
          {
            "name": "350 de Hybrid [W167] 2020-",
            "engineCode": "OM654.920"
          }
        ]
      },
      {
        "name": "GLS",
        "types": [
          {
            "name": "350 d 4MATIC [X166] Ex. Webasto 2015-",
            "engineCode": "OM642.826"
          }
        ]
      },
      {
        "name": "S",
        "types": [
          {
            "name": "560 4MATIC [W222] 2018-",
            "engineCode": "M176.980"
          }
        ]
      },
      {
        "name": "Sprinter",
        "types": [
          {
            "name": "213 BlueTEC 2014-",
            "engineCode": "OM651"
          },
          {
            "name": "216 BlueTEC 2014-",
            "engineCode": "OM651"
          },
          {
            "name": "313 BlueTEC 2014-",
            "engineCode": "OM651"
          },
          {
            "name": "316 BlueTEC 2014-",
            "engineCode": "OM651"
          },
          {
            "name": "413 BlueTEC 2014-",
            "engineCode": "OM651"
          },
          {
            "name": "416 BlueTEC 2014-",
            "engineCode": "OM651"
          },
          {
            "name": "513 BlueTEC 2014-",
            "engineCode": "OM651"
          },
          {
            "name": "516 BlueTEC 2014-",
            "engineCode": "OM651"
          },
          {
            "name": "III 211 CDI  [W907/910] 2020-",
            "engineCode": "OM654"
          },
          {
            "name": "III 211 CDI FWD [W907/910] 2019-",
            "engineCode": "OM651"
          },
          {
            "name": "III 211 CDI RWD [W907/910] 2019-",
            "engineCode": "OM651"
          },
          {
            "name": "III 214 CDI FWD [W907/910] 2019-",
            "engineCode": "OM651"
          },
          {
            "name": "III 214 CDI RWD [W907/910] 2019-",
            "engineCode": "OM651"
          },
          {
            "name": "III 215 CDI [W907/910] 2020-",
            "engineCode": "OM654"
          },
          {
            "name": "III 216 CDI RWD [W907/910] 2019-",
            "engineCode": "OM651"
          },
          {
            "name": "III 217 CDI [W907/910] 2020-",
            "engineCode": "OM654"
          },
          {
            "name": "III 219 CDI [W907/910] 2019-",
            "engineCode": "OM642"
          },
          {
            "name": "III 311 CDI [W907/910] 2020-",
            "engineCode": "OM654"
          },
          {
            "name": "III 311 CDI FWD [W907/910] 2019-",
            "engineCode": "OM651"
          },
          {
            "name": "III 311 CDI RWD [W907/910] 2019-",
            "engineCode": "OM651"
          },
          {
            "name": "III 314 CDI FWD [W907/910] 2019-",
            "engineCode": "OM651"
          },
          {
            "name": "III 314 CDI RWD [W907/910] 2019-",
            "engineCode": "OM651"
          },
          {
            "name": "III 315 CDI [W907/910] 2020-",
            "engineCode": "OM654"
          },
          {
            "name": "III 316 CDI RWD [W907/910] 2019-",
            "engineCode": "OM651"
          },
          {
            "name": "III 317 CDI [W907/910] 2020-",
            "engineCode": "OM654"
          },
          {
            "name": "III 319 CDI [W907/910] 2019-",
            "engineCode": "OM642"
          },
          {
            "name": "III 319 CDI RWD/4x4 [W907/910] 2020-",
            "engineCode": "OM654"
          },
          {
            "name": "III 411 CDI [W907/910] 2020-",
            "engineCode": "OM654"
          },
          {
            "name": "III 411 CDI FWD [W907/910] 2019-",
            "engineCode": "OM651"
          },
          {
            "name": "III 411 CDI RWD [W907/910] 2019-",
            "engineCode": "OM651"
          },
          {
            "name": "III 414 CDI FWD [W907/910] 2019-",
            "engineCode": "OM651"
          },
          {
            "name": "III 414 CDI RWD [W907/910] 2019-",
            "engineCode": "OM651"
          },
          {
            "name": "III 415 CDI [W907/910] 2020-",
            "engineCode": "OM654"
          },
          {
            "name": "III 416 CDI RWD [W907/910] 2019-",
            "engineCode": "OM651"
          },
          {
            "name": "III 417 CDI [W907/910] 2020-",
            "engineCode": "OM654"
          },
          {
            "name": "III 419 CDI [W907/910] 2019-",
            "engineCode": "OM642"
          },
          {
            "name": "III 419 CDI RWD/4x4 [W907/910] 2020-",
            "engineCode": "OM654"
          },
          {
            "name": "III 511 CDI RWD [W907/910] 2019-",
            "engineCode": "OM651"
          },
          {
            "name": "III 514 CDI RWD [W907/910] 2019-",
            "engineCode": "OM651"
          },
          {
            "name": "III 515 CDI RWD [W907/910] 2020-",
            "engineCode": "OM654"
          },
          {
            "name": "III 516 CDI RWD [W907/910] 2019-",
            "engineCode": "OM651"
          },
          {
            "name": "III 517 CDI RWD [W907/910] 2020-",
            "engineCode": "OM654"
          },
          {
            "name": "III 519 CDI [W907/910] 2019-",
            "engineCode": "OM642"
          },
          {
            "name": "III 519 CDI RWD/4x4 [W907/910] 2020-",
            "engineCode": "OM654"
          }
        ]
      },
      {
        "name": "T",
        "types": [
          {
            "name": "180 [W420] 2022-",
            "engineCode": "M200"
          },
          {
            "name": "180 d [W420] 2022-",
            "engineCode": "OM608"
          }
        ]
      },
      {
        "name": "Vito",
        "types": [
          {
            "name": "III 109 CDI [W447] 2015-",
            "engineCode": "OM622"
          },
          {
            "name": "III 110 CDI [W447] 2020-",
            "engineCode": "OM622"
          },
          {
            "name": "III 111 CDI [W447] 2015-",
            "engineCode": "OM622"
          },
          {
            "name": "III 114 CDI [W447] 2014-",
            "engineCode": "OM651"
          },
          {
            "name": "III 116 CDI [W447] 2014-",
            "engineCode": "OM651"
          },
          {
            "name": "III 119 BlueTEC [W447] 2014-",
            "engineCode": "OM651"
          }
        ]
      },
      {
        "name": "X",
        "types": [
          {
            "name": "220 d [W470] 2018-",
            "engineCode": "OM699"
          },
          {
            "name": "250 d [W470] 2018-",
            "engineCode": "OM699"
          }
        ]
      }
    ]
  },
  {
    "make": "Mitsubishi",
    "models": [
      {
        "name": "ASX",
        "types": [
          {
            "name": "1.0 MPI 91 2023-",
            "engineCode": "HAD"
          },
          {
            "name": "1.3 MHEV 141 2023-",
            "engineCode": "H5H"
          },
          {
            "name": "1.3 MHEV 161 2023-",
            "engineCode": "H5H"
          },
          {
            "name": "1.6 Di-D 2015-",
            "engineCode": "9HB"
          },
          {
            "name": "1.6 Hybrid 144 2023-",
            "engineCode": "H4M"
          },
          {
            "name": "1.6 Plug-in Hybrid 161 2023-",
            "engineCode": "H4M"
          },
          {
            "name": "1.8 Di-D 2012-",
            "engineCode": "4N13"
          },
          {
            "name": "2.2 Di-D 2013-",
            "engineCode": "4N14"
          }
        ]
      },
      {
        "name": "Eclipse",
        "types": [
          {
            "name": "Cross 1.5 T 163 2WD/4WD 2018-",
            "engineCode": "4B40"
          },
          {
            "name": "Cross 2.4 Plug-in Hybrid 2021-",
            "engineCode": "4B12"
          }
        ]
      },
      {
        "name": "L200",
        "types": [
          {
            "name": "2.2 DI-D 150 4WD 2020-",
            "engineCode": "4N14"
          },
          {
            "name": "2400 DI-D 155 2016-",
            "engineCode": "4N15"
          },
          {
            "name": "2400 DI-D 182 2016-",
            "engineCode": "4N15"
          }
        ]
      },
      {
        "name": "Outlander",
        "types": [
          {
            "name": "2.0 PHEV 2016-",
            "engineCode": "4B11"
          },
          {
            "name": "2.1 2013-",
            "engineCode": "4J11"
          },
          {
            "name": "2.2 DI-D 2012-",
            "engineCode": "4N14"
          },
          {
            "name": "2.2D 2016-",
            "engineCode": "4N14"
          },
          {
            "name": "2.4 PHEV 2019-",
            "engineCode": "4B12"
          },
          {
            "name": "Hybrid 2013-",
            "engineCode": "4B11"
          }
        ]
      }
    ]
  },
  {
    "make": "Nissan",
    "models": [
      {
        "name": "Juke",
        "types": [
          {
            "name": "1.0 DIG-T 118 2020-",
            "engineCode": "HR10DDT"
          },
          {
            "name": "1.5 dCi 2015-2017",
            "engineCode": "K9K"
          },
          {
            "name": "1.6 DIG-T 218 NISMO RS 2014-",
            "engineCode": "MR16DDT"
          },
          {
            "name": "Hybrid 144 2022-",
            "engineCode": "HR16DE"
          }
        ]
      },
      {
        "name": "NV",
        "types": [
          {
            "name": "200 1.5 dCi 111 2015-2017",
            "engineCode": "K9K"
          },
          {
            "name": "200 1.5 dCi 111 2017-",
            "engineCode": "K9K"
          },
          {
            "name": "250 1.5 dCi 2020-",
            "engineCode": "K9K"
          },
          {
            "name": "300 1.6 dCi 2017-",
            "engineCode": "R9M"
          },
          {
            "name": "300 2.0 dCi 2020-",
            "engineCode": "M9R"
          },
          {
            "name": "400 2.3 dCi 110hk (FWD) 2014-",
            "engineCode": "M9T"
          },
          {
            "name": "400 2.3 dCi 125hk (FWD) 2015-",
            "engineCode": "M9T"
          }
        ]
      },
      {
        "name": "Primastar",
        "types": [
          {
            "name": "III 2.0 dCi 111 2023-",
            "engineCode": "M9R"
          },
          {
            "name": "III 2.0 dCi 131 2023-",
            "engineCode": "M9R"
          },
          {
            "name": "III 2.0 dCi 151 2023-",
            "engineCode": "M9R"
          },
          {
            "name": "III 2.0 dCi 171 2023-",
            "engineCode": "M9R"
          }
        ]
      },
      {
        "name": "Qashqai",
        "types": [
          {
            "name": "1.2 DIG-T 115 Manuell 2014-2016",
            "engineCode": "HRA2"
          },
          {
            "name": "1.2 DIG-T 116 2014-",
            "engineCode": "HRA2"
          },
          {
            "name": "1.2 DIG-T 116 2018-",
            "engineCode": "HRA2"
          },
          {
            "name": "1.3 DIG-T 141 2019-",
            "engineCode": "HR13DDT"
          },
          {
            "name": "1.3 DIG-T 161 2019-",
            "engineCode": "HR13DDT"
          },
          {
            "name": "1.5 dCi 111 2015-2017",
            "engineCode": "K9K"
          },
          {
            "name": "1.5 dCi 111 2017-",
            "engineCode": "K9K"
          },
          {
            "name": "1.6 dCi 2012-2013",
            "engineCode": "R9M"
          },
          {
            "name": "1.6 dCi 2013-",
            "engineCode": "R9M"
          },
          {
            "name": "1.6 DIG-T 164 2015-",
            "engineCode": "MR16"
          },
          {
            "name": "1.7 2013-",
            "engineCode": "HR16"
          },
          {
            "name": "1.7 dCi 151 2019-",
            "engineCode": "R9N"
          },
          {
            "name": "III 1.3 MHEV 140 6M/T 2021-",
            "engineCode": "HR13DDT"
          },
          {
            "name": "III 1.3 MHEV 158 Xtronic 2WD 2021-",
            "engineCode": "HR13DDT"
          },
          {
            "name": "III 1.3 MHEV 158 Xtronic 4WD 2021-",
            "engineCode": "HR13DDT"
          },
          {
            "name": "III 1.5 e-POWER 191 2022-",
            "engineCode": "KR15DDT"
          }
        ]
      },
      {
        "name": "Townstar",
        "types": [
          {
            "name": "Combi 1.3 DIG-T 131 2022-",
            "engineCode": "HR13DDT"
          },
          {
            "name": "Van 1.3 DIG-T 131 2022-",
            "engineCode": "HR13DDT"
          }
        ]
      },
      {
        "name": "X-Trail",
        "types": [
          {
            "name": "1.3 DIG-T 160 2WD 2020-",
            "engineCode": "HR13DDT"
          },
          {
            "name": "1.5 e-POWER 191 2022-",
            "engineCode": "KR15DDT"
          },
          {
            "name": "1.6 dCi 130 [T32] 2015-",
            "engineCode": "R9M"
          },
          {
            "name": "1.6 DIG-T 164 2016-",
            "engineCode": "MR16DDT"
          },
          {
            "name": "1.7 dCi 151 2019-",
            "engineCode": "R9N"
          },
          {
            "name": "2.0 dCi 177 [T32] 2017-",
            "engineCode": "YD22"
          }
        ]
      }
    ]
  },
  {
    "make": "Opel",
    "models": [
      {
        "name": "Adam",
        "types": [
          {
            "name": "1.0T ECOTEC 116 2006-2016",
            "engineCode": "B10XFT"
          },
          {
            "name": "1.0T ECOTEC 116 2017-",
            "engineCode": "B10XFT"
          },
          {
            "name": "1.0T ECOTEC 91 2006-2016",
            "engineCode": "B10XFL"
          },
          {
            "name": "1.0T ECOTEC 91 2017-",
            "engineCode": "B10XFL"
          },
          {
            "name": "1.2 16V 2013-",
            "engineCode": "A12XEL"
          },
          {
            "name": "1.4 101 2015-",
            "engineCode": "B14XER"
          },
          {
            "name": "1.4 16V (A14XEL) 2013-",
            "engineCode": "A14XEL"
          },
          {
            "name": "1.4 16V (A14XER) 2013-",
            "engineCode": "A14XER"
          },
          {
            "name": "Rocks 1.0T ECOTEC 116 2006-2016",
            "engineCode": "B10XFT"
          },
          {
            "name": "Rocks 1.0T ECOTEC 116 2017-",
            "engineCode": "B10XFT"
          },
          {
            "name": "Rocks 1.0T ECOTEC 91 2006-2016",
            "engineCode": "B10XFL"
          },
          {
            "name": "Rocks 1.0T ECOTEC 91 2017-",
            "engineCode": "B10XFL"
          },
          {
            "name": "Rocks 1.2 71 2014-",
            "engineCode": "A12XEL"
          },
          {
            "name": "Rocks 1.4 101 2014-",
            "engineCode": "A14XER"
          },
          {
            "name": "Rocks 1.4 101 2015-",
            "engineCode": "B14XER"
          },
          {
            "name": "Rocks 1.4 88 2014-",
            "engineCode": "A14XEL"
          }
        ]
      },
      {
        "name": "Astra",
        "types": [
          {
            "name": "J 1.6 CDTi 111 2014-",
            "engineCode": "B16DTL"
          },
          {
            "name": "J 1.6 CDTi 137 2014-",
            "engineCode": "B16DTH"
          },
          {
            "name": "J 1.6 GTC SIDI 200hp 2014-",
            "engineCode": "A16SHT"
          },
          {
            "name": "J 1.6T SIDI 170hp 2013-",
            "engineCode": "A16XHT"
          },
          {
            "name": "K 1.0 T ECOTEC 91 2019-",
            "engineCode": "D10XFL"
          },
          {
            "name": "K 1.0 Turbo ECOTEC 106 2017-",
            "engineCode": "B10XFL"
          },
          {
            "name": "K 1.0 Turbo ECOTEC 106 2019-",
            "engineCode": "D10XFL"
          },
          {
            "name": "K 1.0 Turbo ECOTEC 2016",
            "engineCode": "B10XFL"
          },
          {
            "name": "K 1.4 ECOTEC CNG 2017-",
            "engineCode": "B14XNT"
          },
          {
            "name": "K 1.4 ECOTEC CNG 2019-",
            "engineCode": "D14XNT"
          },
          {
            "name": "K 1.4 T 125 ECOTEC 2016-",
            "engineCode": "B14XFL"
          },
          {
            "name": "K 1.4 T 125 ECOTEC 2019-",
            "engineCode": "D14XFL"
          },
          {
            "name": "K 1.4 T 150 ECOTEC 2016-",
            "engineCode": "B14XFT"
          },
          {
            "name": "K 1.4 T 150 ECOTEC 2019-",
            "engineCode": "D14XFT"
          },
          {
            "name": "K 1.6 CDTi 111 (B16DTE) 2016-",
            "engineCode": "B16DTE"
          },
          {
            "name": "K 1.6 CDTi 111 (B16DTU) 2016-",
            "engineCode": "B16DTU"
          },
          {
            "name": "K 1.6 CDTi 137 2016-",
            "engineCode": "B16DTH"
          },
          {
            "name": "K 1.6 CDTi 137 2019-",
            "engineCode": "D16DTH"
          },
          {
            "name": "K 1.6 T 170 ECOTEC 2016-",
            "engineCode": "B16SHL"
          },
          {
            "name": "K 1.6 T 200 ECOTEC 2016-",
            "engineCode": "B16SHT"
          },
          {
            "name": "K D123 2020-",
            "engineCode": "F15DVH"
          },
          {
            "name": "K P111 2020-",
            "engineCode": "F12SHL"
          },
          {
            "name": "K P131 2020-",
            "engineCode": "F12SHT"
          },
          {
            "name": "K P146 2020-",
            "engineCode": "F14SHT"
          },
          {
            "name": "K P146 2021-",
            "engineCode": "F12SHR"
          },
          {
            "name": "L 1.2 MHEV 137 2024-",
            "engineCode": "HPY"
          },
          {
            "name": "L 1.2 Turbo 101 2022-",
            "engineCode": "HNK"
          },
          {
            "name": "L 1.2 Turbo 111 2023-",
            "engineCode": "HNP"
          },
          {
            "name": "L 1.2 Turbo 131 2023-",
            "engineCode": "HNS"
          },
          {
            "name": "L 1.5 CDTI 131 2022-",
            "engineCode": "YHZ"
          },
          {
            "name": "L 1.6 Plug-In Hybrid 181 2023-",
            "engineCode": "DGX"
          },
          {
            "name": "L 1.6 Plug-In Hybrid 226 2023-",
            "engineCode": "DGY"
          }
        ]
      },
      {
        "name": "Combo",
        "types": [
          {
            "name": "D 1.3 CDTi 2012-",
            "engineCode": "A13FD"
          },
          {
            "name": "D 1.4 CNG 2012-",
            "engineCode": "A14FC"
          },
          {
            "name": "D 1.6 CDTi (A16FDH) 2012-",
            "engineCode": "A16FDH"
          },
          {
            "name": "D 1.6 CDTi (A16FDL) 2012-",
            "engineCode": "A16FDL"
          },
          {
            "name": "E 1.2T 111 2019-",
            "engineCode": "D12XHL"
          },
          {
            "name": "E 1.2T 131 2020-",
            "engineCode": "F12XHT"
          },
          {
            "name": "E 1.5 CDTi 101 2019-",
            "engineCode": "D15DT"
          },
          {
            "name": "E 1.5 CDTi 130hk 2019-",
            "engineCode": "D15DTH"
          },
          {
            "name": "E 1.5 CDTi 76 2019-",
            "engineCode": "D15DTL"
          }
        ]
      },
      {
        "name": "Corsa",
        "types": [
          {
            "name": "E 1.0 Turbo ECOTEC 2017-",
            "engineCode": "B10XFT"
          },
          {
            "name": "E 1.0 Turbo ECOTEC 91 2006-2016",
            "engineCode": "B10XFL"
          },
          {
            "name": "E 1.0 Turbo ECOTEC 91 2017-",
            "engineCode": "B10XFL"
          },
          {
            "name": "E 1.0 Turbo ECOTEC 91 2019-",
            "engineCode": "D10XFL"
          },
          {
            "name": "E 1.3 CDTI Ecoflex 76 2015-",
            "engineCode": "B13DTC"
          },
          {
            "name": "E 1.3 CDTI Ecoflex 96 2015-",
            "engineCode": "B13DTE"
          },
          {
            "name": "E 1.4 ECOTEC 91 2015-",
            "engineCode": "B14XEL"
          },
          {
            "name": "E 1.4 ECOTEC 91 2019-",
            "engineCode": "D14XEL"
          },
          {
            "name": "E 1.4 T ECOTEC 101 2019-",
            "engineCode": "D14NEJ"
          },
          {
            "name": "E 1.4 T ECOTEC 151 2019-",
            "engineCode": "D14NEH"
          },
          {
            "name": "F 1.2 P101 2020-",
            "engineCode": "F12XHL"
          },
          {
            "name": "F 1.2 P76 2020-",
            "engineCode": "F12XEL"
          },
          {
            "name": "F 1.2 Turbo 101 2020-",
            "engineCode": "HNK"
          },
          {
            "name": "F 1.2 Turbo 131 2020-",
            "engineCode": "HNS"
          }
        ]
      },
      {
        "name": "Crossland",
        "types": [
          {
            "name": "1.2 Turbo 111 2022-",
            "engineCode": "EB2ADT"
          },
          {
            "name": "1.2 Turbo 131 2022-",
            "engineCode": "EB2ADTS"
          },
          {
            "name": "X 1.2 (59 kW/81 hp) 2018-",
            "engineCode": "B12XE"
          },
          {
            "name": "X 1.2 PureTech 83 2019-",
            "engineCode": "D12XE"
          },
          {
            "name": "X 1.2T (81 kW/110 hp) 2018-",
            "engineCode": "B12XHL"
          },
          {
            "name": "X 1.2T (81 kW/110 hp) 2019-",
            "engineCode": "D12XHL"
          },
          {
            "name": "X 1.2T (96 kW/130 hp) 2006-2018",
            "engineCode": "B12XHT"
          },
          {
            "name": "X 1.2T (96 kW/130 hp) 2019-",
            "engineCode": "D12XHT"
          }
        ]
      },
      {
        "name": "Grandland",
        "types": [
          {
            "name": "1.2 T Hybrid 137 2024-",
            "engineCode": "HPY"
          },
          {
            "name": "X 1.2 T 131 2019-",
            "engineCode": "D12XHT"
          },
          {
            "name": "X 1.2 T 131 2021-",
            "engineCode": "F12XHT"
          },
          {
            "name": "X 1.2 T 2018-",
            "engineCode": "B12XHT"
          },
          {
            "name": "X 1.2 T Hybrid 137 2024-",
            "engineCode": "HPY"
          },
          {
            "name": "X 1.5 Diesel 131 2019-",
            "engineCode": "D15DTH"
          },
          {
            "name": "X 1.6 T 181 2019-",
            "engineCode": "D16XHT"
          },
          {
            "name": "X 2.0 CDTi 181 2019-",
            "engineCode": "D20DTH"
          },
          {
            "name": "X PHEV 226 2020-",
            "engineCode": "EP6FAD"
          }
        ]
      },
      {
        "name": "Insignia",
        "types": [
          {
            "name": "1.4T ecoflex 2012-",
            "engineCode": "A14NET"
          },
          {
            "name": "1.6 CDTi 2016-",
            "engineCode": "B16DTH"
          },
          {
            "name": "1.6T SIDI 170hp (B16SHL) 2015-",
            "engineCode": "B16SHL"
          },
          {
            "name": "1.6T SIDI 170hp (B16XHT) 2015-",
            "engineCode": "B16XHT"
          },
          {
            "name": "1.6T SIDI 170hp 2013-",
            "engineCode": "A16XHT"
          },
          {
            "name": "2.0 CDTI 2012-",
            "engineCode": "A20DTR"
          },
          {
            "name": "2.0 CDTI 2013-",
            "engineCode": "A20DTE"
          },
          {
            "name": "2.0 CDTI ECOTEC 171 2015-",
            "engineCode": "B20DTH"
          },
          {
            "name": "2.0 CDTI ECOTEC 4x4 171 2015-",
            "engineCode": "B20DTH"
          },
          {
            "name": "2.0 T 4x5 2014-",
            "engineCode": "A20NHT"
          },
          {
            "name": "B 1.5 D121 2021-",
            "engineCode": "F15DVH"
          },
          {
            "name": "B 1.5T 141 2018-",
            "engineCode": "B15SFL"
          },
          {
            "name": "B 1.5T 166 2018-",
            "engineCode": "B15SFT"
          },
          {
            "name": "B 1.5T 166 2019-",
            "engineCode": "B15SFT"
          },
          {
            "name": "B 1.6 CDTi 2018-",
            "engineCode": "B16DTH"
          },
          {
            "name": "B 1.6T 201 2018-",
            "engineCode": "D16SHT"
          },
          {
            "name": "B 2.0 CDTI 170 4X5 2018-",
            "engineCode": "B20DTH"
          },
          {
            "name": "B 2.0 CDTI 171 2018-",
            "engineCode": "B20DTH"
          },
          {
            "name": "B 2.0 CDTI 174 2WD 2021-",
            "engineCode": "F20DVH"
          },
          {
            "name": "B 2.0 T 260 4x5 2017-",
            "engineCode": "B20NFT"
          }
        ]
      },
      {
        "name": "Karl",
        "types": [
          {
            "name": "1.1 2015-2016",
            "engineCode": "B10XE"
          },
          {
            "name": "1.1 2017-",
            "engineCode": "B10XE"
          },
          {
            "name": "Rocks 1.0 75 2019-",
            "engineCode": "D10XE"
          }
        ]
      },
      {
        "name": "Meriva",
        "types": [
          {
            "name": "B 1.4T (B14NEL) 2014-",
            "engineCode": "B14NEL"
          },
          {
            "name": "B 1.4T (B14NET) 2014-",
            "engineCode": "B14NET"
          },
          {
            "name": "B 1.6 CDTi 2014-",
            "engineCode": "B16DTH"
          }
        ]
      },
      {
        "name": "Mokka",
        "types": [
          {
            "name": "1.4 T 2013-",
            "engineCode": "A14NET"
          },
          {
            "name": "1.4 T 2014-",
            "engineCode": "B14NET"
          },
          {
            "name": "1.4 T 4x5 2013-",
            "engineCode": "A14NET"
          },
          {
            "name": "1.4 T 4x5 2015-",
            "engineCode": "B14NET"
          },
          {
            "name": "1.6 CDTi 2WD 2015-",
            "engineCode": "B16DTH"
          },
          {
            "name": "1.6 CDTi 4x5 2015-",
            "engineCode": "B16DTH"
          },
          {
            "name": "1.7 2013-",
            "engineCode": "A16XER"
          },
          {
            "name": "1.7 2016-",
            "engineCode": "B16XER"
          },
          {
            "name": "1.7 CDTI 2WD 2013-",
            "engineCode": "A17DTS"
          },
          {
            "name": "B 1.2 P131 2021-",
            "engineCode": "F12XHT"
          },
          {
            "name": "B 1.2T 131 2021-",
            "engineCode": "F12XHL"
          },
          {
            "name": "X 1.4 T 121 2019-",
            "engineCode": "D14NEL"
          },
          {
            "name": "X 1.4 T 140 4x5 2016-",
            "engineCode": "B14NET"
          },
          {
            "name": "X 1.4 T 140 4x5 2019-",
            "engineCode": "D14NET"
          },
          {
            "name": "X 1.4 T 141 2016-",
            "engineCode": "B14NET"
          },
          {
            "name": "X 1.4 T 141 2019-",
            "engineCode": "D14NET"
          },
          {
            "name": "X 1.4 T 152 Ecotec 2016-",
            "engineCode": "B14XFT"
          },
          {
            "name": "X 1.4 T 152 Ecotec 4X5 2016-",
            "engineCode": "B14XFT"
          },
          {
            "name": "X 1.6 CDTi 2WD 137 2016-",
            "engineCode": "B16DTH"
          },
          {
            "name": "X 1.6 CDTi 2WD 137 2019-",
            "engineCode": "D16DTH"
          },
          {
            "name": "X 1.6 CDTi 4x5 2016-",
            "engineCode": "B16DTH"
          },
          {
            "name": "X 1.6 ecoFLEX 2016-",
            "engineCode": "B16XER"
          }
        ]
      },
      {
        "name": "Movano",
        "types": [
          {
            "name": "2.3 CDTi 110hk FWD 2014-",
            "engineCode": "M9T"
          },
          {
            "name": "2.3 CDTi 125hk FWD 2015-",
            "engineCode": "M9T"
          }
        ]
      },
      {
        "name": "Vivaro",
        "types": [
          {
            "name": "1.5 Diesel 2020-",
            "engineCode": "D15DT"
          },
          {
            "name": "1.6 CDTi 2015-",
            "engineCode": "R9M"
          },
          {
            "name": "2.0 Diesel 2020-",
            "engineCode": "DW10"
          }
        ]
      },
      {
        "name": "Zafira",
        "types": [
          {
            "name": "C Tourer 1.4 Turbo 2012-",
            "engineCode": "A14NET"
          },
          {
            "name": "C Tourer 1.6 CDTi 2014-",
            "engineCode": "B16DTH"
          },
          {
            "name": "C Tourer 1.6 CNG 2012-",
            "engineCode": "A16XNT"
          },
          {
            "name": "C Tourer 1.6 Direct Injection Turbo 137 2019-",
            "engineCode": "D16SHJ"
          },
          {
            "name": "C Tourer 2.0 CDTI (A20DT) 2012-",
            "engineCode": "A20DT"
          },
          {
            "name": "C Tourer 2.0 CDTI (A20DTH) 2012-",
            "engineCode": "A20DTH"
          },
          {
            "name": "C Tourer 2.0 CDTI (A20DTL) 2012-",
            "engineCode": "A20DTL"
          }
        ]
      }
    ]
  },
  {
    "make": "Peugeot",
    "models": [
      {
        "name": "108.0",
        "types": [
          {
            "name": "1 2014-",
            "engineCode": "CFB"
          }
        ]
      },
      {
        "name": "2008.0",
        "types": [
          {
            "name": "1.2 e-THP 110 2015 - 2017",
            "engineCode": "HNZ"
          },
          {
            "name": "1.2 e-THP 130 2015 - 2017",
            "engineCode": "HNY"
          },
          {
            "name": "1.2 PureTech 82 2018-",
            "engineCode": "EB2FA"
          },
          {
            "name": "1.5 BlueHDI 100 2019-",
            "engineCode": "YHY"
          },
          {
            "name": "1.5 BlueHDI 120 2019-",
            "engineCode": "YHX"
          },
          {
            "name": "1.6 e-HDi 2013-",
            "engineCode": "9HP"
          },
          {
            "name": "1.6 Vti 2013-",
            "engineCode": "5FS"
          },
          {
            "name": "II 1.5 BlueHDI 130 2020-",
            "engineCode": "YHZ"
          },
          {
            "name": "II GT PureTech 155 2020-",
            "engineCode": "HNN"
          },
          {
            "name": "II PureTech 130 2020-",
            "engineCode": "HNS"
          },
          {
            "name": "PureTech 110 2017-",
            "engineCode": "HNZ"
          },
          {
            "name": "PureTech 110 2018-",
            "engineCode": "EB2ADT"
          },
          {
            "name": "PureTech 130 2017-",
            "engineCode": "HNY"
          }
        ]
      },
      {
        "name": "208",
        "types": [
          {
            "name": "1.0 PureTech 68 2012-",
            "engineCode": "EBO"
          },
          {
            "name": "1.2 PureTech 82 2018-",
            "engineCode": "EB2FA"
          },
          {
            "name": "1.2 VTi 2012 - 2018",
            "engineCode": "EB2"
          },
          {
            "name": "1.4 HDI 2012-",
            "engineCode": "DV4C"
          },
          {
            "name": "1.4 VTi 2012-",
            "engineCode": "EP3C"
          },
          {
            "name": "1.5 BlueHDI 100 2019-",
            "engineCode": "DV5RD"
          },
          {
            "name": "1.6 16V VTi 2012-",
            "engineCode": "EP6C"
          },
          {
            "name": "1.6 BlueHDI 100 2015-",
            "engineCode": "DV6"
          },
          {
            "name": "1.6 HDI (DV6C) 2012-",
            "engineCode": "DV6C"
          },
          {
            "name": "1.6 HDI (DV6DTED) 2012-",
            "engineCode": "DV6DTED"
          },
          {
            "name": "Gti 2013-",
            "engineCode": "5FU"
          },
          {
            "name": "II 1.2 PureTech 75 2020-",
            "engineCode": "EB2F"
          },
          {
            "name": "II PureTech 100 2020-",
            "engineCode": "HNK"
          },
          {
            "name": "II PureTech 130 2020-",
            "engineCode": "HNS"
          },
          {
            "name": "PureTech 110 2017-",
            "engineCode": "HNZ"
          }
        ]
      },
      {
        "name": "3008",
        "types": [
          {
            "name": "1.2 e-THP 130 2015-",
            "engineCode": "HNY"
          },
          {
            "name": "1.6 BlueHDI 2014-",
            "engineCode": "DV6"
          },
          {
            "name": "Hybrid4 2012-",
            "engineCode": "RHC"
          },
          {
            "name": "II 1.5 BlueHDI 130 2018-",
            "engineCode": "YHZ"
          },
          {
            "name": "II 1.6 Hybrid 225 2020-",
            "engineCode": "EP6FAD"
          },
          {
            "name": "II 1.6 THP 165 2017-",
            "engineCode": "EP6FDT"
          },
          {
            "name": "II BlueHDI 120 2017-",
            "engineCode": "DV6FC"
          },
          {
            "name": "II BlueHDI 180 2019-",
            "engineCode": "DV10FC"
          },
          {
            "name": "II GT BlueHDI 180 2017-",
            "engineCode": "DV10FC"
          },
          {
            "name": "II Hybrid4 300 2020-",
            "engineCode": "EP6F"
          },
          {
            "name": "II PureTech 130 2017",
            "engineCode": "HNY"
          },
          {
            "name": "II PureTech 130 2017-",
            "engineCode": "HNY"
          },
          {
            "name": "II PureTech 130 2019-",
            "engineCode": "HNS"
          },
          {
            "name": "II PureTech 180 Automat 2018-",
            "engineCode": "EP6FADT"
          },
          {
            "name": "III Hybrid 136 2024-",
            "engineCode": "HPY"
          }
        ]
      },
      {
        "name": "308",
        "types": [
          {
            "name": "1.2 THP 130 2014 - 2017",
            "engineCode": "HNY"
          },
          {
            "name": "1.2 VTI 82 2016 - 2018",
            "engineCode": "HMZ"
          },
          {
            "name": "1.5 BlueHDI 100 2019-",
            "engineCode": "DV5RD"
          },
          {
            "name": "1.5 BlueHDI 130 2018-",
            "engineCode": "YHZ"
          },
          {
            "name": "1.6 BlueHDI 120 2014-",
            "engineCode": "BHZ"
          },
          {
            "name": "1.6 HDI 2013-",
            "engineCode": "9HD"
          },
          {
            "name": "1.6 HDI 2014-",
            "engineCode": "9HC"
          },
          {
            "name": "2.0 BlueHDI 150 2014-",
            "engineCode": "DW10FD"
          },
          {
            "name": "2.0 BlueHDI 180 2014-",
            "engineCode": "DW10FC"
          },
          {
            "name": "BlueHDI 180 2019-",
            "engineCode": "DW10FC"
          },
          {
            "name": "GT BlueHDI 180 2014-",
            "engineCode": "DW10FC"
          },
          {
            "name": "GT e-THP 205 2015-",
            "engineCode": "EP6F"
          },
          {
            "name": "GTi 2012-",
            "engineCode": "5FU"
          },
          {
            "name": "GTi 2015-",
            "engineCode": "5GN"
          },
          {
            "name": "III Hybrid 136 2024-",
            "engineCode": "HPY"
          },
          {
            "name": "III PureTech 130 2022-",
            "engineCode": "EB2ADTS"
          },
          {
            "name": "PureTech 110 2018-",
            "engineCode": "HNZ"
          },
          {
            "name": "PureTech 110 2019-",
            "engineCode": "EB2A"
          },
          {
            "name": "PureTech 130 2017-",
            "engineCode": "HNY"
          },
          {
            "name": "PureTech 225 Automat 2018-",
            "engineCode": "EP6FADTX"
          }
        ]
      },
      {
        "name": "4008",
        "types": [
          {
            "name": "1.6 Hdi 2012-",
            "engineCode": "9HD"
          }
        ]
      },
      {
        "name": "408",
        "types": [
          {
            "name": "II 1.2 PureTech 130 2023-",
            "engineCode": "EB2ADTS"
          },
          {
            "name": "II 1.6 Hybrid 180 2023-",
            "engineCode": "EP6FAD"
          },
          {
            "name": "II 1.6 Hybrid 225 2023-",
            "engineCode": "EP6FAD"
          },
          {
            "name": "II 1.6 PureTech 215 2023-",
            "engineCode": "EP6FAD"
          },
          {
            "name": "II Hybrid 136 2024-",
            "engineCode": "HPY"
          }
        ]
      },
      {
        "name": "5008",
        "types": [
          {
            "name": "1.2 PureTech 130 2015 - 2017",
            "engineCode": "HNY"
          },
          {
            "name": "II 1.2 Hybrid 136 2024-",
            "engineCode": "HPY"
          },
          {
            "name": "III Hybrid 136 2024-",
            "engineCode": "HPY"
          },
          {
            "name": "SUV 1.6 THP 165 2017-",
            "engineCode": "5GZ"
          },
          {
            "name": "SUV BlueHDI 120 2017-",
            "engineCode": "DV6FC"
          },
          {
            "name": "SUV BlueHDI 130 2018-",
            "engineCode": "YHZ"
          },
          {
            "name": "SUV BlueHDI 180 2019-",
            "engineCode": "DV10FC"
          },
          {
            "name": "SUV GT BlueHDI 180 2017-",
            "engineCode": "DV10FC"
          },
          {
            "name": "SUV PureTech 130 (HNS) 2019-",
            "engineCode": "HNS"
          },
          {
            "name": "SUV PureTech 130 (HNY) 2019-",
            "engineCode": "HNY"
          }
        ]
      },
      {
        "name": "508",
        "types": [
          {
            "name": "1.6 e-THP 165 2014-",
            "engineCode": "5GZ"
          },
          {
            "name": "2.0 BlueHDI 150 2014-",
            "engineCode": "DW10FD"
          },
          {
            "name": "2.0 BlueHDI 180 2014-",
            "engineCode": "DW10FD"
          },
          {
            "name": "BlueHDI 160 2019-",
            "engineCode": "DW10F"
          },
          {
            "name": "BlueHDI 180 2019-",
            "engineCode": "DW10FC"
          },
          {
            "name": "Hybrid 225 Aut 2020-",
            "engineCode": "EP6F"
          },
          {
            "name": "PureTech 180 Automat 2019-",
            "engineCode": "EP6F"
          },
          {
            "name": "PureTech 225 Automat 2019-",
            "engineCode": "EP6FADTX"
          }
        ]
      },
      {
        "name": "Boxer",
        "types": [
          {
            "name": "2.0 BlueHDI 111 2016-",
            "engineCode": "DW10FUE"
          },
          {
            "name": "2.0 BlueHDI 131 2016-",
            "engineCode": "DW10FUD"
          },
          {
            "name": "2.0 BlueHDI 164 2016-",
            "engineCode": "DW10FUC"
          },
          {
            "name": "2.2 BlueHDI 121 2020-",
            "engineCode": "DW12"
          },
          {
            "name": "2.2 BlueHDI 141 2020-",
            "engineCode": "DW12"
          },
          {
            "name": "2.2 BlueHDI 166 2020-",
            "engineCode": "DW12"
          }
        ]
      },
      {
        "name": "Expert",
        "types": [
          {
            "name": "1.6 HDI 90 FAP 2012-",
            "engineCode": "9HZ"
          },
          {
            "name": "2.0 HDI 2012-",
            "engineCode": "AHZ"
          },
          {
            "name": "III 1.5 BlueHDI 101 2019-",
            "engineCode": "DV5RUC"
          },
          {
            "name": "III 1.5 BlueHDI 121 2019-",
            "engineCode": "DV5RUC"
          },
          {
            "name": "III BlueHDI 116 2016-",
            "engineCode": "DW6FCU"
          },
          {
            "name": "III BlueHDI 121 2016-",
            "engineCode": "DW10FE"
          },
          {
            "name": "III BlueHDI 151 2016-",
            "engineCode": "DW10FD"
          },
          {
            "name": "III BlueHDI 181 2016-",
            "engineCode": "DW10FC"
          },
          {
            "name": "III BlueHDI 96 2016-",
            "engineCode": "DW6FDU"
          },
          {
            "name": "IV BlueHDI 146 2022-",
            "engineCode": "DW10FDDU"
          }
        ]
      },
      {
        "name": "Partner",
        "types": [
          {
            "name": "[K9] BlueHDi 101 2019-",
            "engineCode": "YHY"
          },
          {
            "name": "[K9] BlueHDi 131 2019-",
            "engineCode": "YHZ"
          },
          {
            "name": "[K9] BlueHDi 76 2019-",
            "engineCode": "YHW"
          },
          {
            "name": "[K9] PureTech 111 2019-",
            "engineCode": "EB2ADT"
          },
          {
            "name": "[K9] PureTech 131 2019-",
            "engineCode": "EB2ADTS"
          },
          {
            "name": "1.6 BlueHDI 101 2015-",
            "engineCode": "DV6"
          },
          {
            "name": "1.6 BlueHDI 121 2015-",
            "engineCode": "DV6"
          },
          {
            "name": "1.6 BlueHDI 76 2015-",
            "engineCode": "DV6"
          },
          {
            "name": "1.6 HDI 2012-",
            "engineCode": "9HF"
          },
          {
            "name": "1.6 HDI 91 2015-",
            "engineCode": "DV6"
          },
          {
            "name": "PureTech 1.6 96 2018-",
            "engineCode": "5FK"
          },
          {
            "name": "Tepee PureTech 131 2017-",
            "engineCode": "HNY"
          }
        ]
      },
      {
        "name": "Rifter",
        "types": [
          {
            "name": "BlueHDI 101 2019-",
            "engineCode": "DV5RD"
          },
          {
            "name": "BlueHDI 131 2018-",
            "engineCode": "DV5RC"
          }
        ]
      },
      {
        "name": "Traveller",
        "types": [
          {
            "name": "BlueHDI 151 2016-",
            "engineCode": "DW10FD"
          },
          {
            "name": "BlueHDI 181 2016-",
            "engineCode": "DW10FC"
          }
        ]
      }
    ]
  },
  {
    "make": "Renault",
    "models": [
      {
        "name": "Alaskan",
        "types": [
          {
            "name": "2.3 dCi 191 2018 - 2019",
            "engineCode": "M9T 260"
          },
          {
            "name": "2.3 dCi 191 2020-",
            "engineCode": "M9T"
          }
        ]
      },
      {
        "name": "Arkana",
        "types": [
          {
            "name": "E-TECH 146 2021-",
            "engineCode": "H4M"
          }
        ]
      },
      {
        "name": "Austral",
        "types": [
          {
            "name": "1.3 TCe 140 MHEV 2023-",
            "engineCode": "H5H"
          },
          {
            "name": "1.3 TCe 160 MHEV 2023-",
            "engineCode": "H5H"
          },
          {
            "name": "E-Tech 200 Hybrid 2023-",
            "engineCode": "H5F"
          }
        ]
      },
      {
        "name": "Captur",
        "types": [
          {
            "name": "0.9 TCe 91 2013-",
            "engineCode": "H4B"
          },
          {
            "name": "0.9 TCe 91 2017-",
            "engineCode": "H4B"
          },
          {
            "name": "1.0 TCe 101 2020-",
            "engineCode": "H4D"
          },
          {
            "name": "1.2 TCe 121 2013-",
            "engineCode": "H5F"
          },
          {
            "name": "1.2 TCe 121 2017-",
            "engineCode": "H5F"
          },
          {
            "name": "1.3 TCe 131 2020-",
            "engineCode": "H5H"
          },
          {
            "name": "1.3 TCe 141 2024-",
            "engineCode": "H5H"
          },
          {
            "name": "1.3 TCe 151 2019-",
            "engineCode": "H5H"
          },
          {
            "name": "1.3 TCe 156 2020-",
            "engineCode": "H5H"
          },
          {
            "name": "1.3 TCe 160 MHEV 2025-",
            "engineCode": "H5H"
          },
          {
            "name": "E-TECH 146 2021-",
            "engineCode": "H4M"
          },
          {
            "name": "E-TECH 161 2021-",
            "engineCode": "H4M"
          }
        ]
      },
      {
        "name": "Clio",
        "types": [
          {
            "name": "IV 0.9 TCe 91 2012-",
            "engineCode": "H4BT"
          },
          {
            "name": "IV 0.9 TCe 91 2017-",
            "engineCode": "H4B"
          },
          {
            "name": "IV 1.2 16V 2012-",
            "engineCode": "D4F"
          },
          {
            "name": "IV 1.2 16V 76 2016-",
            "engineCode": "D4F"
          },
          {
            "name": "IV 1.2 TCe 121 2013-",
            "engineCode": "H5F"
          },
          {
            "name": "IV 1.5 dCi 2016 - 2017",
            "engineCode": "K9K"
          },
          {
            "name": "IV 1.5 dCi 2017-",
            "engineCode": "K9K"
          },
          {
            "name": "IV 1.6 RS 201 2017-",
            "engineCode": "M5M"
          },
          {
            "name": "IV 1.6 RS 2013-",
            "engineCode": "M5M"
          },
          {
            "name": "V 1.0 SCe 76 2020-",
            "engineCode": "B4D"
          },
          {
            "name": "V 1.0 TCe 101 2020-",
            "engineCode": "H4D"
          },
          {
            "name": "V 1.3 TCe 131 2020-",
            "engineCode": "H5H"
          },
          {
            "name": "V E-TECH 141 2021-",
            "engineCode": "H4M"
          },
          {
            "name": "V E-TECH 146 2023-",
            "engineCode": "H4M"
          }
        ]
      },
      {
        "name": "Espace",
        "types": [
          {
            "name": "1.6 dCi 2015-",
            "engineCode": "R9M"
          },
          {
            "name": "VI E-Tech 200 Hybrid 2024-",
            "engineCode": "H5F"
          }
        ]
      },
      {
        "name": "Express",
        "types": [
          {
            "name": "1.5 Blue dCi 76 2021-",
            "engineCode": "K9K"
          },
          {
            "name": "1.5 Blue dCi 96 2021-",
            "engineCode": "K9K"
          }
        ]
      },
      {
        "name": "Grand",
        "types": [
          {
            "name": "Scénic 1.6 dCi 2013-",
            "engineCode": "R9M"
          }
        ]
      },
      {
        "name": "Kadjar",
        "types": [
          {
            "name": "1.2 TCe Automat/Automatic 2015-",
            "engineCode": "H5F"
          },
          {
            "name": "1.3 TCe 141 2019-",
            "engineCode": "H5H"
          },
          {
            "name": "1.3 TCe 161 2019-",
            "engineCode": "H5H"
          },
          {
            "name": "1.5 dCi 116 2019-",
            "engineCode": "K9K"
          },
          {
            "name": "1.5 dCi 2015 - 2017",
            "engineCode": "K9K"
          },
          {
            "name": "1.5 dCi 2017-",
            "engineCode": "K9K"
          },
          {
            "name": "1.6 dCi 2015-",
            "engineCode": "R9M"
          },
          {
            "name": "1.7 dCi 2019-",
            "engineCode": "R9N"
          }
        ]
      },
      {
        "name": "Kangoo",
        "types": [
          {
            "name": "1.2 TCe 116 2014-",
            "engineCode": "H5F"
          },
          {
            "name": "1.5 dCi 2017-",
            "engineCode": "K9K"
          },
          {
            "name": "III 1.3 TCe 131 2022-",
            "engineCode": "H5H"
          },
          {
            "name": "III 1.5 Blue dCi 116 2021-",
            "engineCode": "K9K"
          },
          {
            "name": "III 1.5 Blue dCi 116 2022-",
            "engineCode": "K9K"
          },
          {
            "name": "III 1.5 Blue dCi 76 2022-",
            "engineCode": "K9K"
          },
          {
            "name": "III 1.5 Blue dCi 96 2021-",
            "engineCode": "K9K"
          },
          {
            "name": "III 1.5 Blue dCi 96 2022-",
            "engineCode": "K9K"
          }
        ]
      },
      {
        "name": "Master",
        "types": [
          {
            "name": "2.3 dCi (FWD) (110 HK/HP) 2014-",
            "engineCode": "M9T"
          },
          {
            "name": "2.3 dCi (FWD) (125 HK/HP) 2014-",
            "engineCode": "M9T"
          },
          {
            "name": "2.3 dCi (FWD) (130 HK/HP) 2017-",
            "engineCode": "M9T"
          },
          {
            "name": "2.3 dCi (FWD) (135 HK/HP) 2014-",
            "engineCode": "M9T"
          },
          {
            "name": "2.3 dCi (FWD) (135 HK/HP) 2020-",
            "engineCode": "M9T"
          },
          {
            "name": "2.3 dCi (FWD) (145 HK/HP) 2016-",
            "engineCode": "M9T"
          },
          {
            "name": "2.3 dCi (FWD) (145 HK/HP) 2020-",
            "engineCode": "M9T"
          },
          {
            "name": "2.3 dCi (FWD) (150 HK/HP) 2020-",
            "engineCode": "M9T"
          },
          {
            "name": "2.3 dCi (FWD) (165 HK/HP) 2014-",
            "engineCode": "M9T"
          },
          {
            "name": "2.3 dCi (FWD) (170 HK/HP) 2016-",
            "engineCode": "M9T"
          },
          {
            "name": "2.3 dCi (FWD) (180 HK/HP) 2020-",
            "engineCode": "M9T"
          }
        ]
      },
      {
        "name": "Mégane",
        "types": [
          {
            "name": "III 1.2 Tce 111 2012-",
            "engineCode": "H5F"
          },
          {
            "name": "III 1.6 dCi 2012-",
            "engineCode": "R9M"
          },
          {
            "name": "III Sport Tourer 1.2 TCe 2012-",
            "engineCode": "H5F"
          },
          {
            "name": "III Sport Tourer 1.5 dCi 2015-",
            "engineCode": "K9K"
          },
          {
            "name": "III Sport Tourer GT 2.0 TCe 2014-",
            "engineCode": "F4R"
          },
          {
            "name": "IV 1.2 TCe 101 2016-",
            "engineCode": "H5F"
          },
          {
            "name": "IV 1.3 TCe 141 2019-",
            "engineCode": "H5H"
          },
          {
            "name": "IV 1.3 TCe 161 2019-",
            "engineCode": "H5H"
          },
          {
            "name": "IV 1.5 dCi 111 2017-",
            "engineCode": "K9K"
          },
          {
            "name": "IV 1.5 dCi 116 2020-",
            "engineCode": "K9K"
          },
          {
            "name": "IV 1.5 dCi 2016 - 2017",
            "engineCode": "K9K"
          },
          {
            "name": "IV 1.6 dCi 2016-",
            "engineCode": "R9M"
          },
          {
            "name": "IV 1.6 TCe 206 2016-",
            "engineCode": "M5M"
          },
          {
            "name": "IV E-Tech 161 2021-",
            "engineCode": "H4M"
          },
          {
            "name": "IV GT 1.6 TCe 205 EDC 2017-",
            "engineCode": "M5M"
          },
          {
            "name": "IV RS 1.8 301 2019-",
            "engineCode": "M5P"
          }
        ]
      },
      {
        "name": "Rafale",
        "types": [
          {
            "name": "E-Tech 300 4x4 PHEV 2024-",
            "engineCode": "H5F"
          }
        ]
      },
      {
        "name": "Scénic",
        "types": [
          {
            "name": "III 1.2 Tce 2012-",
            "engineCode": "H5F"
          },
          {
            "name": "III 1.5 dCi 2015-",
            "engineCode": "K9K"
          },
          {
            "name": "III 1.6 dCi 2013-",
            "engineCode": "R9M"
          },
          {
            "name": "IV 1.2 TCe 2017-",
            "engineCode": "H5F"
          },
          {
            "name": "IV 1.3 TCe 141 2018-",
            "engineCode": "H5H"
          },
          {
            "name": "IV 1.5 dCi 111 2017-",
            "engineCode": "K9K"
          },
          {
            "name": "IV 1.5 dCi 2016 - 2017",
            "engineCode": "K9K"
          }
        ]
      },
      {
        "name": "Talisman",
        "types": [
          {
            "name": "1.3 TCe 161 2019-",
            "engineCode": "H5H"
          },
          {
            "name": "1.5 dCi 2016 - 2017",
            "engineCode": "K9K"
          },
          {
            "name": "1.5 dCi 2017-",
            "engineCode": "K9K"
          },
          {
            "name": "1.6 dCi 131 2016-",
            "engineCode": "R9M"
          },
          {
            "name": "1.6 dCi 161 2016-",
            "engineCode": "R9M"
          },
          {
            "name": "1.6 TCe 151 2016-",
            "engineCode": "M5M"
          },
          {
            "name": "1.6 TCe 201 2016-",
            "engineCode": "M5M"
          },
          {
            "name": "1.7 Blue dCi 121 2019-",
            "engineCode": "R9N"
          },
          {
            "name": "1.7 Blue dCi 151 2019-",
            "engineCode": "R9N"
          },
          {
            "name": "1.8 TCe 226 2019-",
            "engineCode": "M5P"
          }
        ]
      },
      {
        "name": "Trafic",
        "types": [
          {
            "name": "III 1.6 dCi 2015-",
            "engineCode": "R9M"
          },
          {
            "name": "III 2.0 dCi 111 2022-",
            "engineCode": "M9R"
          },
          {
            "name": "III 2.0 dCi 121 2020-",
            "engineCode": "M9R"
          },
          {
            "name": "III 2.0 dCi 131 2022-",
            "engineCode": "M9R"
          },
          {
            "name": "III 2.0 dCi 146 2020-",
            "engineCode": "M9R"
          },
          {
            "name": "III 2.0 dCi 151 2022-",
            "engineCode": "M9R"
          },
          {
            "name": "III 2.0 dCi 171 2020-",
            "engineCode": "M9R"
          },
          {
            "name": "III 2.0 dCi 171 2022-",
            "engineCode": "M9R"
          }
        ]
      },
      {
        "name": "Twingo",
        "types": [
          {
            "name": "III 1.0 SCe 71 2015-",
            "engineCode": "H4DA"
          }
        ]
      }
    ]
  },
  {
    "make": "Seat",
    "models": [
      {
        "name": "Alhambra",
        "types": [
          {
            "name": "1.4 TSI 151 2013-",
            "engineCode": "CTH"
          },
          {
            "name": "1.4 TSI 151 2016-",
            "engineCode": "CZDA"
          },
          {
            "name": "1.4 TSI 151 2019-",
            "engineCode": "DJK"
          },
          {
            "name": "2.0 TDI 140 DSG 2015-",
            "engineCode": "CFF"
          },
          {
            "name": "2.0 TDI 151 (CUV) 2016-",
            "engineCode": "CUV"
          },
          {
            "name": "2.0 TDI 151 (DFLA) 2016-",
            "engineCode": "DFLA"
          },
          {
            "name": "2.0 TDI 185 (CUWA) 2016-",
            "engineCode": "CUWA"
          },
          {
            "name": "2.0 TDI 185 (DFMA) 2016-",
            "engineCode": "DFMA"
          }
        ]
      },
      {
        "name": "Arona",
        "types": [
          {
            "name": "1.0 TSI 111 2021-",
            "engineCode": "DLAA"
          },
          {
            "name": "1.0 TSI 116 (CHZJ - arona) 2018-",
            "engineCode": "CHZJ"
          },
          {
            "name": "1.0 TSI 116 2018-",
            "engineCode": "DKJA"
          },
          {
            "name": "1.0 TSI 116 2019-",
            "engineCode": "DKRF"
          },
          {
            "name": "1.0 TSI 96 2018-",
            "engineCode": "CHZ"
          },
          {
            "name": "1.0 TSI 96 2021-",
            "engineCode": "DLA"
          },
          {
            "name": "1.5 TSI 151 2018-",
            "engineCode": "DADA"
          },
          {
            "name": "1.5 TSI 151 2022-",
            "engineCode": "DXDB"
          },
          {
            "name": "1.6 TDI 96 2018-",
            "engineCode": "DGTD"
          }
        ]
      },
      {
        "name": "Ateca",
        "types": [
          {
            "name": "1.0 TSI 111 2021-",
            "engineCode": "DLAA"
          },
          {
            "name": "1.0 TSI 116 2016-",
            "engineCode": "CHZJ"
          },
          {
            "name": "1.0 TSI 116 2019-",
            "engineCode": "DKR"
          },
          {
            "name": "1.4 TSI 150 2WD 2016-",
            "engineCode": "CZEA"
          },
          {
            "name": "1.5 TSI 151 2019-",
            "engineCode": "DADA"
          },
          {
            "name": "1.5 TSI 151 2021-",
            "engineCode": "DPC"
          },
          {
            "name": "1.5 TSI 151 2023-",
            "engineCode": "DXD"
          },
          {
            "name": "1.6 TDI 111 2019-",
            "engineCode": "DGT"
          },
          {
            "name": "1.6 TDI 116 2016-",
            "engineCode": "DDYA"
          },
          {
            "name": "2.0 TDI 151 2016-",
            "engineCode": "DFFA"
          },
          {
            "name": "2.0 TDI 191 2017-",
            "engineCode": "DFH"
          },
          {
            "name": "Cupra 2.0 TSI 300 4Drive 2019-",
            "engineCode": "DNU"
          }
        ]
      },
      {
        "name": "Ibiza",
        "types": [
          {
            "name": "1.0 ECOTSI 96 2016-",
            "engineCode": "CHZB"
          },
          {
            "name": "1.0 TSI 111 2016-",
            "engineCode": "CHZC"
          },
          {
            "name": "1.0 TSI 116 (CHZJ - ibiza) 2018-",
            "engineCode": "CHZJ"
          },
          {
            "name": "1.0 TSI 96 2018-",
            "engineCode": "CHZL"
          },
          {
            "name": "1.2 TSI 111 2015-",
            "engineCode": "CJZD"
          },
          {
            "name": "1.2 TSI 91 2015-",
            "engineCode": "CJZC"
          },
          {
            "name": "1.4 ECOTSI 2016-",
            "engineCode": "CZEA"
          },
          {
            "name": "1.4 TDI 91 2016-",
            "engineCode": "CUSB"
          },
          {
            "name": "1.5 TSI 151 2018-",
            "engineCode": "DADA"
          },
          {
            "name": "1.5 TSI 151 2022-",
            "engineCode": "DXDB"
          },
          {
            "name": "V 1.0 MPI 81 (DFNA) 2019-",
            "engineCode": "DFNA"
          },
          {
            "name": "V 1.0 MPI 81 (DSGB) 2019-",
            "engineCode": "DSGB"
          },
          {
            "name": "V 1.0 MPI 81 (DSGD) 2019-",
            "engineCode": "DSGD"
          },
          {
            "name": "V 1.0 TGI 91 2018-",
            "engineCode": "DBYA"
          },
          {
            "name": "V 1.0 TSI 111 2021-",
            "engineCode": "DLA"
          },
          {
            "name": "V 1.0 TSI 116 2018-",
            "engineCode": "DKJA"
          },
          {
            "name": "V 1.0 TSI 116 2019-",
            "engineCode": "DKRF"
          },
          {
            "name": "V 1.0 TSI 96 2019-",
            "engineCode": "DKL"
          }
        ]
      },
      {
        "name": "Leon",
        "types": [
          {
            "name": "III 1.0 TSI 116 2017-",
            "engineCode": "CHZD"
          },
          {
            "name": "III 1.0 TSI 116 2019-",
            "engineCode": "DKRF"
          },
          {
            "name": "III 1.0 TSI 86 2019-",
            "engineCode": "DKLB"
          },
          {
            "name": "III 1.2 TSI 106 2013-",
            "engineCode": "CJZ"
          },
          {
            "name": "III 1.2 TSI 111 2014-",
            "engineCode": "CYV"
          },
          {
            "name": "III 1.4 TGI 2013-",
            "engineCode": "CPW"
          },
          {
            "name": "III 1.4 TSI (CMB) 2013-",
            "engineCode": "CMB"
          },
          {
            "name": "III 1.4 TSI (CPT) 2013-",
            "engineCode": "CPT"
          },
          {
            "name": "III 1.4 TSI 126 2013-",
            "engineCode": "CXS"
          },
          {
            "name": "III 1.4 TSI 126 2015-",
            "engineCode": "CZCA"
          },
          {
            "name": "III 1.4 TSI 151 2014-",
            "engineCode": "CZEA"
          },
          {
            "name": "III 1.5 TGI 131 2019-",
            "engineCode": "DHFA"
          },
          {
            "name": "III 1.5 TSI 131 2019-",
            "engineCode": "DACA"
          },
          {
            "name": "III 1.5 TSI 151 2019-",
            "engineCode": "DADA"
          },
          {
            "name": "III 1.5 TSI 151 2020-",
            "engineCode": "DPCA"
          },
          {
            "name": "III 1.6 TDI 111 (CXXB) 2016-",
            "engineCode": "CXXB"
          },
          {
            "name": "III 1.6 TDI 111 (DBKA) 2016-",
            "engineCode": "DBKA"
          },
          {
            "name": "III 1.6 TDI 111 2013-",
            "engineCode": "CRK"
          },
          {
            "name": "III 1.6 TDI 116 2019-",
            "engineCode": "DGTE"
          },
          {
            "name": "III 1.8 TFSI Automat 2013-",
            "engineCode": "CJS"
          },
          {
            "name": "III 1.8 TFSI Manuell 2013-",
            "engineCode": "CJS"
          },
          {
            "name": "III 2.0 TDI 151 2013-",
            "engineCode": "CKF"
          },
          {
            "name": "III 2.0 TDI 151 2015-",
            "engineCode": "CRMB"
          },
          {
            "name": "III 2.0 TDI 185 2013-",
            "engineCode": "CUN"
          },
          {
            "name": "III 2.0 TDI ST 185 2014-",
            "engineCode": "CUP"
          },
          {
            "name": "III Cupra 2.0 TSI 266 2014-",
            "engineCode": "CJXE"
          },
          {
            "name": "III Cupra 2.0 TSI 281 2014-",
            "engineCode": "CJXA"
          },
          {
            "name": "III Cupra 2.0 TSI 290 DSG 2019-",
            "engineCode": "DNU"
          },
          {
            "name": "III Cupra 2.0 TSI 291 2016-",
            "engineCode": "CJXH"
          },
          {
            "name": "III ST 1.6 TDI 116 2017-",
            "engineCode": "DDYA"
          },
          {
            "name": "III ST 1.8 FSI 180 Automat 2015-",
            "engineCode": "CJSB"
          },
          {
            "name": "III ST 1.8 FSI 180 Manuell 2015-",
            "engineCode": "CJSB"
          },
          {
            "name": "III ST 2.0 TDI 151 2015-",
            "engineCode": "CRLB"
          },
          {
            "name": "III ST Cupra 2.0 TSI 300 4Drive DSG 2019-",
            "engineCode": "DNU"
          },
          {
            "name": "IV 1.0 TSI 110 MHEV 2021-",
            "engineCode": "DLA"
          },
          {
            "name": "IV 1.0 TSI 111 2020-",
            "engineCode": "DLA"
          },
          {
            "name": "IV 1.0 TSI 91 2020-",
            "engineCode": "DLAB"
          },
          {
            "name": "IV 1.4 e-Hybrid 205 2021-",
            "engineCode": "DGE"
          },
          {
            "name": "IV 1.5 eTSI 117 2024-",
            "engineCode": "DXDE"
          },
          {
            "name": "IV 1.5 eTSI 151 2020-",
            "engineCode": "DFYA"
          },
          {
            "name": "IV 1.5 TSI 131 2020-",
            "engineCode": "DPB"
          },
          {
            "name": "IV 1.5 TSI 151 2024-",
            "engineCode": "DXDB"
          },
          {
            "name": "IV ST 2.0 TDI 151 2021-",
            "engineCode": "DST"
          }
        ]
      },
      {
        "name": "Mii",
        "types": [
          {
            "name": "1.0 68 Eco 2013-",
            "engineCode": "CPG"
          }
        ]
      },
      {
        "name": "Tarraco",
        "types": [
          {
            "name": "1.4 e-Hybrid 245 PHEV 2021-",
            "engineCode": "DGE"
          },
          {
            "name": "1.4 TSI 151 2019-",
            "engineCode": "CZDA"
          },
          {
            "name": "1.5 TSI 151 2019-",
            "engineCode": "DAD"
          },
          {
            "name": "2.0 TDI 151 2019-",
            "engineCode": "DFG"
          },
          {
            "name": "2.0 TDI 151 2022-",
            "engineCode": "DTS"
          },
          {
            "name": "2.0 TDI 191 2019-",
            "engineCode": "DFH"
          },
          {
            "name": "2.0 TSI 191 2019-",
            "engineCode": "DKZ"
          },
          {
            "name": "2.0 TSI 245 4Drive 2021-",
            "engineCode": "DNP"
          }
        ]
      },
      {
        "name": "Toledo",
        "types": [
          {
            "name": "1.2 TSI 106 2013-",
            "engineCode": "CBZ"
          },
          {
            "name": "1.2 TSI 111 2015-",
            "engineCode": "CJZD"
          },
          {
            "name": "1.2 TSI 91 2015-",
            "engineCode": "CJZC"
          }
        ]
      }
    ]
  },
  {
    "make": "Skoda",
    "models": [
      {
        "name": "Citigo",
        "types": [
          {
            "name": "1.0 68 Eco 2013-",
            "engineCode": "CPG"
          }
        ]
      },
      {
        "name": "Fabia",
        "types": [
          {
            "name": "III 1.0 MPI 76 2015 - 2020",
            "engineCode": "CHY"
          },
          {
            "name": "III 1.0 TSI 111 2018 - 2020",
            "engineCode": "CHZC"
          },
          {
            "name": "III 1.0 TSI 111 2019 - 2020",
            "engineCode": "DKRC"
          },
          {
            "name": "III 1.0 TSI 96 2018 - 2020",
            "engineCode": "CHZB"
          },
          {
            "name": "III 1.0 TSI 96 2019 - 2020",
            "engineCode": "DKLD"
          },
          {
            "name": "III 1.2 TSI 110 DSG 2015 - 2020",
            "engineCode": "CJZD"
          },
          {
            "name": "III 1.2 TSI 111 2015 - 2020",
            "engineCode": "CJZD"
          },
          {
            "name": "III 1.2 TSI 91 2015 - 2020",
            "engineCode": "CJZC"
          },
          {
            "name": "III 1.4 TDI 106 2015 - 2020",
            "engineCode": "CUT"
          },
          {
            "name": "III 1.4 TDI 90 DSG 2015 - 2020",
            "engineCode": "CUS"
          },
          {
            "name": "III 1.4 TDI 91 2015 - 2020",
            "engineCode": "CUS"
          },
          {
            "name": "III 1.4 TSI 2018 - 2021",
            "engineCode": "CZCA"
          },
          {
            "name": "IV 1.0 MPi 66 2022-",
            "engineCode": "DSGA"
          },
          {
            "name": "IV 1.0 MPi 81 2021-",
            "engineCode": "DSGD"
          },
          {
            "name": "IV 1.0 TSI 111 2021-",
            "engineCode": "DLAA"
          },
          {
            "name": "IV 1.0 TSI 117 2024-",
            "engineCode": "DUSA"
          },
          {
            "name": "IV 1.0 TSI 96 (DLAC) 2021-",
            "engineCode": "DLAC"
          },
          {
            "name": "IV 1.0 TSI 96 (DUSB) 2021-",
            "engineCode": "DUSB"
          },
          {
            "name": "IV 1.5 TSI 151 2021-",
            "engineCode": "DPC"
          },
          {
            "name": "IV 1.5 TSI 151 2023-",
            "engineCode": "DXDB"
          }
        ]
      },
      {
        "name": "Kamiq",
        "types": [
          {
            "name": "1.0 TGI G-TEC 91 2020-",
            "engineCode": "DBY"
          },
          {
            "name": "1.0 TSI 111 2021-",
            "engineCode": "DLAA"
          },
          {
            "name": "1.0 TSI 116 (DKJA) 2020-",
            "engineCode": "DKJA"
          },
          {
            "name": "1.0 TSI 116 (DKRF) 2020-",
            "engineCode": "DKRF"
          },
          {
            "name": "1.0 TSI 116 (DXUA) 2020-",
            "engineCode": "DXUA"
          },
          {
            "name": "1.0 TSI 117 2024-",
            "engineCode": "DUSA"
          },
          {
            "name": "1.0 TSI 96 (DKLA) 2020-",
            "engineCode": "DKLA"
          },
          {
            "name": "1.0 TSI 96 (DLAC) 2020-",
            "engineCode": "DLAC"
          },
          {
            "name": "1.0 TSI 96 (DUSB) 2020-",
            "engineCode": "DUSB"
          },
          {
            "name": "1.5 TSI 151 2020-",
            "engineCode": "DPCA"
          },
          {
            "name": "1.5 TSI 151 2024-",
            "engineCode": "DXDB"
          }
        ]
      },
      {
        "name": "Karoq",
        "types": [
          {
            "name": "1.0 TSI 111 2021-",
            "engineCode": "DLAA"
          },
          {
            "name": "1.0 TSI 116 2018-",
            "engineCode": "CHZJ"
          },
          {
            "name": "1.0 TSI 116 2019-",
            "engineCode": "DKRF"
          },
          {
            "name": "1.4 TSI 150 4x5 2020-",
            "engineCode": "CZEA"
          },
          {
            "name": "1.5 TSI 151 2018-",
            "engineCode": "DADA"
          },
          {
            "name": "1.5 TSI 151 2020-",
            "engineCode": "DPCA"
          },
          {
            "name": "1.5 TSI 151 2023-",
            "engineCode": "DXDB"
          },
          {
            "name": "1.6 TDI 116 2018-",
            "engineCode": "DDYA"
          },
          {
            "name": "1.6 TDI 116 2019-",
            "engineCode": "DGTE"
          },
          {
            "name": "2.0 TDI 150 4x5 2018-",
            "engineCode": "DFFA"
          },
          {
            "name": "2.0 TDI 150 FWD 2022-",
            "engineCode": "DTS"
          },
          {
            "name": "2.0 TDI 190 4x5 2019-",
            "engineCode": "DFHA"
          },
          {
            "name": "2.0 TDI 200 4x5 2021-",
            "engineCode": "DTUA"
          },
          {
            "name": "2.0 TSI 190 4x5 2021-",
            "engineCode": "DNN"
          }
        ]
      },
      {
        "name": "Kodiaq",
        "types": [
          {
            "name": "1.4 TSI 150 2WD 2017-",
            "engineCode": "CZE"
          },
          {
            "name": "1.4 TSI 150 4x5 2017-",
            "engineCode": "CZD"
          },
          {
            "name": "1.5 TSI 150 4x5 (DADA) 2019-",
            "engineCode": "DADA"
          },
          {
            "name": "1.5 TSI 150 4x5 (DPCA) 2019-",
            "engineCode": "DPCA"
          },
          {
            "name": "1.5 TSI 151 2019-",
            "engineCode": "DADA"
          },
          {
            "name": "1.5 TSI 151 2020-",
            "engineCode": "DPCA"
          },
          {
            "name": "2.0 TDI 150 4x5 2021-",
            "engineCode": "DTS"
          },
          {
            "name": "2.0 TDI 151 2017-",
            "engineCode": "DFGA"
          },
          {
            "name": "2.0 TDI 190 4x5 2018-",
            "engineCode": "DFHA"
          },
          {
            "name": "2.0 TDI 191 2017-",
            "engineCode": "DFHA"
          },
          {
            "name": "2.0 TDI 193 4x5 2024-",
            "engineCode": "DXN"
          },
          {
            "name": "2.0 TDI 200 4x5 2021-",
            "engineCode": "DTUA"
          },
          {
            "name": "2.0 TSI 180 4x5 2018-",
            "engineCode": "CZPA"
          },
          {
            "name": "2.0 TSI 190 4x5 2021-",
            "engineCode": "DNN"
          },
          {
            "name": "2.0 TSI 191 2020-",
            "engineCode": "DKZA"
          },
          {
            "name": "II 1.5 TSI 150 mHEV 2024-",
            "engineCode": "DXDB"
          },
          {
            "name": "RS 245 4x5 2021-",
            "engineCode": "DNPA"
          }
        ]
      },
      {
        "name": "Octavia",
        "types": [
          {
            "name": "II 1.5 TSI 151 2018 - 2019",
            "engineCode": "DADA"
          },
          {
            "name": "III 1.0 TSI 116 2015 - 2019",
            "engineCode": "CHZD"
          },
          {
            "name": "III 1.2 TSI 106 2013 - 2019",
            "engineCode": "CJZA"
          },
          {
            "name": "III 1.2 TSI 111 2016 - 2019",
            "engineCode": "CYVB"
          },
          {
            "name": "III 1.2 TSI 86 2013 - 2019",
            "engineCode": "CJZB"
          },
          {
            "name": "III 1.4 TSI 151 2015 - 2019",
            "engineCode": "CZD"
          },
          {
            "name": "III 1.4 TSI 2013 - 2019",
            "engineCode": "CHP"
          },
          {
            "name": "III 1.4 TSI G-TEC 2015 - 2019",
            "engineCode": "CPW"
          },
          {
            "name": "III 1.6 TDI 105 4X5 2014 - 2019",
            "engineCode": "CLH"
          },
          {
            "name": "III 1.6 TDI 111 (CXX) 2016 - 2019",
            "engineCode": "CXX"
          },
          {
            "name": "III 1.6 TDI 111 (DBKA) 2016 - 2019",
            "engineCode": "DBKA"
          },
          {
            "name": "III 1.6 TDI 111 2014 - 2019",
            "engineCode": "CRK"
          },
          {
            "name": "III 1.6 TDI 2013 - 2019",
            "engineCode": "CLH"
          },
          {
            "name": "III 1.8 TSI 180 Automat [without Webasto] 2013 - 2019",
            "engineCode": "CJS"
          },
          {
            "name": "III 1.8 TSI 180 DSG 4X4 [without Webasto] 2013 - 2019",
            "engineCode": "CJS"
          },
          {
            "name": "III 1.8 TSI 180 Manuell [without Webasto] 2013 - 2019",
            "engineCode": "CJS"
          },
          {
            "name": "III 1.8 TSI 181 2018 - 2019",
            "engineCode": "CJSA"
          },
          {
            "name": "III 2.0 TDI 150 4x5 2017 - 2019",
            "engineCode": "DCY"
          },
          {
            "name": "III 2.0 TDI 151 2013 - 2019",
            "engineCode": "CKF"
          },
          {
            "name": "III 2.0 TDI 151 2016 - 2019",
            "engineCode": "CRMB"
          },
          {
            "name": "III 2.0 TDI 184 4x5 2016 - 2019",
            "engineCode": "CUN"
          },
          {
            "name": "III 2.0 TDI RS 185 2013 - 2019",
            "engineCode": "CUP"
          },
          {
            "name": "III 2.0 TDI RS 185 2015 - 2019",
            "engineCode": "CUN"
          },
          {
            "name": "III 2.0 TSI 220 Automat 2015 - 2019",
            "engineCode": "CHH"
          },
          {
            "name": "III 2.0 TSI 245 RS 2017 - 2019",
            "engineCode": "DLBA"
          },
          {
            "name": "III RS 2.0 TSI 2013 - 2019",
            "engineCode": "CHH"
          },
          {
            "name": "IV 1.0 TSI 111 2021-",
            "engineCode": "DLAA"
          },
          {
            "name": "IV 1.0 TSI 116 2019-",
            "engineCode": "DKRF"
          },
          {
            "name": "IV 1.0 TSI e-TEC 111 2021-",
            "engineCode": "DLA"
          },
          {
            "name": "IV 1.4 TSI 151 2020-",
            "engineCode": "DJKA"
          },
          {
            "name": "IV 1.4 TSI iV 204 PHEV 2021-",
            "engineCode": "DGE"
          },
          {
            "name": "IV 1.4 TSI iV 245 PHEV 2021-",
            "engineCode": "DGE"
          },
          {
            "name": "IV 1.5 TSI 151 (DPCA) 2020-",
            "engineCode": "DPCA"
          },
          {
            "name": "IV 1.5 TSI 151 (DXDB) 2020-",
            "engineCode": "DXDB"
          },
          {
            "name": "IV 1.5 TSI e-TEC 117 2024-",
            "engineCode": "DXDE"
          },
          {
            "name": "IV 1.5 TSI e-TEC 151 (DFY) 2021-",
            "engineCode": "DFY"
          },
          {
            "name": "IV 1.5 TSI e-TEC 151 (DXDB) 2021-",
            "engineCode": "DXDB"
          },
          {
            "name": "IV 1.5 TSI TEC 117 2024-",
            "engineCode": "DXDE"
          },
          {
            "name": "IV 1.6 TDI 116 (DDY) 2019-",
            "engineCode": "DDY"
          },
          {
            "name": "IV 1.6 TDI 116 (DGTE) 2019-",
            "engineCode": "DGTE"
          },
          {
            "name": "IV 1.8 TSI 191 2019-",
            "engineCode": "DKZA"
          },
          {
            "name": "IV 2.0 RS 266 2024-",
            "engineCode": "DNPB"
          },
          {
            "name": "IV 2.0 TDI 116 2021-",
            "engineCode": "DSU"
          },
          {
            "name": "IV 2.0 TDI 116 2022-",
            "engineCode": "DTR"
          },
          {
            "name": "IV 2.0 TDI 151 (DST) 2021-",
            "engineCode": "DST"
          },
          {
            "name": "IV 2.0 TDI 151 (DTT) 2021-",
            "engineCode": "DTT"
          },
          {
            "name": "IV 2.0 TDI 151 2019-",
            "engineCode": "DFFA"
          },
          {
            "name": "IV 2.0 TDI RS 185 2019-",
            "engineCode": "DJGA"
          },
          {
            "name": "IV 2.0 TSI RS 246 2021-",
            "engineCode": "DNP"
          },
          {
            "name": "IV TSI 130 CNG 2019-",
            "engineCode": "DHFA"
          },
          {
            "name": "Scout 1.8 TSI 180 DSG 4x5 2015-",
            "engineCode": "CJS"
          },
          {
            "name": "Scout 2.0 TDI 151 2015-",
            "engineCode": "CRM"
          },
          {
            "name": "Scout 2.0 TDI 185 2014-",
            "engineCode": "CUN"
          },
          {
            "name": "Scout 2.0 TDI 185 2019-",
            "engineCode": "DJGA"
          }
        ]
      },
      {
        "name": "Rapid",
        "types": [
          {
            "name": "1.2 TSI 106 2013-",
            "engineCode": "CBZ"
          },
          {
            "name": "1.2 TSI 91 2016-",
            "engineCode": "CJZC"
          },
          {
            "name": "1.4 TDI 91 2016-",
            "engineCode": "CUS"
          },
          {
            "name": "1.4 TSI 123 2013-",
            "engineCode": "CAX"
          },
          {
            "name": "1.4 TSI 126 2016-",
            "engineCode": "CZC"
          },
          {
            "name": "1.6 TDI 106 2013-",
            "engineCode": "CAY"
          },
          {
            "name": "1.6 TDI 116 2016-",
            "engineCode": "CXMA"
          },
          {
            "name": "Spaceback 1.0 TSI 111 2018-",
            "engineCode": "CHZC"
          },
          {
            "name": "Spaceback 1.0 TSI 111 2019-",
            "engineCode": "DKRC"
          },
          {
            "name": "Spaceback 1.0 TSI 96 2018-",
            "engineCode": "CHZB"
          },
          {
            "name": "Spaceback 1.0 TSI 96 2019-",
            "engineCode": "DKLD"
          },
          {
            "name": "Spaceback 1.2 TSI 111 2016-",
            "engineCode": "CJZD"
          },
          {
            "name": "Spaceback 1.2 TSI 91 2016-",
            "engineCode": "CJZC"
          }
        ]
      },
      {
        "name": "Scala",
        "types": [
          {
            "name": "1.0 TGI G-TEC 91 2020-",
            "engineCode": "DBY"
          },
          {
            "name": "1.0 TSI 111 2021-",
            "engineCode": "DLAA"
          },
          {
            "name": "1.0 TSI 116 (DKJA) 2019-",
            "engineCode": "DKJA"
          },
          {
            "name": "1.0 TSI 116 (DKRF - scala) 2019-",
            "engineCode": "DKRF"
          },
          {
            "name": "1.0 TSI 116 (DXUA) 2019-",
            "engineCode": "DXUA"
          },
          {
            "name": "1.0 TSI 117 2024-",
            "engineCode": "DUSA"
          },
          {
            "name": "1.0 TSI 96 (DKLA - scala) 2019-",
            "engineCode": "DKLA"
          },
          {
            "name": "1.0 TSI 96 (DLAC) 2019-",
            "engineCode": "DLAC"
          },
          {
            "name": "1.0 TSI 96 (DUSB) 2019-",
            "engineCode": "DUSB"
          },
          {
            "name": "1.5 TSI 151 2019-",
            "engineCode": "DADA"
          },
          {
            "name": "1.5 TSI 151 2020-",
            "engineCode": "DPCA"
          },
          {
            "name": "1.5 TSI 151 2023-",
            "engineCode": "DXDB"
          }
        ]
      },
      {
        "name": "Superb",
        "types": [
          {
            "name": "II 1.6 TDI 105 (Automat) 2010 - 2015",
            "engineCode": "CAY"
          },
          {
            "name": "II 1.6 TDI 105 (Manuell) 2010 - 2015",
            "engineCode": "CAY"
          },
          {
            "name": "II 1.8 TSI 161 (BZB) 2009 - 2015",
            "engineCode": "BZB"
          },
          {
            "name": "II 1.8 TSI 161 (CDAA) 2009 - 2015",
            "engineCode": "CDAA"
          },
          {
            "name": "II 1.9 TDI (Manuell) 2009 - 2015",
            "engineCode": "BLS"
          },
          {
            "name": "II 2.0 TDI 140 (Manuell) 2009 - 2015",
            "engineCode": "BMP"
          },
          {
            "name": "II 2.0 TDI 140 (Manuell) 2010 - 2015",
            "engineCode": "CFF"
          },
          {
            "name": "II 2.0 TDI 140 DSG7 2010 - 2015",
            "engineCode": "CFF"
          },
          {
            "name": "II 2.0 TDI 170 (Automat) 2009 - 2015",
            "engineCode": "CBB"
          },
          {
            "name": "II 2.0 TDI 170 (Manuell) 2009 - 2015",
            "engineCode": "CBB"
          },
          {
            "name": "II 2.0 TDI 170 (Manuell) 2010 - 2015",
            "engineCode": "CFG"
          },
          {
            "name": "II 2.0 TDI 170 DSG7 2010 - 2015",
            "engineCode": "CFG"
          },
          {
            "name": "II 2.0 TSI 201 2011 - 2015",
            "engineCode": "CCZ"
          },
          {
            "name": "II 3.6 V6 261 2009 - 2015",
            "engineCode": "CDV"
          },
          {
            "name": "III 1.4 TSI 150 4x5 2016 - 2024",
            "engineCode": "CZDA"
          },
          {
            "name": "III 1.4 TSI 151 2016 - 2024",
            "engineCode": "CZE"
          },
          {
            "name": "III 1.4 TSI iV 218 PHEV 2020 - 2024",
            "engineCode": "DGE"
          },
          {
            "name": "III 1.5 TSI 151 2020 - 2024",
            "engineCode": "DPCA"
          },
          {
            "name": "III 1.5 TSI eTECH 151 2021 - 2024",
            "engineCode": "DFY"
          },
          {
            "name": "III 1.6 TDI 121 2016 - 2024",
            "engineCode": "DCXA"
          },
          {
            "name": "III 1.6 TDI 121 2017 - 2024",
            "engineCode": "DCZA"
          },
          {
            "name": "III 1.8 TSI 181 (CJSC) 2018 - 2024",
            "engineCode": "CJSC"
          },
          {
            "name": "III 2.0 TDI 150 4x5 2016 - 2024",
            "engineCode": "DFE"
          },
          {
            "name": "III 2.0 TDI 150 4x5 2018 - 2024",
            "engineCode": "DFEA"
          },
          {
            "name": "III 2.0 TDI 151 2016 - 2024",
            "engineCode": "CRLB"
          },
          {
            "name": "III 2.0 TDI 151 2018 - 2024",
            "engineCode": "DFGA"
          },
          {
            "name": "III 2.0 TDI 151 2020 - 2024",
            "engineCode": "DSR"
          },
          {
            "name": "III 2.0 TDI 151 2021 - 2024",
            "engineCode": "DTS"
          },
          {
            "name": "III 2.0 TDI 190 4x5 2016 - 2024",
            "engineCode": "DFC"
          },
          {
            "name": "III 2.0 TDI 190 4x5 2018 - 2024",
            "engineCode": "DFHA"
          },
          {
            "name": "III 2.0 TDI 191 (DDAA) 2016 - 2024",
            "engineCode": "DDAA"
          },
          {
            "name": "III 2.0 TDI 191 (DFC) 2016 - 2024",
            "engineCode": "DFC"
          },
          {
            "name": "III 2.0 TDI 200 4x5 2021 - 2024",
            "engineCode": "DTUA"
          },
          {
            "name": "III 2.0 TSI 191 2020 - 2024",
            "engineCode": "DKZ"
          },
          {
            "name": "III 2.0 TSI 191 2021 - 2024",
            "engineCode": "DNN"
          },
          {
            "name": "III 2.0 TSI 221 2018 - 2024",
            "engineCode": "CHHB"
          },
          {
            "name": "III 2.0 TSI 280 4X5 2018 - 2024",
            "engineCode": "CJXA"
          },
          {
            "name": "IV 1.5 TSI 150 mHEV 2024-",
            "engineCode": "DXDB"
          },
          {
            "name": "IV 1.5 TSI e-TEC 151 2024-",
            "engineCode": "DXDB"
          },
          {
            "name": "IV 2.0 TDI 193 4x5 2024-",
            "engineCode": "DXNB"
          }
        ]
      },
      {
        "name": "Yeti",
        "types": [
          {
            "name": "1.2 TSI 106 2010 - 2017",
            "engineCode": "CBZ"
          },
          {
            "name": "1.2 TSI 111 2015 - 2017",
            "engineCode": "CYVB"
          },
          {
            "name": "1.4 TSI 123 2011 - 2017",
            "engineCode": "CAX"
          },
          {
            "name": "1.4 TSI 126 2016 - 2017",
            "engineCode": "CZC"
          },
          {
            "name": "1.4 TSI 150 4x5 2016 - 2017",
            "engineCode": "CZDA"
          },
          {
            "name": "1.6 TDI 105 (Automat) 2011 - 2017",
            "engineCode": "CAY"
          },
          {
            "name": "1.6 TDI 105 (Manuell) 2011 - 2017",
            "engineCode": "CAY"
          },
          {
            "name": "1.8 TSI 161 2009 - 2017",
            "engineCode": "CDA"
          },
          {
            "name": "2.0 TDI (Automat) 2011 - 2017",
            "engineCode": "CFJ"
          },
          {
            "name": "2.0 TDI (Manuell) (CEG) 2010 - 2017",
            "engineCode": "CEG"
          },
          {
            "name": "2.0 TDI (Manuell) (CFH) 2010 - 2017",
            "engineCode": "CFH"
          },
          {
            "name": "2.0 TDI (Manuell) 2009 - 2017",
            "engineCode": "CBD"
          },
          {
            "name": "2.0 TDI (Manuell) 2011 - 2017",
            "engineCode": "CFJ"
          },
          {
            "name": "2.0 TDI 110 4x5 2016 - 2017",
            "engineCode": "CUU"
          },
          {
            "name": "2.0 TDI 111 (CUU) 2016 - 2017",
            "engineCode": "CUU"
          },
          {
            "name": "2.0 TDI 111 (DFSA) 2016 - 2017",
            "engineCode": "DFSA"
          },
          {
            "name": "2.0 TDI 150 4x5 (CUU) 2015 - 2017",
            "engineCode": "CUU"
          },
          {
            "name": "2.0 TDI 150 4x5 (DFSB) 2015 - 2017",
            "engineCode": "DFSB"
          },
          {
            "name": "2.0 TDI 151 2015 - 2017",
            "engineCode": "CUU"
          },
          {
            "name": "2.0 TDI DSG7 2010 - 2017",
            "engineCode": "CFH"
          }
        ]
      }
    ]
  },
  {
    "make": "Ssang Yong",
    "models": [
      {
        "name": "Actyon",
        "types": [
          {
            "name": "Sports 2.2 e-XDi 2017-",
            "engineCode": "D22"
          },
          {
            "name": "Sports II 2.0 Xdi 2/4WD 2012-",
            "engineCode": "D20DTR"
          }
        ]
      },
      {
        "name": "Korando",
        "types": [
          {
            "name": "2.2 Xdi 2015-",
            "engineCode": "D22T"
          },
          {
            "name": "e-Xdi 201 2014-",
            "engineCode": "D20T"
          },
          {
            "name": "e-Xdi 221 2016-",
            "engineCode": "D22T"
          }
        ]
      },
      {
        "name": "Rexton",
        "types": [
          {
            "name": "W e-XDi 201 2013-",
            "engineCode": "D20D"
          }
        ]
      },
      {
        "name": "Rodius",
        "types": [
          {
            "name": "II 2.2 e-XDi 2016-",
            "engineCode": "D22"
          }
        ]
      },
      {
        "name": "Tivoli",
        "types": [
          {
            "name": "e-XDi 161 2015-",
            "engineCode": "D16DTF"
          },
          {
            "name": "e-XGi 161 2015-",
            "engineCode": "G16X"
          }
        ]
      },
      {
        "name": "XLV",
        "types": [
          {
            "name": "e-XDi 161 2016-",
            "engineCode": "D16DTF"
          },
          {
            "name": "e-XGi 161 2016-",
            "engineCode": "G16"
          }
        ]
      }
    ]
  },
  {
    "make": "Subaru",
    "models": [
      {
        "name": "Crosstrek",
        "types": [
          {
            "name": "2.0i e-Boxer 2024-",
            "engineCode": "FB20"
          }
        ]
      },
      {
        "name": "Forester",
        "types": [
          {
            "name": "2.0 D 2013-",
            "engineCode": "EE20"
          },
          {
            "name": "2.0 XT 2014-",
            "engineCode": "FA20"
          },
          {
            "name": "2.0i e-Boxer 2020-",
            "engineCode": "FB20"
          },
          {
            "name": "2.1 2018-",
            "engineCode": "FB20"
          }
        ]
      },
      {
        "name": "Levorg",
        "types": [
          {
            "name": "1.7 2015-",
            "engineCode": "FB16DIT"
          },
          {
            "name": "1.7 2018-",
            "engineCode": "FB16DIT"
          }
        ]
      },
      {
        "name": "Outback",
        "types": [
          {
            "name": "2.0 D 2013-",
            "engineCode": "EE20"
          },
          {
            "name": "2.5i 2018-",
            "engineCode": "FB25"
          },
          {
            "name": "2.5i 2021-",
            "engineCode": "FB25"
          },
          {
            "name": "2.5i Xfuel 2021-",
            "engineCode": "FB25"
          },
          {
            "name": "2.6 2013-",
            "engineCode": "FB25"
          },
          {
            "name": "2.6 2015-",
            "engineCode": "FB25"
          }
        ]
      },
      {
        "name": "XV",
        "types": [
          {
            "name": "1.6i 2018-",
            "engineCode": "FB16"
          },
          {
            "name": "1.7 2012-",
            "engineCode": "FB16"
          },
          {
            "name": "2.0 D 2012-",
            "engineCode": "EE20Z"
          },
          {
            "name": "2.0i 2018-",
            "engineCode": "FB20"
          },
          {
            "name": "2.0i e-Boxer 2020-",
            "engineCode": "FB20"
          },
          {
            "name": "2.1 2012-",
            "engineCode": "FB20"
          }
        ]
      }
    ]
  },
  {
    "make": "Suzuki",
    "models": [
      {
        "name": "Across",
        "types": [
          {
            "name": "2.5 PHEV 4WD 2021-",
            "engineCode": "A25-FXS"
          }
        ]
      },
      {
        "name": "Ignis",
        "types": [
          {
            "name": "1.2 Dualjet 91 2016-",
            "engineCode": "K12C"
          }
        ]
      },
      {
        "name": "Jimny",
        "types": [
          {
            "name": "1.5 VVT 2019-",
            "engineCode": "K15B"
          }
        ]
      },
      {
        "name": "S-Cross",
        "types": [
          {
            "name": "1.4 T Boosterjet Hybrid 130 2022-",
            "engineCode": "K14D"
          },
          {
            "name": "1.5 Hybrid 116 Allgrip 2022-",
            "engineCode": "K15C"
          },
          {
            "name": "1.6 121 2013-",
            "engineCode": "M16A"
          },
          {
            "name": "1.6 DDiS 2013-",
            "engineCode": "D16AA"
          }
        ]
      },
      {
        "name": "SX4",
        "types": [
          {
            "name": "S-Cross 1.0 T Boosterjet 113 2016-",
            "engineCode": "K10C"
          },
          {
            "name": "S-Cross 1.4 T Boosterjet 141 2016-",
            "engineCode": "K14C"
          },
          {
            "name": "S-Cross 1.4 T Boosterjet Hybrid 130 2020-",
            "engineCode": "K14D"
          },
          {
            "name": "S-Cross 1.6 117 2013-",
            "engineCode": "M16A"
          }
        ]
      },
      {
        "name": "Swift",
        "types": [
          {
            "name": "1.0 T Boosterjet 113 2016-",
            "engineCode": "K10C"
          },
          {
            "name": "1.2 4x5 2017-",
            "engineCode": "K12C"
          },
          {
            "name": "1.6 Sport 2012-",
            "engineCode": "M16A"
          },
          {
            "name": "VI 1.2 Hybrid 2021-",
            "engineCode": "K12D"
          },
          {
            "name": "VI 1.2 Hybrid 84 2024-",
            "engineCode": "Z12E"
          },
          {
            "name": "VI 1.4 T Boosterjet Hybrid 2020-",
            "engineCode": "K14D"
          }
        ]
      },
      {
        "name": "Vitara",
        "types": [
          {
            "name": "1.0T Boosterjet 2018-",
            "engineCode": "K10C"
          },
          {
            "name": "1.4 S 2016 - 2019",
            "engineCode": "K14C"
          },
          {
            "name": "1.4 T Boosterjet Hybrid 2020-",
            "engineCode": "K14D"
          },
          {
            "name": "1.5 Hybrid 115 AllGrip 4x5 2022-",
            "engineCode": "K15C"
          },
          {
            "name": "1.6 DDIS 2015-",
            "engineCode": "D16AA"
          },
          {
            "name": "1.6 VVT 2015-",
            "engineCode": "M16A"
          }
        ]
      }
    ]
  },
  {
    "make": "Toyota",
    "models": [
      {
        "name": "Auris",
        "types": [
          {
            "name": "1.2 D4-T 2016-",
            "engineCode": "8NR"
          },
          {
            "name": "1.4 D-4D DPF 2013-",
            "engineCode": "1ND-TV"
          },
          {
            "name": "1.6 D4-D 2016-",
            "engineCode": "1WW"
          },
          {
            "name": "1.7 2013-",
            "engineCode": "1ZR-FAE"
          },
          {
            "name": "1.8 Hybrid 2013-",
            "engineCode": "2ZR-FXE"
          },
          {
            "name": "1.8 Hybrid 2016-",
            "engineCode": "2ZR-FXE"
          },
          {
            "name": "1.8 Hybrid Touring Sports 2016-",
            "engineCode": "2ZR-FXE"
          }
        ]
      },
      {
        "name": "Avensis",
        "types": [
          {
            "name": "1.6 D4-D 2015-",
            "engineCode": "1WW"
          },
          {
            "name": "2.0 D-4D 2015-",
            "engineCode": "2WW"
          }
        ]
      },
      {
        "name": "Aygo",
        "types": [
          {
            "name": "1.1 2015-",
            "engineCode": "1KR-FE"
          },
          {
            "name": "X 1.0 VVT-i 73 2022-",
            "engineCode": "1KR-FE"
          }
        ]
      },
      {
        "name": "C-HR",
        "types": [
          {
            "name": "1.2 T 2017-",
            "engineCode": "8NR"
          },
          {
            "name": "2.0 Hybrid 2020-",
            "engineCode": "M20A-FXS"
          }
        ]
      },
      {
        "name": "Corolla",
        "types": [
          {
            "name": "1.3 2019-",
            "engineCode": "8NR"
          },
          {
            "name": "1.8 140 Hybrid 2023-",
            "engineCode": "2ZR"
          },
          {
            "name": "2.0 Hybrid 2023-",
            "engineCode": "M20A"
          },
          {
            "name": "Cross 2.0 196 Hybrid 2WD 2023-",
            "engineCode": "M20A"
          },
          {
            "name": "Cross 2.0 196 Hybrid 4WD 2023-",
            "engineCode": "M20A"
          }
        ]
      },
      {
        "name": "Hilux",
        "types": [
          {
            "name": "2.4 D-4D 2016-",
            "engineCode": "2GD-FTV"
          },
          {
            "name": "2.8 D-4D 2021-",
            "engineCode": "1GD-FTV"
          },
          {
            "name": "3.0 D-4D 2012-",
            "engineCode": "1KD-FTV"
          }
        ]
      },
      {
        "name": "Landcruiser",
        "types": [
          {
            "name": "150 2.8 D-4D 2015-",
            "engineCode": "1GD-FTV"
          }
        ]
      },
      {
        "name": "Prius",
        "types": [
          {
            "name": "2.0 Plug-in Hybrid 224 2023-",
            "engineCode": "M20A-FXS"
          }
        ]
      },
      {
        "name": "Proace",
        "types": [
          {
            "name": "1.5 D 101 2020-",
            "engineCode": "5WZ-TV"
          },
          {
            "name": "1.6 D 91 2013-",
            "engineCode": "3WZ-TV"
          },
          {
            "name": "1.6 D4D (3WZ-FTV) 2016-",
            "engineCode": "3WZ-FTV"
          },
          {
            "name": "1.6 D4D (3WZ-HV) 2016-",
            "engineCode": "3WZ-HV"
          },
          {
            "name": "2.0 D 121 2016-",
            "engineCode": "4WZ-FTV"
          },
          {
            "name": "2.0 D 129 2013-",
            "engineCode": "4WZ-FTV"
          },
          {
            "name": "2.0 D 151 2016-",
            "engineCode": "4WZ-FHV"
          },
          {
            "name": "2.0 D 164 2013-",
            "engineCode": "4WZ-FHV"
          },
          {
            "name": "2.0 D4d 145 2021-",
            "engineCode": "4WZ-FTV"
          },
          {
            "name": "2.0 D4d 178 2016-",
            "engineCode": "4WZ-FHV"
          },
          {
            "name": "City 1.5 D 2020-",
            "engineCode": "DV5"
          },
          {
            "name": "City Verso 1.2 131 2020-",
            "engineCode": "2WS-HV"
          }
        ]
      },
      {
        "name": "RAV",
        "types": [
          {
            "name": "4 2.0 D-4D 2016-",
            "engineCode": "2WW"
          },
          {
            "name": "4 2.0 VVT-iE 2019-",
            "engineCode": "M20A-FKS"
          },
          {
            "name": "4 2.1 2009 - 2015",
            "engineCode": "3ZR-FAE"
          },
          {
            "name": "4 2.5 PHEV AWD-i 2020-",
            "engineCode": "A25A-FXS"
          },
          {
            "name": "4 2.5 VVT-i Hybrid 2WD/AWD 2019-",
            "engineCode": "A25A-FXS"
          },
          {
            "name": "4 Hybrid 2016-",
            "engineCode": "2AR-FXE"
          }
        ]
      },
      {
        "name": "Verso",
        "types": [
          {
            "name": "1.6 D-4D 2014-",
            "engineCode": "1WW"
          },
          {
            "name": "1.8 VVT-i 2013-",
            "engineCode": "2ZR-FAE"
          }
        ]
      },
      {
        "name": "Yaris",
        "types": [
          {
            "name": "1.0 VVT-i 2015-",
            "engineCode": "1KR-FE"
          },
          {
            "name": "1.3 VVT-i 2015-",
            "engineCode": "1NR-FE"
          },
          {
            "name": "1.5 Hybrid 117 2021-",
            "engineCode": "M15A-FXE"
          },
          {
            "name": "1.5 Hybrid 2012-",
            "engineCode": "1NZ"
          },
          {
            "name": "1.5 Hybrid 2015-",
            "engineCode": "1NZ-FXE"
          },
          {
            "name": "1.5 Hybrid 2020-",
            "engineCode": "M15A-FXE"
          },
          {
            "name": "1.6 2017-",
            "engineCode": "2NR-FKE"
          },
          {
            "name": "Cross 1.5 Hybrid 116 2WD 2021-",
            "engineCode": "M15A-FXE"
          },
          {
            "name": "Cross 1.5 Hybrid 116 AWD 2021-",
            "engineCode": "M15A-FXE"
          },
          {
            "name": "Hybrid 2021-",
            "engineCode": "M15A-FXE"
          }
        ]
      }
    ]
  },
  {
    "make": "Volkswagen",
    "models": [
      {
        "name": "Amarok",
        "types": [
          {
            "name": "2.0 TDI 180 (Manuell) 2012-",
            "engineCode": "CNE"
          },
          {
            "name": "2.0 TDI 180 4Motion 2012-",
            "engineCode": "CSH"
          },
          {
            "name": "2.0 TDI 2012-",
            "engineCode": "CNF"
          },
          {
            "name": "3.0 TDI V6 163 4Motion 2017-",
            "engineCode": "DDXA"
          },
          {
            "name": "3.0 TDI V6 204 4Motion 2017-",
            "engineCode": "DDXB"
          },
          {
            "name": "3.0 TDI V6 224 4Motion 2017-",
            "engineCode": "DDXC"
          },
          {
            "name": "3.0 TDI V6 258 4Motion 2019-",
            "engineCode": "DDXE"
          },
          {
            "name": "II 2.0 TDI 170 4Motion 2023-",
            "engineCode": "DXK"
          },
          {
            "name": "II 2.0 TDI 205 4Motion 2023-",
            "engineCode": "DXK"
          }
        ]
      },
      {
        "name": "Arteon",
        "types": [
          {
            "name": "1.4 TSI 218 PHEV 2021-",
            "engineCode": "DGE"
          },
          {
            "name": "1.5 TSI 151 2018-",
            "engineCode": "DADA"
          },
          {
            "name": "2.0 TDI 151 2017-",
            "engineCode": "DFGA"
          },
          {
            "name": "2.0 TDI 191 2018-",
            "engineCode": "DFHA"
          },
          {
            "name": "2.0 TDI 193 4Motion 2024-",
            "engineCode": "DXNB"
          },
          {
            "name": "2.0 TDI 240 GTS 2018-",
            "engineCode": "CUAA"
          },
          {
            "name": "2.0 TSI 280 GTR 4M [with Webasto] 2018-",
            "engineCode": "DJHC"
          }
        ]
      },
      {
        "name": "Beetle",
        "types": [
          {
            "name": "1.2 TSI 106 2015-",
            "engineCode": "CYVD"
          },
          {
            "name": "1.4 TSI 151 2015-",
            "engineCode": "CZD"
          },
          {
            "name": "1.4 TSI 2012-",
            "engineCode": "CAV"
          },
          {
            "name": "1.4 TSI 2013-",
            "engineCode": "CTH"
          },
          {
            "name": "2.0 TSI 220 GT 2015-",
            "engineCode": "CULC"
          },
          {
            "name": "Cab 2.0 TSI 220 GT 2016-",
            "engineCode": "CULC"
          },
          {
            "name": "Dune 1.4 TSI 151 2016-",
            "engineCode": "CZDA"
          },
          {
            "name": "Dune 2.0 TSI 220 GT 2016-",
            "engineCode": "CULC"
          },
          {
            "name": "Dune Cab 2.0 TSI 220 GT 2016-",
            "engineCode": "CULC"
          }
        ]
      },
      {
        "name": "Caddy",
        "types": [
          {
            "name": "III 1.0 TSI 103 2016-",
            "engineCode": "CHZG"
          },
          {
            "name": "III 1.0 TSI 86 2019-",
            "engineCode": "DKRD"
          },
          {
            "name": "III 1.2 TSI 85 2016-",
            "engineCode": "CYVC"
          },
          {
            "name": "III 1.4 110 CNG EU7 2016-",
            "engineCode": "CPW"
          },
          {
            "name": "III 1.4 TSI 126 (CZCA) 2016-",
            "engineCode": "CZCA"
          },
          {
            "name": "III 1.4 TSI 126 (CZCB) 2016-",
            "engineCode": "CZCB"
          },
          {
            "name": "III 1.4 TSI 131 2019-",
            "engineCode": "DJKD"
          },
          {
            "name": "III 2.0 TDI 103 (CUUD) 2016-",
            "engineCode": "CUUD"
          },
          {
            "name": "III 2.0 TDI 103 (DFSD) 2016-",
            "engineCode": "DFSD"
          },
          {
            "name": "III 2.0 TDI 123 (CUUE) 2016-",
            "engineCode": "CUUE"
          },
          {
            "name": "III 2.0 TDI 123 (DFSE) 2016-",
            "engineCode": "DFSE"
          },
          {
            "name": "III 2.0 TDI 151 2016-",
            "engineCode": "CUU"
          },
          {
            "name": "III 2.0 TDI 151 2017-",
            "engineCode": "DFSB"
          },
          {
            "name": "III 2.0 TDI 76 (CUUF) 2016-",
            "engineCode": "CUUF"
          },
          {
            "name": "III 2.0 TDI 76 (DFSF) 2016-",
            "engineCode": "DFSF"
          },
          {
            "name": "IV 1.5 TSI 115 2021-",
            "engineCode": "DPB"
          },
          {
            "name": "IV 1.5 TSI EVO 117 2024-",
            "engineCode": "DXDE"
          },
          {
            "name": "IV 2.0 TDI 103 2021-",
            "engineCode": "DTR"
          },
          {
            "name": "IV 2.0 TDI 122 4Motion 2021-",
            "engineCode": "DTRC"
          },
          {
            "name": "IV 2.0 TDI 123 2021-",
            "engineCode": "DTRC"
          },
          {
            "name": "IV 2.0 TDI 76 2021-",
            "engineCode": "DTR"
          }
        ]
      },
      {
        "name": "Caravelle",
        "types": [
          {
            "name": "T7 2.0 TDI 110 FWD 2025-",
            "engineCode": "DZJE"
          },
          {
            "name": "T7 2.0 TDI 150 4M 2025-",
            "engineCode": "DZJF"
          },
          {
            "name": "T7 2.0 TDI 150 FWD 2025-",
            "engineCode": "DZJF"
          },
          {
            "name": "T7 2.0 TDI 170 4M 2025-",
            "engineCode": "DZJA"
          },
          {
            "name": "T7 2.0 TDI 170 FWD 2025-",
            "engineCode": "DZJA"
          }
        ]
      },
      {
        "name": "Crafter",
        "types": [
          {
            "name": "2.0 TDI 164 2015-",
            "engineCode": "CSNA"
          },
          {
            "name": "II 2.0 TDI 140 FWD 2017-",
            "engineCode": "DAUA"
          },
          {
            "name": "II 2.0 TDI 177 4MOTION 2017-",
            "engineCode": "DAVA"
          },
          {
            "name": "II 2.0 TDI 177 4MOTION 2021-",
            "engineCode": "DMZ"
          },
          {
            "name": "II 2.0 TDI 177 FWD 2017-",
            "engineCode": "DAVA"
          },
          {
            "name": "II 2.0 TDI 177 FWD 2021-",
            "engineCode": "DMZ"
          }
        ]
      },
      {
        "name": "Golf",
        "types": [
          {
            "name": "Alltrack 1.8 TSI 180 DSG 2016-",
            "engineCode": "CJS"
          },
          {
            "name": "Alltrack 2.0 TDI 185 2015-",
            "engineCode": "CUN"
          },
          {
            "name": "Alltrack 2.0 TDI 185 2018-",
            "engineCode": "DGCA"
          },
          {
            "name": "Alltrack 2.0 TDI 185 2019-",
            "engineCode": "DJGA"
          },
          {
            "name": "Alltrack 2.0 TDI 200 4Motion 2021-",
            "engineCode": "DTU"
          },
          {
            "name": "Sportsvan 1.0 TSI 116 2019-",
            "engineCode": "DKRF"
          },
          {
            "name": "Sportsvan 1.2 TSI 111 2014-",
            "engineCode": "CYVB"
          },
          {
            "name": "Sportsvan 1.2 TSI 86 2014-",
            "engineCode": "CYVA"
          },
          {
            "name": "Sportsvan 1.4 TSI 126 2014-",
            "engineCode": "CZC"
          },
          {
            "name": "Sportsvan 1.4 TSI 151 2014-",
            "engineCode": "CZD"
          },
          {
            "name": "Sportsvan 1.5 TSI 131 2018-",
            "engineCode": "DAC"
          },
          {
            "name": "Sportsvan 1.5 TSI 151 2018-",
            "engineCode": "DADA"
          },
          {
            "name": "Sportsvan 1.6 TDI 111 (CRK) 2015-",
            "engineCode": "CRK"
          },
          {
            "name": "Sportsvan 1.6 TDI 111 (CXX) 2015-",
            "engineCode": "CXX"
          },
          {
            "name": "Sportsvan 1.6 TDI 111 2016-",
            "engineCode": "DBKA"
          },
          {
            "name": "Sportsvan 1.6 TDI 116 2019-",
            "engineCode": "DGTE"
          },
          {
            "name": "Sportsvan 2.0 TDI 150 GT 2015-",
            "engineCode": "CRL"
          },
          {
            "name": "Sportsvan 2.0 TDI 150 GT 2017-",
            "engineCode": "DCYA"
          },
          {
            "name": "VI 1.4 TSI PLUS (CAV) 2012-",
            "engineCode": "CAV"
          },
          {
            "name": "VI 1.4 TSI PLUS (CAX) 2012-",
            "engineCode": "CAX"
          },
          {
            "name": "VI 2.0 GTI Edition 36 2012-",
            "engineCode": "CDL"
          },
          {
            "name": "VII 1.0 TSI 111 2017-",
            "engineCode": "CHZC"
          },
          {
            "name": "VII 1.0 TSI 116 2019-",
            "engineCode": "DKRF"
          },
          {
            "name": "VII 1.2 TSI 106 2013-",
            "engineCode": "CJZA"
          },
          {
            "name": "VII 1.2 TSI 111 2014-",
            "engineCode": "CYVB"
          },
          {
            "name": "VII 1.2 TSI 86 2013-",
            "engineCode": "CJZB"
          },
          {
            "name": "VII 1.4 TGI 2013-",
            "engineCode": "CPW"
          },
          {
            "name": "VII 1.4 TSI 123 2013-",
            "engineCode": "CMB"
          },
          {
            "name": "VII 1.4 TSI 126 (CXS) 2013-",
            "engineCode": "CXS"
          },
          {
            "name": "VII 1.4 TSI 126 (CZC) 2013-",
            "engineCode": "CZC"
          },
          {
            "name": "VII 1.4 TSI 140 GT 2013-",
            "engineCode": "CHP"
          },
          {
            "name": "VII 1.4 TSI 150 GT 2018-",
            "engineCode": "CZDA"
          },
          {
            "name": "VII 1.4 TSI 151 2013-",
            "engineCode": "CZD"
          },
          {
            "name": "VII 1.4 TSI 2013-",
            "engineCode": "CPT"
          },
          {
            "name": "VII 1.5 TSI 131 2018-",
            "engineCode": "DACA"
          },
          {
            "name": "VII 1.5 TSI 151 2018-",
            "engineCode": "DADA"
          },
          {
            "name": "VII 1.6 TDI 106 2013-",
            "engineCode": "CLH"
          },
          {
            "name": "VII 1.6 TDI 111 (CXXB) 2016-",
            "engineCode": "CXXB"
          },
          {
            "name": "VII 1.6 TDI 111 (DBK) 2016-",
            "engineCode": "DBK"
          },
          {
            "name": "VII 1.6 TDI 116 2017-",
            "engineCode": "DDYA"
          },
          {
            "name": "VII 1.6 TDI 116 2019-",
            "engineCode": "DGTE"
          },
          {
            "name": "VII 1.6 TDI 2013-",
            "engineCode": "CRK"
          },
          {
            "name": "VII 2.0 GTD 185 2013-",
            "engineCode": "CUN"
          },
          {
            "name": "VII 2.0 GTD 185 2017-",
            "engineCode": "DGCA"
          },
          {
            "name": "VII 2.0 GTD 185 2019-",
            "engineCode": "DJGA"
          },
          {
            "name": "VII 2.0 GTi DSG7 2013-",
            "engineCode": "CHH"
          },
          {
            "name": "VII 2.0 TDI 151 2013-",
            "engineCode": "CRL"
          },
          {
            "name": "VII 2.0 TDI 151 2017-",
            "engineCode": "DCYA"
          },
          {
            "name": "VII 2.0 TDI 2013-",
            "engineCode": "CRB"
          },
          {
            "name": "VII 2.0 TSI 190 4M 2022-",
            "engineCode": "DNN"
          },
          {
            "name": "VII 2.0 TSI 246 2021-",
            "engineCode": "DNP"
          },
          {
            "name": "VII GTE 1.4 TSI 151 -2015",
            "engineCode": "CUK"
          },
          {
            "name": "VII GTE 1.4 TSI 151 2015-",
            "engineCode": "CUKB"
          },
          {
            "name": "VII GTI 245 DSG 2017-",
            "engineCode": "DLB"
          },
          {
            "name": "VII GTI 245 Manuell 2017-",
            "engineCode": "DLB"
          },
          {
            "name": "VII GTI Clubsport 2.0 TSI 301 2021-",
            "engineCode": "DNP"
          },
          {
            "name": "VII R 4Motion 2013-",
            "engineCode": "CJX"
          },
          {
            "name": "VII R 4Motion DSG8 2017-",
            "engineCode": "DJHA"
          },
          {
            "name": "VIII 1.0 eTSI 111 2021-",
            "engineCode": "DLAA"
          },
          {
            "name": "VIII 1.0 TSI 111 2021-",
            "engineCode": "DLAA"
          },
          {
            "name": "VIII 1.0 TSI 91 2020-",
            "engineCode": "DLAB"
          },
          {
            "name": "VIII 1.4 TSI eHybrid 205 2021-",
            "engineCode": "DGE"
          },
          {
            "name": "VIII 1.4 TSI GTE 2020-",
            "engineCode": "DGE"
          },
          {
            "name": "VIII 1.5 eTSI 117 2024-",
            "engineCode": "DXDE"
          },
          {
            "name": "VIII 1.5 eTSI 151 (DFYA) 2020-",
            "engineCode": "DFYA"
          },
          {
            "name": "VIII 1.5 eTSI 151 (DXDB) 2020-",
            "engineCode": "DXDB"
          },
          {
            "name": "VIII 1.5 TGI 131 2019-",
            "engineCode": "DHFA"
          },
          {
            "name": "VIII 1.5 TSI 117 2024-",
            "engineCode": "DXDE"
          },
          {
            "name": "VIII 1.5 TSI 131 2020-",
            "engineCode": "DPBA"
          },
          {
            "name": "VIII 1.5 TSI 151 2020-",
            "engineCode": "DPCA"
          },
          {
            "name": "VIII 2.0 TDI 116 (DSU) 2021-",
            "engineCode": "DSU"
          },
          {
            "name": "VIII 2.0 TDI 116 (DTR) 2021-",
            "engineCode": "DTR"
          },
          {
            "name": "VIII 2.0 TDI 151 2021-",
            "engineCode": "DTS"
          },
          {
            "name": "VIII 2.0 TDI 200 4M 2021-",
            "engineCode": "DTU"
          }
        ]
      },
      {
        "name": "Jetta",
        "types": [
          {
            "name": "1.2 TSI 106 2015-",
            "engineCode": "CYVD"
          },
          {
            "name": "1.4 TSI Hybrid (CNL) 2013-",
            "engineCode": "CNL"
          },
          {
            "name": "1.4 TSI Hybrid (CRJ) 2013-",
            "engineCode": "CRJ"
          }
        ]
      },
      {
        "name": "Multivan",
        "types": [
          {
            "name": "T7 1.4 TSI eHybrid 218 PHEV 2022-",
            "engineCode": "DGE"
          }
        ]
      },
      {
        "name": "Passat",
        "types": [
          {
            "name": "1.4 TSI 150 4Motion 2016-",
            "engineCode": "CZEA"
          },
          {
            "name": "1.4 TSI 151 2015-",
            "engineCode": "CZE"
          },
          {
            "name": "1.4 TSI 2012-",
            "engineCode": "CTH"
          },
          {
            "name": "1.5 eTSI 151 2024-",
            "engineCode": "DXDB"
          },
          {
            "name": "1.5 TSI 151 2019-",
            "engineCode": "DADA"
          },
          {
            "name": "1.5 TSI 151 2020-",
            "engineCode": "DPCA"
          },
          {
            "name": "1.6 TDI 121 2015-",
            "engineCode": "DCX"
          },
          {
            "name": "1.6 TDI 121 2016-",
            "engineCode": "DCZ"
          },
          {
            "name": "1.8 TSI 180 DSG 2015-",
            "engineCode": "CJS"
          },
          {
            "name": "2.0 TDI (CRLA) 2015-",
            "engineCode": "CRLA"
          },
          {
            "name": "2.0 TDI (CVS) 2015-",
            "engineCode": "CVS"
          },
          {
            "name": "2.0 TDI 151 (DFE) 2016-",
            "engineCode": "DFE"
          },
          {
            "name": "2.0 TDI 151 (DFGA) 2016-",
            "engineCode": "DFGA"
          },
          {
            "name": "2.0 TDI 151 2015-",
            "engineCode": "CRLB"
          },
          {
            "name": "2.0 TDI 151 2021-",
            "engineCode": "DSRB"
          },
          {
            "name": "2.0 TDI 191 (DDA) 2015-",
            "engineCode": "DDA"
          },
          {
            "name": "2.0 TDI 191 (DFC) 2015-",
            "engineCode": "DFC"
          },
          {
            "name": "2.0 TDI 191 2018-",
            "engineCode": "DFHA"
          },
          {
            "name": "2.0 TDI 193 4Motion 2024-",
            "engineCode": "DXNB"
          },
          {
            "name": "2.0 TDI 201 2020-",
            "engineCode": "DTU"
          },
          {
            "name": "2.0 TDI 241 2015-",
            "engineCode": "CUA"
          },
          {
            "name": "2.0 TSI GT 221 2015-",
            "engineCode": "CHHB"
          },
          {
            "name": "2.0 TSI GT 221 2016-",
            "engineCode": "CXDA"
          },
          {
            "name": "2.0 TSI GTR 281 2016-",
            "engineCode": "CJXA"
          },
          {
            "name": "Alltrack 2.0 TDI 191 2016-",
            "engineCode": "DFC"
          },
          {
            "name": "Alltrack 2.0 TDI 241 2016-",
            "engineCode": "CUA"
          },
          {
            "name": "Alltrack 2.0 TSI 190 4M 2021-",
            "engineCode": "DNF"
          },
          {
            "name": "GTE 1.4TSi 219 2020-",
            "engineCode": "DGE"
          }
        ]
      },
      {
        "name": "Polo",
        "types": [
          {
            "name": "1.0 MPI 81 (DFNA) 2019-",
            "engineCode": "DFNA"
          },
          {
            "name": "1.0 MPI 81 (DSGB) 2019-",
            "engineCode": "DSGB"
          },
          {
            "name": "1.0 MPI 81 (DSGD) 2019-",
            "engineCode": "DSGD"
          },
          {
            "name": "1.0 TGI 91 2018-",
            "engineCode": "DBYA"
          },
          {
            "name": "1.0 TSI 111 2021-",
            "engineCode": "DLA"
          },
          {
            "name": "1.0 TSI 76 2018-",
            "engineCode": "CHY"
          },
          {
            "name": "1.0 TSI 96 (DKLA - polo) 2019-",
            "engineCode": "DKLA"
          },
          {
            "name": "1.0 TSI 96 2018-",
            "engineCode": "CHZL"
          },
          {
            "name": "1.0 TSI 96 2021-",
            "engineCode": "DLA"
          },
          {
            "name": "1.1 2014-",
            "engineCode": "CHY"
          },
          {
            "name": "1.2 TSI 111 2014-",
            "engineCode": "CJZD"
          },
          {
            "name": "1.2 TSI 91 2014-",
            "engineCode": "CJZC"
          },
          {
            "name": "1.4 BlueGT 2013-",
            "engineCode": "CPT"
          },
          {
            "name": "1.4 TDI 76 2015-",
            "engineCode": "CUS"
          },
          {
            "name": "1.4 TDI 91 2015-",
            "engineCode": "CUS"
          },
          {
            "name": "1.4 TSI 2013-",
            "engineCode": "CPT"
          },
          {
            "name": "1.5 TSI 151 2019-",
            "engineCode": "DADA"
          },
          {
            "name": "1.6 TDI 96 2018-",
            "engineCode": "DGT"
          },
          {
            "name": "1.8 GTi 192 DSG 2015-",
            "engineCode": "DAJ"
          },
          {
            "name": "2.0 GTi 200 DSG 2018-",
            "engineCode": "CZPC"
          }
        ]
      },
      {
        "name": "Scirocco",
        "types": [
          {
            "name": "1.4 TSI 161 2013-",
            "engineCode": "CTH"
          },
          {
            "name": "2.0 TSI 181 2015-",
            "engineCode": "CULA"
          }
        ]
      },
      {
        "name": "Sharan",
        "types": [
          {
            "name": "1.4 TSI 151 2016-",
            "engineCode": "CZDA"
          },
          {
            "name": "1.4 TSI 151 2019-",
            "engineCode": "DJKA"
          },
          {
            "name": "1.4 TSI 2013-",
            "engineCode": "CTH"
          },
          {
            "name": "2.0 TDI 140 DSG 2015-",
            "engineCode": "CFF"
          },
          {
            "name": "2.0 TDI 151 2015-",
            "engineCode": "CUVC"
          },
          {
            "name": "2.0 TDI 151 2016-",
            "engineCode": "DFLA"
          },
          {
            "name": "2.0 TDI 178 2019-",
            "engineCode": "DLUB"
          },
          {
            "name": "2.0 TDI 185 2015-",
            "engineCode": "CUWA"
          },
          {
            "name": "2.0 TDI 185 2016-",
            "engineCode": "DFMA"
          }
        ]
      },
      {
        "name": "T-Cross",
        "types": [
          {
            "name": "1.0 TSI 111 2021-",
            "engineCode": "DLA"
          },
          {
            "name": "1.0 TSI 116 (DKRF - t-cross) 2019-",
            "engineCode": "DKRF"
          },
          {
            "name": "1.0 TSI 116 2024-",
            "engineCode": "DUS"
          },
          {
            "name": "1.0 TSI 96 (DKLA - t-cross) 2019-",
            "engineCode": "DKLA"
          },
          {
            "name": "1.5 TSI 151 (DPC) 2020-",
            "engineCode": "DPC"
          },
          {
            "name": "1.5 TSI 151 (DXDB) 2020-",
            "engineCode": "DXDB"
          },
          {
            "name": "1.6 TDI 96 2019-",
            "engineCode": "DGTD"
          }
        ]
      },
      {
        "name": "T-Roc",
        "types": [
          {
            "name": "1.0 TSI 111 2021-",
            "engineCode": "DLAA"
          },
          {
            "name": "1.0 TSI 116 2018-",
            "engineCode": "CHZJ"
          },
          {
            "name": "1.0 TSI 116 2019-",
            "engineCode": "DKRF"
          },
          {
            "name": "1.5 eTSI 151 2023-",
            "engineCode": "DXDB"
          },
          {
            "name": "1.5 TSI 151 2018-",
            "engineCode": "DADA"
          },
          {
            "name": "1.5 TSI 151 2020-",
            "engineCode": "DPCA"
          },
          {
            "name": "1.5 TSI 151 2023-",
            "engineCode": "DXDB"
          },
          {
            "name": "2.0 TDI 151 2018-",
            "engineCode": "DFFA"
          },
          {
            "name": "2.0 TDI 151 2021-",
            "engineCode": "DTT"
          },
          {
            "name": "2.0 TDI 191 2020-",
            "engineCode": "DFHA"
          },
          {
            "name": "2.0 TSI 190 4M 2018-",
            "engineCode": "DNNA"
          },
          {
            "name": "2.0 TSI 300 4M 2019-",
            "engineCode": "DNU"
          },
          {
            "name": "2.0 TSI GT 190 4M 2018-",
            "engineCode": "CZPB"
          }
        ]
      },
      {
        "name": "Taigo",
        "types": [
          {
            "name": "1.0 TSI 111 2022-",
            "engineCode": "DLAA"
          },
          {
            "name": "1.0 TSI 71 2022-",
            "engineCode": "DUSB"
          },
          {
            "name": "1.0 TSI 96 2022-",
            "engineCode": "DLAC"
          },
          {
            "name": "1.5 TSI 151 2022-",
            "engineCode": "DPCA"
          },
          {
            "name": "1.5 TSI 151 2023-",
            "engineCode": "DXDB"
          }
        ]
      },
      {
        "name": "Tayron",
        "types": [
          {
            "name": "2.0 TDI 193 4Motion 2025-",
            "engineCode": "DXNB"
          }
        ]
      },
      {
        "name": "Tiguan",
        "types": [
          {
            "name": "1.4 TSI 2012-",
            "engineCode": "CAX"
          },
          {
            "name": "1.4 TSI 4WD 2013-",
            "engineCode": "CTH"
          },
          {
            "name": "1.4 TSI eHybrid 245 PHEV 2021-",
            "engineCode": "DGE"
          },
          {
            "name": "1.5 TSI 131 2018-",
            "engineCode": "DACB"
          },
          {
            "name": "1.5 TSI 131 2021-",
            "engineCode": "DPBE"
          },
          {
            "name": "1.5 TSI 151 2021-",
            "engineCode": "DPC"
          },
          {
            "name": "1.5 TSI 151 2023-",
            "engineCode": "DXDB"
          },
          {
            "name": "1.5 TSI e151 2023-",
            "engineCode": "DXDB"
          },
          {
            "name": "2.0 TDI 150 4Motion 2021-",
            "engineCode": "DTS"
          },
          {
            "name": "2.0 TDI 151 (CUVC) 2016-",
            "engineCode": "CUVC"
          },
          {
            "name": "2.0 TDI 151 (DFGA - tiguan) 2016-",
            "engineCode": "DFGA"
          },
          {
            "name": "2.0 TDI 185 2015-",
            "engineCode": "CUWA"
          },
          {
            "name": "2.0 TDI 191 2016-",
            "engineCode": "DFHA"
          },
          {
            "name": "2.0 TDI 193 4Motion 2024-",
            "engineCode": "DXN"
          },
          {
            "name": "2.0 TDI 200 4Motion 2021-",
            "engineCode": "DTU"
          },
          {
            "name": "2.0 TSI 180 4Motion 2018-",
            "engineCode": "CZPA"
          },
          {
            "name": "2.0 TSI 190 4M 2022-",
            "engineCode": "DNN"
          },
          {
            "name": "2.0 TSI 220 4Motion 2018-",
            "engineCode": "CHHB"
          },
          {
            "name": "2.0 TSI 320 4M 2022-",
            "engineCode": "DNF"
          },
          {
            "name": "Allspace 2.0 TDI 150 DSG7 4Motion 2018-",
            "engineCode": "DFGA"
          },
          {
            "name": "Allspace 2.0 TDI 150 Manuell 2018-",
            "engineCode": "DFGA"
          },
          {
            "name": "Allspace 2.0 TDI 190 DSG7 4Motion 2018-",
            "engineCode": "DFHA"
          },
          {
            "name": "Allspace 2.0 TDI 240 DSG7 4Motion 2018-",
            "engineCode": "CUAA"
          },
          {
            "name": "Allspace 2.0 TSI 180 4Motion 2018-",
            "engineCode": "CZPA"
          },
          {
            "name": "Allspace 2.0 TSI 190 DSG 4Motion 2020-",
            "engineCode": "DNLA"
          },
          {
            "name": "Allspace 2.0 TSI GT 220 4Motion 2018-",
            "engineCode": "CHHA"
          },
          {
            "name": "GTS TDI 241 2018-",
            "engineCode": "CUAA"
          }
        ]
      },
      {
        "name": "Touareg",
        "types": [
          {
            "name": "3.0 TDI V6 205 2012-",
            "engineCode": "CJM"
          },
          {
            "name": "3.0 TDI V6 205 2016-",
            "engineCode": "CVW"
          },
          {
            "name": "3.0 TDI V6 246 2012-",
            "engineCode": "CRC"
          },
          {
            "name": "3.0 TDI V6 263 2015-",
            "engineCode": "CVV"
          },
          {
            "name": "3.0 TDI V6 287 2018-",
            "engineCode": "DENA"
          },
          {
            "name": "3.0 TSI V6 341 2019-",
            "engineCode": "DCBE"
          },
          {
            "name": "R eHybrid 462 4M 2021-",
            "engineCode": "DCBE"
          }
        ]
      },
      {
        "name": "Touran",
        "types": [
          {
            "name": "1.2 TSI 111 2016-",
            "engineCode": "CYVB"
          },
          {
            "name": "1.4 TSI 151 2016-",
            "engineCode": "CZD"
          },
          {
            "name": "1.4 TSI 2013-",
            "engineCode": "CTH"
          },
          {
            "name": "1.5 TSI 151 2019-",
            "engineCode": "DADA"
          },
          {
            "name": "1.5 TSI 151 2020-",
            "engineCode": "DPCA"
          },
          {
            "name": "1.5 TSI 151 2022-",
            "engineCode": "DXDB"
          },
          {
            "name": "1.6 TDI 111 2016-",
            "engineCode": "CRKB"
          },
          {
            "name": "1.6 TDI 116 2017-",
            "engineCode": "DGDA"
          },
          {
            "name": "2.0 TDI 151 2015-",
            "engineCode": "DFEA"
          },
          {
            "name": "2.0 TDI 151 2017-",
            "engineCode": "DFGA"
          },
          {
            "name": "2.0 TDI 191 2015-",
            "engineCode": "DFHA"
          }
        ]
      },
      {
        "name": "Transporter",
        "types": [
          {
            "name": "Multivan T6 2.0 TDI 103 2016-",
            "engineCode": "CXGB"
          },
          {
            "name": "Multivan T6 2.0 TDI 151 (CXF) 2016-",
            "engineCode": "CXF"
          },
          {
            "name": "Multivan T6 2.0 TDI 151 (CXH) 2016-",
            "engineCode": "CXH"
          },
          {
            "name": "Multivan T6 2.0 TDI 181 2016-",
            "engineCode": "CFC"
          },
          {
            "name": "Multivan T6 2.0 TDI 205 2016-",
            "engineCode": "CXE"
          },
          {
            "name": "Multivan T6 2.0 TDI 85 2016-",
            "engineCode": "CXGA"
          },
          {
            "name": "Multivan T6 2.0 TSI 151 2016-",
            "engineCode": "CJKB"
          },
          {
            "name": "Multivan T6 2.0 TSI 205 2016-",
            "engineCode": "CJKA"
          },
          {
            "name": "T6 2.0 TDI 103 (CAAB) 2016-",
            "engineCode": "CAAB"
          },
          {
            "name": "T6 2.0 TDI 103 (CXGB) 2016-",
            "engineCode": "CXGB"
          },
          {
            "name": "T6 2.0 TDI 141 2016-",
            "engineCode": "CAAC"
          },
          {
            "name": "T6 2.0 TDI 151 (CXF) 2016-",
            "engineCode": "CXF"
          },
          {
            "name": "T6 2.0 TDI 151 (CXH) 2016-",
            "engineCode": "CXH"
          },
          {
            "name": "T6 2.0 TDI 181 2016-",
            "engineCode": "CFC"
          },
          {
            "name": "T6 2.0 TDI 205 2016-",
            "engineCode": "CXE"
          },
          {
            "name": "T6 2.0 TDI 85 (CAAA) 2016-",
            "engineCode": "CAAA"
          },
          {
            "name": "T6 2.0 TDI 85 (CXGA) 2016-",
            "engineCode": "CXGA"
          },
          {
            "name": "T6 2.0 TSI 151 2015-",
            "engineCode": "CJKB"
          },
          {
            "name": "T6 2.0 TSI 205 2015-",
            "engineCode": "CJKA"
          },
          {
            "name": "T6.1 2.0 TDI 111 2022-",
            "engineCode": "DNA"
          },
          {
            "name": "T6.1 2.0 TDI 150 4M 2020-",
            "engineCode": "CXH"
          },
          {
            "name": "T6.1 2.0 TDI 151 2020-",
            "engineCode": "CXH"
          },
          {
            "name": "T6.1 2.0 TDI 151 2022-",
            "engineCode": "DNA"
          },
          {
            "name": "T6.1 2.0 TDI 205 2022-",
            "engineCode": "DMZ"
          },
          {
            "name": "T7 2.0 TDI 110 FWD 2025-",
            "engineCode": "DZJE"
          },
          {
            "name": "T7 2.0 TDI 150 4M 2025-",
            "engineCode": "DZJF"
          },
          {
            "name": "T7 2.0 TDI 150 FWD 2025-",
            "engineCode": "DZJF"
          },
          {
            "name": "T7 2.0 TDI 170 4M 2025-",
            "engineCode": "DZJA"
          },
          {
            "name": "T7 2.0 TDI 170 FWD 2025-",
            "engineCode": "DZJA"
          }
        ]
      }
    ]
  },
  {
    "make": "Volvo",
    "models": [
      {
        "name": "S60",
        "types": [
          {
            "name": "II D3 2016-",
            "engineCode": "D4204T8"
          },
          {
            "name": "II D4 (Automat) 2014-",
            "engineCode": "D4204T5"
          },
          {
            "name": "II D4 (Manuell) 2014-",
            "engineCode": "D4204T5"
          },
          {
            "name": "II D4 2016-",
            "engineCode": "D4204T9"
          },
          {
            "name": "II D5 2015 - 2018",
            "engineCode": "D5244T21"
          },
          {
            "name": "II D5 2016-",
            "engineCode": "D4204T14"
          },
          {
            "name": "II T4 2016-",
            "engineCode": "B4204T37"
          },
          {
            "name": "II T5 [med bränslevärmare] 2014-",
            "engineCode": "B4204T11"
          },
          {
            "name": "II T5 2016-",
            "engineCode": "B4204T19"
          },
          {
            "name": "II T5 2019-",
            "engineCode": "B4204T31"
          },
          {
            "name": "III B3 Mildhybrid (B420T3) 2020 - 2023",
            "engineCode": "B420T3"
          },
          {
            "name": "III B3 Mildhybrid (B420T4) 2020 - 2023",
            "engineCode": "B420T4"
          },
          {
            "name": "III B4 Mildhybrid (B420T5) 2020-",
            "engineCode": "B420T5"
          },
          {
            "name": "III B4 Mildhybrid (B420T6) 2020-",
            "engineCode": "B420T6"
          },
          {
            "name": "III B5 Mildhybrid 2020-",
            "engineCode": "B420T2"
          },
          {
            "name": "III B5 Mildhybrid AWD 2020-",
            "engineCode": "B420T2"
          },
          {
            "name": "III T6 2019-",
            "engineCode": "B4204T26"
          },
          {
            "name": "III T6 AWD 2018-",
            "engineCode": "B4204T29"
          },
          {
            "name": "III T6 AWD Recharge 2019-",
            "engineCode": "B4204T46"
          },
          {
            "name": "III T6 AWD Recharge 2022-",
            "engineCode": "B4204T52"
          },
          {
            "name": "III T8 AWD Recharge 2020-",
            "engineCode": "B4204T53"
          },
          {
            "name": "III T8 AWD Recharge 2022-",
            "engineCode": "B4204T56"
          }
        ]
      },
      {
        "name": "S80",
        "types": [
          {
            "name": "II D4 (Automat) 2014-",
            "engineCode": "D4204T5"
          },
          {
            "name": "II D4 (Manuell) 2014-",
            "engineCode": "D4204T5"
          },
          {
            "name": "II D4 2012-",
            "engineCode": "D5204T3"
          }
        ]
      },
      {
        "name": "S90",
        "types": [
          {
            "name": "II B4 Mildhybrid 2020-",
            "engineCode": "B420T6"
          },
          {
            "name": "II B5 Mildhybrid 2020-",
            "engineCode": "B420T2"
          },
          {
            "name": "II B5 Mildhybrid 2022-",
            "engineCode": "B420T10"
          },
          {
            "name": "II D4 2016-",
            "engineCode": "D4204T9"
          },
          {
            "name": "II D5 2017-",
            "engineCode": "D4204T14"
          },
          {
            "name": "II D5 AWD 2017-",
            "engineCode": "D4204T23"
          },
          {
            "name": "II D6 2017-",
            "engineCode": "D4204T23"
          },
          {
            "name": "II T6 AWD Recharge 2019-",
            "engineCode": "B4204T46"
          },
          {
            "name": "II T8 AWD Recharge (B4204T53) 2022-",
            "engineCode": "B4204T53"
          },
          {
            "name": "II T8 AWD Recharge (B4204T56) 2022-",
            "engineCode": "B4204T56"
          },
          {
            "name": "II T8 AWD Recharge (B4204T57) 2022-",
            "engineCode": "B4204T57"
          },
          {
            "name": "II T8 AWD Recharge 2020-",
            "engineCode": "B4204T53"
          }
        ]
      },
      {
        "name": "V40",
        "types": [
          {
            "name": "II D3 2012-",
            "engineCode": "D4162T"
          },
          {
            "name": "II D3 2016-",
            "engineCode": "D4204T8"
          },
          {
            "name": "II D4 2012-",
            "engineCode": "D5204T6"
          },
          {
            "name": "II D4 2016-",
            "engineCode": "D4204T9"
          },
          {
            "name": "II D5 2012-",
            "engineCode": "D5204T4"
          },
          {
            "name": "II D5 2015-",
            "engineCode": "D4204T14"
          },
          {
            "name": "II T3 2013-",
            "engineCode": "B4164T4"
          },
          {
            "name": "II T3 2016-",
            "engineCode": "B4204T38"
          },
          {
            "name": "II T4 (B4154T4) 2015-",
            "engineCode": "B4154T4"
          },
          {
            "name": "II T4 (B4204T37) 2015-",
            "engineCode": "B4204T37"
          },
          {
            "name": "II T4 2012-",
            "engineCode": "B4164T3"
          },
          {
            "name": "II T5 2012-",
            "engineCode": "B4164T"
          }
        ]
      },
      {
        "name": "V60",
        "types": [
          {
            "name": "D3 2016-",
            "engineCode": "D4204T8/T20"
          },
          {
            "name": "D3 Cross Country 2016-",
            "engineCode": "D4204T4"
          },
          {
            "name": "D4 (Automat) 2014-",
            "engineCode": "D4204T5"
          },
          {
            "name": "D4 (Manuell) 2014-",
            "engineCode": "D4204T5"
          },
          {
            "name": "D4 2013-",
            "engineCode": "D5204T7"
          },
          {
            "name": "D4 2016-",
            "engineCode": "D4204T9"
          },
          {
            "name": "D4 Cross Country 2016-",
            "engineCode": "D4204T14"
          },
          {
            "name": "D5 2016-",
            "engineCode": "D4204T14"
          },
          {
            "name": "II B3 Mildhybrid 2021 - 2023",
            "engineCode": "B420T4"
          },
          {
            "name": "II B4 Cross Country AWD 2021 - 2024",
            "engineCode": "D420T8"
          },
          {
            "name": "II B4 Mildhybrid (B420T5) 2021-",
            "engineCode": "B420T5"
          },
          {
            "name": "II B4 Mildhybrid (B420T6) 2021-",
            "engineCode": "B420T6"
          },
          {
            "name": "II B5 2021 - 2024",
            "engineCode": "D420T8"
          },
          {
            "name": "II B5 Cross Country Mildhybrid AWD 2021-",
            "engineCode": "B420T2"
          },
          {
            "name": "II B5 Mildhybrid 2020-",
            "engineCode": "B420T2"
          },
          {
            "name": "II B5 Mildhybrid AWD 2021-",
            "engineCode": "B420T2"
          },
          {
            "name": "II D3 AWD 2019-",
            "engineCode": "D4204T4"
          },
          {
            "name": "II D4 2019-",
            "engineCode": "D4204T4"
          },
          {
            "name": "II D4 AWD 2019-",
            "engineCode": "D4204T9"
          },
          {
            "name": "II D4 Cross Country AWD 2019-",
            "engineCode": "D4204T14"
          },
          {
            "name": "II D5 2019-",
            "engineCode": "D4204T9"
          },
          {
            "name": "II T5 2016-",
            "engineCode": "B4204T19"
          },
          {
            "name": "II T5 2019-",
            "engineCode": "B4204T31"
          },
          {
            "name": "II T6 2019-",
            "engineCode": "B4204T26"
          },
          {
            "name": "II T6 AWD Recharge 2022-",
            "engineCode": "B4204T52"
          },
          {
            "name": "III T8 AWD Recharge 2022-",
            "engineCode": "B4204T56"
          },
          {
            "name": "III T8 AWD Recharge 2023-",
            "engineCode": "B4204T53"
          },
          {
            "name": "T4 2015-",
            "engineCode": "B4154T4"
          },
          {
            "name": "T4 2016-",
            "engineCode": "B4204T37"
          },
          {
            "name": "T5 [med bränslevärmare] 2014-",
            "engineCode": "B4204T11"
          }
        ]
      },
      {
        "name": "V70",
        "types": [
          {
            "name": "III D4 (Automat) 2014-",
            "engineCode": "D4204T5"
          },
          {
            "name": "III D4 (Manuell) 2014-",
            "engineCode": "D4204T5"
          },
          {
            "name": "III D4 2012-",
            "engineCode": "D5204T3"
          },
          {
            "name": "III D4 2016-",
            "engineCode": "D4204T9"
          }
        ]
      },
      {
        "name": "V90",
        "types": [
          {
            "name": "II B4 AWD 2021 - 2024",
            "engineCode": "D420T8"
          },
          {
            "name": "II B4 Cross Country AWD 2021 - 2023",
            "engineCode": "D420T8"
          },
          {
            "name": "II B4 Mildhybrid 2020-",
            "engineCode": "B420T6"
          },
          {
            "name": "II B5 Mildhybrid 2020-",
            "engineCode": "B420T2"
          },
          {
            "name": "II Cross Country B5 Mildhybrid AWD 2020-",
            "engineCode": "B420T2"
          },
          {
            "name": "II D3 AWD 2017-",
            "engineCode": "D4204T4"
          },
          {
            "name": "II D4 2017-",
            "engineCode": "D4204T9"
          },
          {
            "name": "II D4 AWD 2017-",
            "engineCode": "D4204T14"
          },
          {
            "name": "II D4 Cross Country 2017-",
            "engineCode": "D4204T14"
          },
          {
            "name": "II D5 2017-",
            "engineCode": "D4204T14"
          },
          {
            "name": "II D5 AWD 2017-",
            "engineCode": "D4204T23"
          },
          {
            "name": "II D5 Cross Country 2017-",
            "engineCode": "D4204T23"
          },
          {
            "name": "II D6 2017-",
            "engineCode": "D4204T23"
          },
          {
            "name": "II T5 2018-",
            "engineCode": "B4204T31"
          },
          {
            "name": "II T5 Cross Country 2017-",
            "engineCode": "B4204T23"
          },
          {
            "name": "II T5 Cross Country AWD 2018-",
            "engineCode": "B4204T26"
          },
          {
            "name": "II T6 2017-",
            "engineCode": "B4204T23"
          },
          {
            "name": "II T6 AWD Recharge 2020-",
            "engineCode": "B4204T46"
          },
          {
            "name": "II T6 AWD Recharge 2022-",
            "engineCode": "B4204T52"
          },
          {
            "name": "II T6 Cross Country 2017-",
            "engineCode": "B4204T27"
          },
          {
            "name": "II T6 Cross Country AWD 2018-",
            "engineCode": "B4204T29"
          },
          {
            "name": "II T7 2017-",
            "engineCode": "B4204T27"
          },
          {
            "name": "II T8 AWD Recharge (B4204T56) 2023-",
            "engineCode": "B4204T56"
          },
          {
            "name": "II T8 AWD Recharge (B4204T57) 2023-",
            "engineCode": "B4204T57"
          }
        ]
      },
      {
        "name": "XC40",
        "types": [
          {
            "name": "B3 Mildhybrid 2022-",
            "engineCode": "B420T4"
          },
          {
            "name": "B4 Mildhybrid 2021-",
            "engineCode": "B420T5/T6"
          },
          {
            "name": "B4 Mildhybrid AWD (B420T5) 2020-",
            "engineCode": "B420T5"
          },
          {
            "name": "B4 Mildhybrid AWD (B420T6) 2020-",
            "engineCode": "B420T6"
          },
          {
            "name": "B5 Mildhybrid AWD 2021 - 2023",
            "engineCode": "B420T10"
          },
          {
            "name": "B5 Mildhybrid AWD 2021-",
            "engineCode": "B420T2"
          },
          {
            "name": "D3 AWD 2018-",
            "engineCode": "D4204T16"
          },
          {
            "name": "D4 AWD 2018-",
            "engineCode": "D4204T12"
          },
          {
            "name": "T3 2019-",
            "engineCode": "B3154T9"
          },
          {
            "name": "T4 / T4 AWD 2018-",
            "engineCode": "B4204T47"
          },
          {
            "name": "T4 2018-",
            "engineCode": "B3154T"
          }
        ]
      },
      {
        "name": "XC60",
        "types": [
          {
            "name": "D4 2012-",
            "engineCode": "D5204T7"
          },
          {
            "name": "D4 2016-",
            "engineCode": "D4204T4"
          }
        ]
      }
    ]
  }
];
